//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class TemplatesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    uploadTemplate(templateType: string | undefined, commitChanges: boolean | undefined, commitChangesWithWarning: boolean | undefined, isDefault: boolean | undefined, file: FileParameter | undefined, signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/api/templates?";
        if (templateType === null)
            throw new globalThis.Error("The parameter 'templateType' cannot be null.");
        else if (templateType !== undefined)
            url_ += "templateType=" + encodeURIComponent("" + templateType) + "&";
        if (commitChanges === null)
            throw new globalThis.Error("The parameter 'commitChanges' cannot be null.");
        else if (commitChanges !== undefined)
            url_ += "commitChanges=" + encodeURIComponent("" + commitChanges) + "&";
        if (commitChangesWithWarning === null)
            throw new globalThis.Error("The parameter 'commitChangesWithWarning' cannot be null.");
        else if (commitChangesWithWarning !== undefined)
            url_ += "commitChangesWithWarning=" + encodeURIComponent("" + commitChangesWithWarning) + "&";
        if (isDefault === null)
            throw new globalThis.Error("The parameter 'isDefault' cannot be null.");
        else if (isDefault !== undefined)
            url_ += "isDefault=" + encodeURIComponent("" + isDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadTemplate(_response);
        });
    }

    protected processUploadTemplate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<any>(result200);

        } else if (status === 415) {
            const _responseText = response.data;
            let result415: any = null;
            let resultData415  = _responseText;
            result415 = ProblemDetails.fromJS(resultData415);
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class SustainabilityJobClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    syncSustainabilityData(signal?: AbortSignal): Promise<SustainabilitySyncResponse> {
        let url_ = this.baseUrl + "/api/sustainability";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncSustainabilityData(_response);
        });
    }

    protected processSyncSustainabilityData(response: AxiosResponse): Promise<SustainabilitySyncResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = SustainabilitySyncResponse.fromJS(resultData202);
            return Promise.resolve<SustainabilitySyncResponse>(result202);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = SustainabilitySyncResponse.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SustainabilitySyncResponse>(null as any);
    }
}

export class ProjectsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDashboardProjectsByUserId(signal?: AbortSignal): Promise<DashboardProject[]> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDashboardProjectsByUserId(_response);
        });
    }

    protected processGetDashboardProjectsByUserId(response: AxiosResponse): Promise<DashboardProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DashboardProject[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardProject[]>(null as any);
    }

    createProject(createProjectRequest: CreateProjectRequest, signal?: AbortSignal): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createProjectRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectResponse.fromJS(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    upsertProjectModels(projectId: string, upsertModels: UpsertModel[] | undefined, signal?: AbortSignal): Promise<Model[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/models";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(upsertModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertProjectModels(_response);
        });
    }

    protected processUpsertProjectModels(response: AxiosResponse): Promise<Model[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Model.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Model[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Model[]>(null as any);
    }

    getModels(projectId: string, signal?: AbortSignal): Promise<Model[]> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/models";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModels(_response);
        });
    }

    protected processGetModels(response: AxiosResponse): Promise<Model[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Model.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Model[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Model[]>(null as any);
    }

    getProject(projectId: string, signal?: AbortSignal): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/dashboard";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProject(_response);
        });
    }

    protected processGetProject(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectResponse.fromJS(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    uploadProjectImage(projectId: string, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/image";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadProjectImage(_response);
        });
    }

    protected processUploadProjectImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectImage(projectId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/image";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectImage(_response);
        });
    }

    protected processGetProjectImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteProject(projectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateProjectSettings(updateProjectRequest: UpdateProjectRequest, signal?: AbortSignal): Promise<ProjectResponse> {
        let url_ = this.baseUrl + "/api/projects/update-project-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProjectRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProjectSettings(_response);
        });
    }

    protected processUpdateProjectSettings(response: AxiosResponse): Promise<ProjectResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectResponse.fromJS(resultData200);
            return Promise.resolve<ProjectResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectResponse>(null as any);
    }

    updateApsProjectId(projectId: string, apsProjectDataRequest: ApsProjectDataRequest, signal?: AbortSignal): Promise<Project> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/aps-project-id";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apsProjectDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateApsProjectId(_response);
        });
    }

    protected processUpdateApsProjectId(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }
}

export class ScenariosClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createScenario(createScenarioRequest: CreateScenarioRequest, signal?: AbortSignal): Promise<Scenario> {
        let url_ = this.baseUrl + "/api/scenarios";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createScenarioRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateScenario(_response);
        });
    }

    protected processCreateScenario(response: AxiosResponse): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Scenario.fromJS(resultData200);
            return Promise.resolve<Scenario>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Scenario>(null as any);
    }

    getScenarios(projectId: string | undefined, signal?: AbortSignal): Promise<Scenario[]> {
        let url_ = this.baseUrl + "/api/scenarios?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarios(_response);
        });
    }

    protected processGetScenarios(response: AxiosResponse): Promise<Scenario[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Scenario.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Scenario[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Scenario[]>(null as any);
    }

    getScenarioByID(scenarioId: string, signal?: AbortSignal): Promise<Scenario> {
        let url_ = this.baseUrl + "/api/scenarios/getscenariobyID/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScenarioByID(_response);
        });
    }

    protected processGetScenarioByID(response: AxiosResponse): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Scenario.fromJS(resultData200);
            return Promise.resolve<Scenario>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Scenario>(null as any);
    }

    updateScenarioSettings(updateScenarioRequest: UpdateScenarioRequest, signal?: AbortSignal): Promise<Scenario> {
        let url_ = this.baseUrl + "/api/scenarios/update-scenario-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateScenarioRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateScenarioSettings(_response);
        });
    }

    protected processUpdateScenarioSettings(response: AxiosResponse): Promise<Scenario> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Scenario.fromJS(resultData200);
            return Promise.resolve<Scenario>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Scenario>(null as any);
    }

    setFinalScenario(scenarioId: string, enableFinal: boolean | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}/commands/set-final-scenario?";
        if (scenarioId === undefined || scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (enableFinal === null)
            throw new globalThis.Error("The parameter 'enableFinal' cannot be null.");
        else if (enableFinal !== undefined)
            url_ += "enableFinal=" + encodeURIComponent("" + enableFinal) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetFinalScenario(_response);
        });
    }

    protected processSetFinalScenario(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    deleteScenario(scenarioId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScenario(_response);
        });
    }

    protected processDeleteScenario(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cloneScenario(scenarioId: string, scenarioCloneRequest: CloneScenarioRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{scenario-id}/commands/clone-scenario";
        if (scenarioId === undefined || scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenario-id}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scenarioCloneRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneScenario(_response);
        });
    }

    protected processCloneScenario(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyModelMaterials(modelId: string, copyModelMaterialRequest: CopyModelMaterialRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/scenarios/{model-id}/commands/copy-model-materials";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{model-id}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(copyModelMaterialRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyModelMaterials(_response);
        });
    }

    protected processCopyModelMaterials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DesignAutomationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createProjectJobs(projectId: string, signal?: AbortSignal): Promise<Project> {
        let url_ = this.baseUrl + "/api/design-automations/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProjectJobs(_response);
        });
    }

    protected processCreateProjectJobs(response: AxiosResponse): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Project.fromJS(resultData200);
            return Promise.resolve<Project>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Project>(null as any);
    }

    getPluginsHistory(signal?: AbortSignal): Promise<PluginHistory[]> {
        let url_ = this.baseUrl + "/api/design-automations/plugins-history";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPluginsHistory(_response);
        });
    }

    protected processGetPluginsHistory(response: AxiosResponse): Promise<PluginHistory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PluginHistory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PluginHistory[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PluginHistory[]>(null as any);
    }

    registerPlugins(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/design-automations/commands/register-plugins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterPlugins(_response);
        });
    }

    protected processRegisterPlugins(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPlugins(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/design-automations/commands/reset-plugins";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPlugins(_response);
        });
    }

    protected processResetPlugins(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createSignedUrl(objectKey: string | undefined, signal?: AbortSignal): Promise<CreateObjectSigned> {
        let url_ = this.baseUrl + "/api/design-automations/signed-upload?";
        if (objectKey === null)
            throw new globalThis.Error("The parameter 'objectKey' cannot be null.");
        else if (objectKey !== undefined)
            url_ += "objectKey=" + encodeURIComponent("" + objectKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSignedUrl(_response);
        });
    }

    protected processCreateSignedUrl(response: AxiosResponse): Promise<CreateObjectSigned> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateObjectSigned.fromJS(resultData200);
            return Promise.resolve<CreateObjectSigned>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateObjectSigned>(null as any);
    }

    reportProgress(progressUpdate: ProgressUpdate, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/design-automations/progress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(progressUpdate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportProgress(_response);
        });
    }

    protected processReportProgress(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ModelCommandsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Asynchronously Get All Commands by Specific command name
     * @param commandType (optional) name/type of commands to be retrieved
     * @return List of commands matching the given command
     */
    getModelCommands(commandType: string | undefined, signal?: AbortSignal): Promise<ModelCommandResponse[]> {
        let url_ = this.baseUrl + "/api/models/commands?";
        if (commandType === null)
            throw new globalThis.Error("The parameter 'commandType' cannot be null.");
        else if (commandType !== undefined)
            url_ += "commandType=" + encodeURIComponent("" + commandType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelCommands(_response);
        });
    }

    protected processGetModelCommands(response: AxiosResponse): Promise<ModelCommandResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelCommandResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ModelCommandResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelCommandResponse[]>(null as any);
    }

    /**
     * Asynchronously creates a new ModelCommand Entry in Database
     * @param createCommandRequest Create ModelCommand Request Object
     * @return New command
     */
    createModelCommand(createCommandRequest: CreateModelCommandRequest, signal?: AbortSignal): Promise<ModelCommandResponse> {
        let url_ = this.baseUrl + "/api/models/commands";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCommandRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModelCommand(_response);
        });
    }

    protected processCreateModelCommand(response: AxiosResponse): Promise<ModelCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelCommandResponse.fromJS(resultData200);
            return Promise.resolve<ModelCommandResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelCommandResponse>(null as any);
    }

    /**
     * Asychronoushly Get ModelCommand by commandId
     * @param commandId commandId
     * @return command object matching the given commandId
     */
    getModelCommand(commandId: string, signal?: AbortSignal): Promise<ModelCommandResponse> {
        let url_ = this.baseUrl + "/api/models/commands/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new globalThis.Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelCommand(_response);
        });
    }

    protected processGetModelCommand(response: AxiosResponse): Promise<ModelCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelCommandResponse.fromJS(resultData200);
            return Promise.resolve<ModelCommandResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelCommandResponse>(null as any);
    }

    /**
     * Update a ModelCommand Object
     * @return ModelCommand Obect with updated value
     */
    updateModelCommand(commandId: string, updateCommandRequest: UpdateModelCommandRequest, signal?: AbortSignal): Promise<ModelCommandResponse> {
        let url_ = this.baseUrl + "/api/models/commands/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new globalThis.Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCommandRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModelCommand(_response);
        });
    }

    protected processUpdateModelCommand(response: AxiosResponse): Promise<ModelCommandResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelCommandResponse.fromJS(resultData200);
            return Promise.resolve<ModelCommandResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelCommandResponse>(null as any);
    }

    /**
     * Asynchronously Deletes a ModelCommand record
     * @param commandId commandId of the command to be deleted
     */
    deleteModelCommand(commandId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/commands/{commandId}";
        if (commandId === undefined || commandId === null)
            throw new globalThis.Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModelCommand(_response);
        });
    }

    protected processDeleteModelCommand(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ModelsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getModel(modelId: string, signal?: AbortSignal): Promise<Model> {
        let url_ = this.baseUrl + "/api/models/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModel(_response);
        });
    }

    protected processGetModel(response: AxiosResponse): Promise<Model> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Model.fromJS(resultData200);
            return Promise.resolve<Model>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Model>(null as any);
    }

    updateModel(modelId: string, upsertModel: UpsertModel, signal?: AbortSignal): Promise<Model> {
        let url_ = this.baseUrl + "/api/models/{modelId}";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(upsertModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModel(_response);
        });
    }

    protected processUpdateModel(response: AxiosResponse): Promise<Model> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Model.fromJS(resultData200);
            return Promise.resolve<Model>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Model>(null as any);
    }

    getModelCategories(modelId: string, scenarioId: string | null | undefined, signal?: AbortSignal): Promise<Category[]> {
        let url_ = this.baseUrl + "/api/models/{modelId}/categories?";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelCategories(_response);
        });
    }

    protected processGetModelCategories(response: AxiosResponse): Promise<Category[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Category.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Category[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Category[]>(null as any);
    }

    getProjectModel(modelId: string, signal?: AbortSignal): Promise<ProjectModelDto> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/project-model";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectModel(_response);
        });
    }

    protected processGetProjectModel(response: AxiosResponse): Promise<ProjectModelDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectModelDto.fromJS(resultData200);
            return Promise.resolve<ProjectModelDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectModelDto>(null as any);
    }

    getModelElements(modelId: string, scenarioId: string | undefined, signal?: AbortSignal): Promise<Element[]> {
        let url_ = this.baseUrl + "/api/models/{modelId}/elements?";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelElements(_response);
        });
    }

    protected processGetModelElements(response: AxiosResponse): Promise<Element[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Element.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Element[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Element[]>(null as any);
    }

    getModelScopes(modelId: string, signal?: AbortSignal): Promise<ModelScopesResponse> {
        let url_ = this.baseUrl + "/api/models/{modelId}/scopes";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelScopes(_response);
        });
    }

    protected processGetModelScopes(response: AxiosResponse): Promise<ModelScopesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopesResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopesResponse>(null as any);
    }

    getModelComponents(modelId: string, scenarioId: string | undefined, signal?: AbortSignal): Promise<Element[]> {
        let url_ = this.baseUrl + "/api/models/{modelId}/components?";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelComponents(_response);
        });
    }

    protected processGetModelComponents(response: AxiosResponse): Promise<Element[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Element.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Element[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Element[]>(null as any);
    }

    getModelExtendedData(modelId: string, scenarioId: string | null | undefined, signal?: AbortSignal): Promise<{ [key: string]: { [key: string]: any; }; }> {
        let url_ = this.baseUrl + "/api/models/{modelId}/extended-data?";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelExtendedData(_response);
        });
    }

    protected processGetModelExtendedData(response: AxiosResponse): Promise<{ [key: string]: { [key: string]: any; }; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : {};
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key: string]: { [key: string]: any; }; }>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: { [key: string]: any; }; }>(null as any);
    }

    getModelMaterials(modelId: string, scenarioId: string | undefined, signal?: AbortSignal): Promise<Material2[]> {
        let url_ = this.baseUrl + "/api/models/{modelId}/materials?";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        if (scenarioId === null)
            throw new globalThis.Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelMaterials(_response);
        });
    }

    protected processGetModelMaterials(response: AxiosResponse): Promise<Material2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Material2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Material2[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Material2[]>(null as any);
    }

    assignMaterials(modelId: string, assignMaterialsRequest: AssignMaterialsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-materials";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignMaterialsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignMaterials(_response);
        });
    }

    protected processAssignMaterials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    autoAssignMaterials(modelId: string, autoAssignMaterialsRequest: AutoAssignMaterialsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/auto-assign-materials";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(autoAssignMaterialsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAutoAssignMaterials(_response);
        });
    }

    protected processAutoAssignMaterials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignRebarEstimationEdits(modelId: string, assignRebarEstimationEditsRequest: AssignRebarEstimationEditsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-rebar-estimation-edits";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRebarEstimationEditsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignRebarEstimationEdits(_response);
        });
    }

    protected processAssignRebarEstimationEdits(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignRebarEstimations(modelId: string, assignRebarEstimationsRequest: AssignRebarEstimationsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-rebar-estimations";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignRebarEstimationsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignRebarEstimations(_response);
        });
    }

    protected processAssignRebarEstimations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignNonModelledElementsEdits(modelId: string, assignNonModelledElementsEditsRequest: AssignNonModelledElementsEditsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-non-modelled-elements-edits";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignNonModelledElementsEditsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignNonModelledElementsEdits(_response);
        });
    }

    protected processAssignNonModelledElementsEdits(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignNonModelledElements(modelId: string, assignNonModelledElementsRequest: AssignNonModelledElementsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-non-modelled-elements";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignNonModelledElementsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignNonModelledElements(_response);
        });
    }

    protected processAssignNonModelledElements(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    assignScopes(modelId: string, assignScopesRequest: AssignScopesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/assign-scopes";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignScopesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignScopes(_response);
        });
    }

    protected processAssignScopes(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeMaterials(modelId: string, removeMaterialsRequest: RemoveMaterialsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/remove-materials";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeMaterialsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveMaterials(_response);
        });
    }

    protected processRemoveMaterials(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeSupplementals(modelId: string, removeSupplementalsRequest: RemoveSupplementalsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/remove-supplementals";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(removeSupplementalsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSupplementals(_response);
        });
    }

    protected processRemoveSupplementals(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadModelImage(modelId: string, file: FileParameter | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/commands/upload-image";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadModelImage(_response);
        });
    }

    protected processUploadModelImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getModelImage(modelId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/models/{modelId}/image";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelImage(_response);
        });
    }

    protected processGetModelImage(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    splitModel(modelSplitRequest: ModelSplitRequest, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/models/commands/split-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(modelSplitRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSplitModel(_response);
        });
    }

    protected processSplitModel(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    createModelVersion(request: CreateModelVersionRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/commands/create-version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModelVersion(_response);
        });
    }

    protected processCreateModelVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteModel(request: DeleteModelRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/commands/delete-model";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModel(_response);
        });
    }

    protected processDeleteModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getModelUsageInfo(modelId: string, signal?: AbortSignal): Promise<ModelUsageInfo> {
        let url_ = this.baseUrl + "/api/models/{modelId}/usage-info";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelUsageInfo(_response);
        });
    }

    protected processGetModelUsageInfo(response: AxiosResponse): Promise<ModelUsageInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelUsageInfo.fromJS(resultData200);
            return Promise.resolve<ModelUsageInfo>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelUsageInfo>(null as any);
    }

    /**
     * Retrieves a list of available model families.
    Model families are used to categorize models for filtering and selection purposes.
    Returns a list of family names as strings.
     */
    getModelFamilies(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/models/families";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelFamilies(_response);
        });
    }

    protected processGetModelFamilies(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getModelTypes(signal?: AbortSignal): Promise<ModelTypeDto[]> {
        let url_ = this.baseUrl + "/api/models/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelTypes(_response);
        });
    }

    protected processGetModelTypes(response: AxiosResponse): Promise<ModelTypeDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModelTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ModelTypeDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelTypeDto[]>(null as any);
    }

    updateModelVersion(modelId: string, request: UpdateModelVersionRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/models/{modelId}/update-version";
        if (modelId === undefined || modelId === null)
            throw new globalThis.Error("The parameter 'modelId' must be defined.");
        url_ = url_.replace("{modelId}", encodeURIComponent("" + modelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModelVersion(_response);
        });
    }

    protected processUpdateModelVersion(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NodeHierarchyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Retrieve all Nodes from Node Hierarchy
     */
    get(signal?: AbortSignal): Promise<NodeHierarchyDto[]> {
        let url_ = this.baseUrl + "/api/nodehierarchy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NodeHierarchyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NodeHierarchyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NodeHierarchyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NodeHierarchyDto[]>(null as any);
    }
}

export class EtlJobsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getImportModelEtlJobs(importModelEtlJobsRequest: ImportModelEtlJobsRequest, signal?: AbortSignal): Promise<EtlJob[]> {
        let url_ = this.baseUrl + "/api/etl-jobs/import-models";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(importModelEtlJobsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImportModelEtlJobs(_response);
        });
    }

    protected processGetImportModelEtlJobs(response: AxiosResponse): Promise<EtlJob[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EtlJob.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EtlJob[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EtlJob[]>(null as any);
    }
}

export class JobsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getJobs(jobsRequest: JobsRequest, signal?: AbortSignal): Promise<Job[]> {
        let url_ = this.baseUrl + "/api/jobs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(jobsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobs(_response);
        });
    }

    protected processGetJobs(response: AxiosResponse): Promise<Job[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Job.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Job[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Job[]>(null as any);
    }
}

export class AuthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    signInGET(rememberMe: boolean | undefined, redirectUrl: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/signin?";
        if (rememberMe === null)
            throw new globalThis.Error("The parameter 'rememberMe' cannot be null.");
        else if (rememberMe !== undefined)
            url_ += "rememberMe=" + encodeURIComponent("" + rememberMe) + "&";
        if (redirectUrl === null)
            throw new globalThis.Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignInGET(_response);
        });
    }

    protected processSignInGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signInPOST(rememberMe: boolean | undefined, redirectUrl: string | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/signin?";
        if (rememberMe === null)
            throw new globalThis.Error("The parameter 'rememberMe' cannot be null.");
        else if (rememberMe !== undefined)
            url_ += "rememberMe=" + encodeURIComponent("" + rememberMe) + "&";
        if (redirectUrl === null)
            throw new globalThis.Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignInPOST(_response);
        });
    }

    protected processSignInPOST(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signOutCurrentUserGET(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignOutCurrentUserGET(_response);
        });
    }

    protected processSignOutCurrentUserGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    signOutCurrentUserPOST(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/auth/signout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignOutCurrentUserPOST(_response);
        });
    }

    protected processSignOutCurrentUserPOST(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    logout(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    callback(code: string | undefined, state: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/signin-autodesk?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallback(_response);
        });
    }

    protected processCallback(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    callback2(code: string | undefined, state: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/auth/callback?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCallback2(_response);
        });
    }

    protected processCallback2(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserProfile(signal?: AbortSignal): Promise<UserProfileResult> {
        let url_ = this.baseUrl + "/api/auth/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<UserProfileResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileResult.fromJS(resultData200);
            return Promise.resolve<UserProfileResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileResult>(null as any);
    }

    getUserProfile2(signal?: AbortSignal): Promise<UserProfileResult> {
        let url_ = this.baseUrl + "/api/auth/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile2(_response);
        });
    }

    protected processGetUserProfile2(response: AxiosResponse): Promise<UserProfileResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileResult.fromJS(resultData200);
            return Promise.resolve<UserProfileResult>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileResult>(null as any);
    }

    createViewToken(signal?: AbortSignal): Promise<Token> {
        let url_ = this.baseUrl + "/api/auth/viewtoken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateViewToken(_response);
        });
    }

    protected processCreateViewToken(response: AxiosResponse): Promise<Token> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Token.fromJS(resultData200);
            return Promise.resolve<Token>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Token>(null as any);
    }
}

export class PermissionsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getPermissions(signal?: AbortSignal): Promise<PermissionsResponse> {
        let url_ = this.baseUrl + "/api/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPermissions(_response);
        });
    }

    protected processGetPermissions(response: AxiosResponse): Promise<PermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PermissionsResponse.fromJS(resultData200);
            return Promise.resolve<PermissionsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PermissionsResponse>(null as any);
    }

    deletePermission(permissionId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/permissions/{permissionId}";
        if (permissionId === undefined || permissionId === null)
            throw new globalThis.Error("The parameter 'permissionId' must be defined.");
        url_ = url_.replace("{permissionId}", encodeURIComponent("" + permissionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePermission(_response);
        });
    }

    protected processDeletePermission(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResourceUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createResourceUser(createResourceRequest: CreateResourceUserRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/resource-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateResourceUser(_response);
        });
    }

    protected processCreateResourceUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteResourceUser(deleteResourceRequest: DeleteResourceUserRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/resource-users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteResourceRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteResourceUser(_response);
        });
    }

    protected processDeleteResourceUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getResourceUsers(resourceId: string | undefined, isFromApsUser: boolean | undefined, signal?: AbortSignal): Promise<ApplicationUser[]> {
        let url_ = this.baseUrl + "/api/resource-users?";
        if (resourceId === null)
            throw new globalThis.Error("The parameter 'resourceId' cannot be null.");
        else if (resourceId !== undefined)
            url_ += "resourceId=" + encodeURIComponent("" + resourceId) + "&";
        if (isFromApsUser === null)
            throw new globalThis.Error("The parameter 'isFromApsUser' cannot be null.");
        else if (isFromApsUser !== undefined)
            url_ += "IsFromApsUser=" + encodeURIComponent("" + isFromApsUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetResourceUsers(_response);
        });
    }

    protected processGetResourceUsers(response: AxiosResponse): Promise<ApplicationUser[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationUser.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApplicationUser[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationUser[]>(null as any);
    }
}

export class RolesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRoles(signal?: AbortSignal): Promise<RolesResponse> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: AxiosResponse): Promise<RolesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RolesResponse.fromJS(resultData200);
            return Promise.resolve<RolesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RolesResponse>(null as any);
    }

    createRole(createRoleRequest: CreateRoleRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRoleRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateUserRoles(userId: string, updateUserRoles: UpdateUserRolesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateUserRoles);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserRoles(_response);
        });
    }

    protected processUpdateUserRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRolePermissions(roleId: string, signal?: AbortSignal): Promise<RolePermissionsResponse> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRolePermissions(_response);
        });
    }

    protected processGetRolePermissions(response: AxiosResponse): Promise<RolePermissionsResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RolePermissionsResponse.fromJS(resultData200);
            return Promise.resolve<RolePermissionsResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RolePermissionsResponse>(null as any);
    }

    updateRolePermissions(roleId: string, updateRolePermissions: UpdateRolePermissionsRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{roleId}/permissions";
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRolePermissions);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRolePermissions(_response);
        });
    }

    protected processUpdateRolePermissions(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRole(roleName: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/{roleName}";
        if (roleName === undefined || roleName === null)
            throw new globalThis.Error("The parameter 'roleName' must be defined.");
        url_ = url_.replace("{roleName}", encodeURIComponent("" + roleName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getExternalRoles(signal?: AbortSignal): Promise<ExternalRolesResponse> {
        let url_ = this.baseUrl + "/api/roles/external";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalRoles(_response);
        });
    }

    protected processGetExternalRoles(response: AxiosResponse): Promise<ExternalRolesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalRolesResponse.fromJS(resultData200);
            return Promise.resolve<ExternalRolesResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalRolesResponse>(null as any);
    }

    createExternalRole(createExternalRoleRequest: CreateExternalRoleRequest, signal?: AbortSignal): Promise<ExternalRoleResponse> {
        let url_ = this.baseUrl + "/api/roles/external";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createExternalRoleRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateExternalRole(_response);
        });
    }

    protected processCreateExternalRole(response: AxiosResponse): Promise<ExternalRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalRoleResponse.fromJS(resultData200);
            return Promise.resolve<ExternalRoleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalRoleResponse>(null as any);
    }

    getExternalRole(externalRoleId: string, signal?: AbortSignal): Promise<ExternalRoleResponse> {
        let url_ = this.baseUrl + "/api/roles/external/{externalRoleId}";
        if (externalRoleId === undefined || externalRoleId === null)
            throw new globalThis.Error("The parameter 'externalRoleId' must be defined.");
        url_ = url_.replace("{externalRoleId}", encodeURIComponent("" + externalRoleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternalRole(_response);
        });
    }

    protected processGetExternalRole(response: AxiosResponse): Promise<ExternalRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalRoleResponse.fromJS(resultData200);
            return Promise.resolve<ExternalRoleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalRoleResponse>(null as any);
    }

    updateExternalRole(externalRoleId: string, updateExternalRoleRequest: UpdateExternalRoleRequest, signal?: AbortSignal): Promise<ExternalRoleResponse> {
        let url_ = this.baseUrl + "/api/roles/external/{externalRoleId}";
        if (externalRoleId === undefined || externalRoleId === null)
            throw new globalThis.Error("The parameter 'externalRoleId' must be defined.");
        url_ = url_.replace("{externalRoleId}", encodeURIComponent("" + externalRoleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateExternalRoleRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateExternalRole(_response);
        });
    }

    protected processUpdateExternalRole(response: AxiosResponse): Promise<ExternalRoleResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExternalRoleResponse.fromJS(resultData200);
            return Promise.resolve<ExternalRoleResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExternalRoleResponse>(null as any);
    }

    deleteExternalRole(externalRoleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/roles/external/{externalRoleId}";
        if (externalRoleId === undefined || externalRoleId === null)
            throw new globalThis.Error("The parameter 'externalRoleId' must be defined.");
        url_ = url_.replace("{externalRoleId}", encodeURIComponent("" + externalRoleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteExternalRole(_response);
        });
    }

    protected processDeleteExternalRole(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createUser(createUserRequest: CreateUserRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createUserRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUsers(role: string | null | undefined, signal?: AbortSignal): Promise<ApplicationUserResponse[]> {
        let url_ = this.baseUrl + "/api/users?";
        if (role !== undefined && role !== null)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<ApplicationUserResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationUserResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApplicationUserResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationUserResponse[]>(null as any);
    }

    getUser(userId: string, signal?: AbortSignal): Promise<ApplicationUserResponse> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<ApplicationUserResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationUserResponse.fromJS(resultData200);
            return Promise.resolve<ApplicationUserResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationUserResponse>(null as any);
    }

    deleteUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUserPermissions(userId: string, signal?: AbortSignal): Promise<Claim[]> {
        let url_ = this.baseUrl + "/api/users/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserPermissions(_response);
        });
    }

    protected processGetUserPermissions(response: AxiosResponse): Promise<Claim[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Claim.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Claim[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Claim[]>(null as any);
    }

    deleteUserRoles(deleteUserRolesRequest: DeleteUserRolesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/users/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteUserRolesRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUserRoles(_response);
        });
    }

    protected processDeleteUserRoles(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BenchmarkCatalogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Returns all benchmark catalog summaries (name + id) for use in project dropdowns.
     */
    getAllSummaries(signal?: AbortSignal): Promise<BenchmarkCatalogSummaryDto[]> {
        let url_ = this.baseUrl + "/api/benchmark-catalogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllSummaries(_response);
        });
    }

    protected processGetAllSummaries(response: AxiosResponse): Promise<BenchmarkCatalogSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BenchmarkCatalogSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<BenchmarkCatalogSummaryDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BenchmarkCatalogSummaryDto[]>(null as any);
    }

    /**
     * Creates a new benchmark catalog with its value rows.
     */
    create(request: BenchmarkCatalogCreateRequest, signal?: AbortSignal): Promise<BenchmarkCatalogDto> {
        let url_ = this.baseUrl + "/api/benchmark-catalogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<BenchmarkCatalogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BenchmarkCatalogDto.fromJS(resultData201);
            return Promise.resolve<BenchmarkCatalogDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BenchmarkCatalogDto>(null as any);
    }

    /**
     * Returns a single catalog with all value rows (including [NEW] gaps for recently added model types).
     */
    getById(id: string, signal?: AbortSignal): Promise<BenchmarkCatalogDto> {
        let url_ = this.baseUrl + "/api/benchmark-catalogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<BenchmarkCatalogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BenchmarkCatalogDto.fromJS(resultData200);
            return Promise.resolve<BenchmarkCatalogDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BenchmarkCatalogDto>(null as any);
    }

    /**
     * Updates catalog name, description, and merges value rows.
    Existing rows are updated; new scope rows are inserted; removed scope rows are deleted.
     */
    update(id: string, request: BenchmarkCatalogUpdateRequest, signal?: AbortSignal): Promise<BenchmarkCatalogDto> {
        let url_ = this.baseUrl + "/api/benchmark-catalogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<BenchmarkCatalogDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BenchmarkCatalogDto.fromJS(resultData200);
            return Promise.resolve<BenchmarkCatalogDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BenchmarkCatalogDto>(null as any);
    }

    /**
     * Deletes a catalog and all its value children.
    Returns 400 if any project is still linked to this catalog.
     */
    delete(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/benchmark-catalogs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns the benchmark values (from linked catalog) and target values (from ProjectTargets)
    for a given project. Used by the Results page to render reference line overlays.
     */
    getBenchmarkAndTargetsForProject(projectId: string, signal?: AbortSignal): Promise<ProjectBenchmarkAndTargetsDto> {
        let url_ = this.baseUrl + "/api/projects/{projectId}/benchmark-and-targets";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBenchmarkAndTargetsForProject(_response);
        });
    }

    protected processGetBenchmarkAndTargetsForProject(response: AxiosResponse): Promise<ProjectBenchmarkAndTargetsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectBenchmarkAndTargetsDto.fromJS(resultData200);
            return Promise.resolve<ProjectBenchmarkAndTargetsDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectBenchmarkAndTargetsDto>(null as any);
    }
}

export class CadMaterialsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCadMaterials(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/cad-materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCadMaterials(_response);
        });
    }

    protected processGetCadMaterials(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class CadModelCategoriesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCadModelCategories(signal?: AbortSignal): Promise<CadModelCategory2[]> {
        let url_ = this.baseUrl + "/api/cad-model-categories";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCadModelCategories(_response);
        });
    }

    protected processGetCadModelCategories(response: AxiosResponse): Promise<CadModelCategory2[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CadModelCategory2.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CadModelCategory2[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CadModelCategory2[]>(null as any);
    }
}

export class Co2MaterialTypesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMaterialTypes(materialLibraryIds: string[] | null | undefined, showArchived: boolean | undefined, signal?: AbortSignal): Promise<Co2MaterialType[]> {
        let url_ = this.baseUrl + "/api/co2-material-types?";
        if (materialLibraryIds !== undefined && materialLibraryIds !== null)
            materialLibraryIds && materialLibraryIds.forEach(item => { url_ += "materialLibraryIds=" + encodeURIComponent("" + item) + "&"; });
        if (showArchived === null)
            throw new globalThis.Error("The parameter 'showArchived' cannot be null.");
        else if (showArchived !== undefined)
            url_ += "showArchived=" + encodeURIComponent("" + showArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialTypes(_response);
        });
    }

    protected processGetMaterialTypes(response: AxiosResponse): Promise<Co2MaterialType[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Co2MaterialType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Co2MaterialType[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Co2MaterialType[]>(null as any);
    }

    upsertMaterialTypes(upsertCo2MaterialTypeRequest: UpsertCo2MaterialTypeRequest[], signal?: AbortSignal): Promise<UpsertCo2MaterialTypeResponse> {
        let url_ = this.baseUrl + "/api/co2-material-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(upsertCo2MaterialTypeRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertMaterialTypes(_response);
        });
    }

    protected processUpsertMaterialTypes(response: AxiosResponse): Promise<UpsertCo2MaterialTypeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpsertCo2MaterialTypeResponse.fromJS(resultData200);
            return Promise.resolve<UpsertCo2MaterialTypeResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpsertCo2MaterialTypeResponse>(null as any);
    }

    getMaterialTypeOptions(materialLibraryIds: string[] | null | undefined, showArchived: boolean | undefined, signal?: AbortSignal): Promise<Co2MaterialTypeOptions> {
        let url_ = this.baseUrl + "/api/co2-material-types/options?";
        if (materialLibraryIds !== undefined && materialLibraryIds !== null)
            materialLibraryIds && materialLibraryIds.forEach(item => { url_ += "materialLibraryIds=" + encodeURIComponent("" + item) + "&"; });
        if (showArchived === null)
            throw new globalThis.Error("The parameter 'showArchived' cannot be null.");
        else if (showArchived !== undefined)
            url_ += "showArchived=" + encodeURIComponent("" + showArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialTypeOptions(_response);
        });
    }

    protected processGetMaterialTypeOptions(response: AxiosResponse): Promise<Co2MaterialTypeOptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Co2MaterialTypeOptions.fromJS(resultData200);
            return Promise.resolve<Co2MaterialTypeOptions>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Co2MaterialTypeOptions>(null as any);
    }

    deleteMaterialType(co2MaterialTypeId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/co2-material-types/{co2MaterialTypeId}";
        if (co2MaterialTypeId === undefined || co2MaterialTypeId === null)
            throw new globalThis.Error("The parameter 'co2MaterialTypeId' must be defined.");
        url_ = url_.replace("{co2MaterialTypeId}", encodeURIComponent("" + co2MaterialTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMaterialType(_response);
        });
    }

    protected processDeleteMaterialType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    co2MaterialTypeByCategory(signal?: AbortSignal): Promise<Co2MaterialTypeByCategory[]> {
        let url_ = this.baseUrl + "/api/co2-material-types/co2-material-type-by-category";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCo2MaterialTypeByCategory(_response);
        });
    }

    protected processCo2MaterialTypeByCategory(response: AxiosResponse): Promise<Co2MaterialTypeByCategory[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Co2MaterialTypeByCategory.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Co2MaterialTypeByCategory[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Co2MaterialTypeByCategory[]>(null as any);
    }
}

export class MaterialLibrariesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMaterialLibraries(signal?: AbortSignal): Promise<Co2MaterialLibrary[]> {
        let url_ = this.baseUrl + "/api/material-libraries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaterialLibraries(_response);
        });
    }

    protected processGetMaterialLibraries(response: AxiosResponse): Promise<Co2MaterialLibrary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Co2MaterialLibrary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Co2MaterialLibrary[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Co2MaterialLibrary[]>(null as any);
    }
}

export class MetadataEntitiesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getMetaDataByType(type: string | null | undefined, signal?: AbortSignal): Promise<MetadataEntityResponse[]> {
        let url_ = this.baseUrl + "/api/metadata-entities?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMetaDataByType(_response);
        });
    }

    protected processGetMetaDataByType(response: AxiosResponse): Promise<MetadataEntityResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetadataEntityResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MetadataEntityResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetadataEntityResponse[]>(null as any);
    }

    /**
     * Creates a new metadata entity.
     * @param metadataEntityCreateRequest The metadata entity details to create, including name, type (e.g., System, Subsystem),
    optional parent ID, description, owner, and metadata.
     * @return Returns a MetadataEntityResponse for the created entity with its generated ID.
     */
    createMetaDataEntity(metadataEntityCreateRequest: MetadataEntityCreateRequest, signal?: AbortSignal): Promise<MetadataEntityResponse> {
        let url_ = this.baseUrl + "/api/metadata-entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadataEntityCreateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMetaDataEntity(_response);
        });
    }

    protected processCreateMetaDataEntity(response: AxiosResponse): Promise<MetadataEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MetadataEntityResponse.fromJS(resultData200);
            return Promise.resolve<MetadataEntityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\n            \n            Returned when the request is invalid (e.g., missing required fields or invalid type).\n            ", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetadataEntityResponse>(null as any);
    }

    /**
     * Updates an existing metadata entity (e.g. rename a Benchmark Model Type). Duplicate names per type are not allowed.
     */
    updateMetaDataEntity(metadataEntityUpdateRequest: MetadataEntityUpdateRequest, signal?: AbortSignal): Promise<MetadataEntityResponse> {
        let url_ = this.baseUrl + "/api/metadata-entities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadataEntityUpdateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateMetaDataEntity(_response);
        });
    }

    protected processUpdateMetaDataEntity(response: AxiosResponse): Promise<MetadataEntityResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MetadataEntityResponse.fromJS(resultData200);
            return Promise.resolve<MetadataEntityResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetadataEntityResponse>(null as any);
    }

    deleteMetaDataEntitybyId(deleteMetaDataEntityById: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/metadata-entities?";
        if (deleteMetaDataEntityById === null)
            throw new globalThis.Error("The parameter 'deleteMetaDataEntityById' cannot be null.");
        else if (deleteMetaDataEntityById !== undefined)
            url_ += "deleteMetaDataEntityById=" + encodeURIComponent("" + deleteMetaDataEntityById) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMetaDataEntitybyId(_response);
        });
    }

    protected processDeleteMetaDataEntitybyId(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Creates new metadata meta data type entities.
     * @return Entities successfully created.
     */
    createModelFamilyTypeEntity(metadataEntityCreateRequests: MetadataEntityCreateRequest[], signal?: AbortSignal): Promise<MetadataEntityResponse[]> {
        let url_ = this.baseUrl + "/api/metadata-entities/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(metadataEntityCreateRequests);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModelFamilyTypeEntity(_response);
        });
    }

    protected processCreateModelFamilyTypeEntity(response: AxiosResponse): Promise<MetadataEntityResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MetadataEntityResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MetadataEntityResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("\n            Returned when the request is invalid (e.g., missing required fields or parent doesn\'t exist).\n            ", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized access.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MetadataEntityResponse[]>(null as any);
    }
}

export class NonModelledElementsExportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Start export of all non-modelled element configurations to Excel. Returns job ID to poll for completion.
     */
    startExport(signal?: AbortSignal): Promise<NonModelledElementsExportResponse> {
        let url_ = this.baseUrl + "/api/settings/non-modelled-elements/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartExport(_response);
        });
    }

    protected processStartExport(response: AxiosResponse): Promise<NonModelledElementsExportResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NonModelledElementsExportResponse.fromJS(resultData200);
            return Promise.resolve<NonModelledElementsExportResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NonModelledElementsExportResponse>(null as any);
    }

    /**
     * Download the exported Excel file once the job has completed (status = success). Poll until 200 OK.
     */
    getExportFile(jobId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/settings/non-modelled-elements/export/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportFile(_response);
        });
    }

    protected processGetExportFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 202) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProfileConfigurationsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getCadModelCategoryFiltersByProfile(profileId: string | null | undefined, signal?: AbortSignal): Promise<CadModelCategoryFilterResponse> {
        let url_ = this.baseUrl + "/api/profile-configurations?";
        if (profileId !== undefined && profileId !== null)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCadModelCategoryFiltersByProfile(_response);
        });
    }

    protected processGetCadModelCategoryFiltersByProfile(response: AxiosResponse): Promise<CadModelCategoryFilterResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CadModelCategoryFilterResponse.fromJS(resultData200);
            return Promise.resolve<CadModelCategoryFilterResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CadModelCategoryFilterResponse>(null as any);
    }

    createProfileConfiguration(request: CreateProfileConfigurationRequest, signal?: AbortSignal): Promise<ProfileConfiguration> {
        let url_ = this.baseUrl + "/api/profile-configurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProfileConfiguration(_response);
        });
    }

    protected processCreateProfileConfiguration(response: AxiosResponse): Promise<ProfileConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileConfiguration.fromJS(resultData200);
            return Promise.resolve<ProfileConfiguration>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileConfiguration>(null as any);
    }

    getPredefinedProfileConfiguration(signal?: AbortSignal): Promise<CadModelCategoryFilterObjectData[]> {
        let url_ = this.baseUrl + "/api/profile-configurations/predefinedProfileConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPredefinedProfileConfiguration(_response);
        });
    }

    protected processGetPredefinedProfileConfiguration(response: AxiosResponse): Promise<CadModelCategoryFilterObjectData[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CadModelCategoryFilterObjectData.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<CadModelCategoryFilterObjectData[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CadModelCategoryFilterObjectData[]>(null as any);
    }

    updateProfileConfiguration(profileConfigurationId: string, request: UpdateProfileConfigurationRequest, signal?: AbortSignal): Promise<ProfileConfiguration> {
        let url_ = this.baseUrl + "/api/profile-configurations/{profileConfigurationId}";
        if (profileConfigurationId === undefined || profileConfigurationId === null)
            throw new globalThis.Error("The parameter 'profileConfigurationId' must be defined.");
        url_ = url_.replace("{profileConfigurationId}", encodeURIComponent("" + profileConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfileConfiguration(_response);
        });
    }

    protected processUpdateProfileConfiguration(response: AxiosResponse): Promise<ProfileConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileConfiguration.fromJS(resultData200);
            return Promise.resolve<ProfileConfiguration>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileConfiguration>(null as any);
    }
}

export class ProfilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAllProfiles(signal?: AbortSignal): Promise<ProfileResponse[]> {
        let url_ = this.baseUrl + "/api/profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllProfiles(_response);
        });
    }

    protected processGetAllProfiles(response: AxiosResponse): Promise<ProfileResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProfileResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileResponse[]>(null as any);
    }

    createProfile(profileCreateRequest: ProfileCreateRequest, signal?: AbortSignal): Promise<ProfileCreateUpdateResponse> {
        let url_ = this.baseUrl + "/api/profiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileCreateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProfile(_response);
        });
    }

    protected processCreateProfile(response: AxiosResponse): Promise<ProfileCreateUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileCreateUpdateResponse.fromJS(resultData200);
            return Promise.resolve<ProfileCreateUpdateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProfileCreateUpdateResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileCreateUpdateResponse>(null as any);
    }

    getProfileDetails(signal?: AbortSignal): Promise<ProfileResponse[]> {
        let url_ = this.baseUrl + "/api/profiles/details";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfileDetails(_response);
        });
    }

    protected processGetProfileDetails(response: AxiosResponse): Promise<ProfileResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfileResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ProfileResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileResponse[]>(null as any);
    }

    getProfileById(profileId: string, signal?: AbortSignal): Promise<ProfileResponse> {
        let url_ = this.baseUrl + "/api/profiles/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfileById(_response);
        });
    }

    protected processGetProfileById(response: AxiosResponse): Promise<ProfileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileResponse.fromJS(resultData200);
            return Promise.resolve<ProfileResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileResponse>(null as any);
    }

    updateProfile(profileId: string, profileUpdateRequest: ProfileUpdateRequest, signal?: AbortSignal): Promise<ProfileCreateUpdateResponse> {
        let url_ = this.baseUrl + "/api/profiles/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileUpdateRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: AxiosResponse): Promise<ProfileCreateUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileCreateUpdateResponse.fromJS(resultData200);
            return Promise.resolve<ProfileCreateUpdateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProfileCreateUpdateResponse.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileCreateUpdateResponse>(null as any);
    }

    deleteProfile(profileId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/profiles/{profileId}";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProfile(_response);
        });
    }

    protected processDeleteProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates the material configuration for a specific profile.
    Validates that the profileId in the route matches the request body.
    Returns 200 OK on success, 400 Bad Request for invalid input, 401 Unauthorized for unauthorized access,
    and 404 Not Found if the profile or configuration is not found.
     * @param profileId The unique identifier of the profile to update.
     */
    saveProfileMaterialConfiguration(profileId: string, request: ProfileMaterialConfigurationRequest, signal?: AbortSignal): Promise<ProfileCreateUpdateResponse> {
        let url_ = this.baseUrl + "/api/profiles/{profileId}/material-configurations";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveProfileMaterialConfiguration(_response);
        });
    }

    protected processSaveProfileMaterialConfiguration(response: AxiosResponse): Promise<ProfileCreateUpdateResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProfileCreateUpdateResponse.fromJS(resultData200);
            return Promise.resolve<ProfileCreateUpdateResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileCreateUpdateResponse>(null as any);
    }

    getProfileConfiguration(profileId: string, signal?: AbortSignal): Promise<NodeMaterialConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/profiles/{profileId}/configuration";
        if (profileId === undefined || profileId === null)
            throw new globalThis.Error("The parameter 'profileId' must be defined.");
        url_ = url_.replace("{profileId}", encodeURIComponent("" + profileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProfileConfiguration(_response);
        });
    }

    protected processGetProfileConfiguration(response: AxiosResponse): Promise<NodeMaterialConfigurationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NodeMaterialConfigurationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NodeMaterialConfigurationDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NodeMaterialConfigurationDto[]>(null as any);
    }
}

export class UnmappedCadMaterialsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getUnMappedCadMaterials(profileId: string | null | undefined, signal?: AbortSignal): Promise<UnMappedCadMaterialsResponse[]> {
        let url_ = this.baseUrl + "/api/unmapped-cad-materials?";
        if (profileId !== undefined && profileId !== null)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnMappedCadMaterials(_response);
        });
    }

    protected processGetUnMappedCadMaterials(response: AxiosResponse): Promise<UnMappedCadMaterialsResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnMappedCadMaterialsResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnMappedCadMaterialsResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnMappedCadMaterialsResponse[]>(null as any);
    }
}

export class HubsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    sendMessage(text: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/hubs/message/{text}";
        if (text === undefined || text === null)
            throw new globalThis.Error("The parameter 'text' must be defined.");
        url_ = url_.replace("{text}", encodeURIComponent("" + text));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Co2MaterialAssignSettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Find Co2MaterialAssignSetting by co2MaterialAssignSettingId
     * @param mode (optional) Allowed values are Project or Global Or Scenario or Profile
     * @param projectId (optional) Project Id is required if mode is Project
     * @param scenarioId (optional) Scenario Id is required if mode is Scenario
     * @param profileId (optional) Profile Id is required if mode is Profile
     * @return An instance co2 Material Assign
     */
    getCo2MaterialAssignSetting(mode: Co2MaterialSettingType | undefined, projectId: string | null | undefined, scenarioId: string | null | undefined, profileId: string | null | undefined, signal?: AbortSignal): Promise<GetCo2MaterialAssignSettingResponse> {
        let url_ = this.baseUrl + "/api/co2-material-assign-settings?";
        if (mode === null)
            throw new globalThis.Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (scenarioId !== undefined && scenarioId !== null)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (profileId !== undefined && profileId !== null)
            url_ += "profileId=" + encodeURIComponent("" + profileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCo2MaterialAssignSetting(_response);
        });
    }

    protected processGetCo2MaterialAssignSetting(response: AxiosResponse): Promise<GetCo2MaterialAssignSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCo2MaterialAssignSettingResponse.fromJS(resultData200);
            return Promise.resolve<GetCo2MaterialAssignSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCo2MaterialAssignSettingResponse>(null as any);
    }

    /**
     * Update / Insert Co2MaterialAssignSetting
     * @return an instance of GetCo2MaterialAssignSettingResponse
     */
    upsertCo2MaterialAssignSetting(upsertCo2MaterialSettingRequest: UpsertCo2MaterialSettingRequest, signal?: AbortSignal): Promise<GetCo2MaterialAssignSettingResponse> {
        let url_ = this.baseUrl + "/api/co2-material-assign-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(upsertCo2MaterialSettingRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertCo2MaterialAssignSetting(_response);
        });
    }

    protected processUpsertCo2MaterialAssignSetting(response: AxiosResponse): Promise<GetCo2MaterialAssignSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCo2MaterialAssignSettingResponse.fromJS(resultData200);
            return Promise.resolve<GetCo2MaterialAssignSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCo2MaterialAssignSettingResponse>(null as any);
    }

    /**
     * Update a Co2MaterialAssignSettingItem
     * @param updateCo2MaterialAssignSettingItemRequest input should contain Co2MaterialAssignSettingItemId and Item Details to be updated
     * @return an updated instance of Co2MaterialAssignSettingItem
     */
    updateCo2MaterialAssignSettingItem(co2MaterialAssignSettingId: string, co2MaterialAssignSettingItemId: string, updateCo2MaterialAssignSettingItemRequest: UpdateCo2MaterialAssignSettingItemRequest, signal?: AbortSignal): Promise<GetCo2MaterialAssignSettingItemResponse> {
        let url_ = this.baseUrl + "/api/co2-material-assign-settings/{co2MaterialAssignSettingId}/items/{co2MaterialAssignSettingItemId}";
        if (co2MaterialAssignSettingId === undefined || co2MaterialAssignSettingId === null)
            throw new globalThis.Error("The parameter 'co2MaterialAssignSettingId' must be defined.");
        url_ = url_.replace("{co2MaterialAssignSettingId}", encodeURIComponent("" + co2MaterialAssignSettingId));
        if (co2MaterialAssignSettingItemId === undefined || co2MaterialAssignSettingItemId === null)
            throw new globalThis.Error("The parameter 'co2MaterialAssignSettingItemId' must be defined.");
        url_ = url_.replace("{co2MaterialAssignSettingItemId}", encodeURIComponent("" + co2MaterialAssignSettingItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateCo2MaterialAssignSettingItemRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCo2MaterialAssignSettingItem(_response);
        });
    }

    protected processUpdateCo2MaterialAssignSettingItem(response: AxiosResponse): Promise<GetCo2MaterialAssignSettingItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCo2MaterialAssignSettingItemResponse.fromJS(resultData200);
            return Promise.resolve<GetCo2MaterialAssignSettingItemResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCo2MaterialAssignSettingItemResponse>(null as any);
    }

    /**
     * Create  a new Co2MaterialAssignSettingItem
     * @return a new  instance of Co2MaterialAssignSettingItem
     */
    createCo2MaterialAssignSettingItem(co2MaterialAssignSettingId: string, createCo2MaterialAssignSettingItemRequest: UpdateCo2MaterialAssignSettingItemRequest, signal?: AbortSignal): Promise<GetCo2MaterialAssignSettingItemResponse> {
        let url_ = this.baseUrl + "/api/co2-material-assign-settings/{co2MaterialAssignSettingId}/items";
        if (co2MaterialAssignSettingId === undefined || co2MaterialAssignSettingId === null)
            throw new globalThis.Error("The parameter 'co2MaterialAssignSettingId' must be defined.");
        url_ = url_.replace("{co2MaterialAssignSettingId}", encodeURIComponent("" + co2MaterialAssignSettingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createCo2MaterialAssignSettingItemRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCo2MaterialAssignSettingItem(_response);
        });
    }

    protected processCreateCo2MaterialAssignSettingItem(response: AxiosResponse): Promise<GetCo2MaterialAssignSettingItemResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetCo2MaterialAssignSettingItemResponse.fromJS(resultData200);
            return Promise.resolve<GetCo2MaterialAssignSettingItemResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetCo2MaterialAssignSettingItemResponse>(null as any);
    }
}

export class QueryBuildersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Create a new Rule Set Selection Filter
     * @param createFilteredElementConfigurationRequest request config
     */
    createFilteredElementConfiguration(createFilteredElementConfigurationRequest: CreateFilteredElementConfigurationRequest, signal?: AbortSignal): Promise<FilteredElementConfiguration> {
        let url_ = this.baseUrl + "/api/query-builders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createFilteredElementConfigurationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFilteredElementConfiguration(_response);
        });
    }

    protected processCreateFilteredElementConfiguration(response: AxiosResponse): Promise<FilteredElementConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredElementConfiguration.fromJS(resultData200);
            return Promise.resolve<FilteredElementConfiguration>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredElementConfiguration>(null as any);
    }

    /**
     * Find ElementFilterConfiguration by ElementFilterConfigurationId
     * @param filteredElementConfigurationId (optional) Project Id is required if mode is Project
     * @return An instance ElementFilterConfiguration
     */
    getFilteredElementConfiguration(filteredElementConfigurationId: string | undefined, signal?: AbortSignal): Promise<FilteredElementConfiguration> {
        let url_ = this.baseUrl + "/api/query-builders?";
        if (filteredElementConfigurationId === null)
            throw new globalThis.Error("The parameter 'filteredElementConfigurationId' cannot be null.");
        else if (filteredElementConfigurationId !== undefined)
            url_ += "filteredElementConfigurationId=" + encodeURIComponent("" + filteredElementConfigurationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredElementConfiguration(_response);
        });
    }

    protected processGetFilteredElementConfiguration(response: AxiosResponse): Promise<FilteredElementConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredElementConfiguration.fromJS(resultData200);
            return Promise.resolve<FilteredElementConfiguration>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredElementConfiguration>(null as any);
    }

    /**
     * Update a new Selection Filter
     * @param updateFilteredElementConfigurationRequest request config
     */
    updateFilteredElementConfiguration(filteredElementConfigurationId: string, updateFilteredElementConfigurationRequest: UpdateFilteredElementConfigurationRequest, signal?: AbortSignal): Promise<FilteredElementConfiguration> {
        let url_ = this.baseUrl + "/api/query-builders/{filteredElementConfigurationId}";
        if (filteredElementConfigurationId === undefined || filteredElementConfigurationId === null)
            throw new globalThis.Error("The parameter 'filteredElementConfigurationId' must be defined.");
        url_ = url_.replace("{filteredElementConfigurationId}", encodeURIComponent("" + filteredElementConfigurationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFilteredElementConfigurationRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFilteredElementConfiguration(_response);
        });
    }

    protected processUpdateFilteredElementConfiguration(response: AxiosResponse): Promise<FilteredElementConfiguration> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilteredElementConfiguration.fromJS(resultData200);
            return Promise.resolve<FilteredElementConfiguration>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredElementConfiguration>(null as any);
    }

    /**
     * Find ElementFilterConfiguration by ElementFilterConfigurationId
     * @param type (optional) 
     * @return An instance ElementFilterConfiguration
     */
    getRuleSetFilters(type: FilteredElementConfigurationType | null | undefined, signal?: AbortSignal): Promise<FilteredElementConfiguration[]> {
        let url_ = this.baseUrl + "/api/query-builders/rule-sets?";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRuleSetFilters(_response);
        });
    }

    protected processGetRuleSetFilters(response: AxiosResponse): Promise<FilteredElementConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FilteredElementConfiguration.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<FilteredElementConfiguration[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilteredElementConfiguration[]>(null as any);
    }
}

export class RebarMaterialsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getListOfRebarMaterialsValue(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/rebar-materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListOfRebarMaterialsValue(_response);
        });
    }

    protected processGetListOfRebarMaterialsValue(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    deleteRebarMaterialValue(value: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/rebar-materials?";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRebarMaterialValue(_response);
        });
    }

    protected processDeleteRebarMaterialValue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    addRebarMaterialValue(value: string | undefined, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/rebar-materials?";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRebarMaterialValue(_response);
        });
    }

    protected processAddRebarMaterialValue(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getApplicationSettings(signal?: AbortSignal): Promise<ApplicationSettings> {
        let url_ = this.baseUrl + "/api/settings/application";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationSettings(_response);
        });
    }

    protected processGetApplicationSettings(response: AxiosResponse): Promise<ApplicationSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationSettings.fromJS(resultData200);
            return Promise.resolve<ApplicationSettings>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationSettings>(null as any);
    }

    getAppSetting(key: string, signal?: AbortSignal): Promise<AppSetting> {
        let url_ = this.baseUrl + "/api/settings/appsetting/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppSetting(_response);
        });
    }

    protected processGetAppSetting(response: AxiosResponse): Promise<AppSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppSetting.fromJS(resultData200);
            return Promise.resolve<AppSetting>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppSetting>(null as any);
    }

    updateAppSetting(key: string, request: UpdateAppSettingRequest, signal?: AbortSignal): Promise<AppSetting> {
        let url_ = this.baseUrl + "/api/settings/appsetting/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAppSetting(_response);
        });
    }

    protected processUpdateAppSetting(response: AxiosResponse): Promise<AppSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppSetting.fromJS(resultData200);
            return Promise.resolve<AppSetting>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppSetting>(null as any);
    }

    deleteAppSetting(key: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/settings/appsetting/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAppSetting(_response);
        });
    }

    protected processDeleteAppSetting(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createAppSetting(request: CreateAppSettingRequest, signal?: AbortSignal): Promise<AppSetting> {
        let url_ = this.baseUrl + "/api/settings/appsetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAppSetting(_response);
        });
    }

    protected processCreateAppSetting(response: AxiosResponse): Promise<AppSetting> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = AppSetting.fromJS(resultData201);
            return Promise.resolve<AppSetting>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppSetting>(null as any);
    }
}

export class ModelDerivativeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getModelDerivativeDefaultGuid(urn: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/model-derivative/{urn}/metadata/guid";
        if (urn === undefined || urn === null)
            throw new globalThis.Error("The parameter 'urn' must be defined.");
        url_ = url_.replace("{urn}", encodeURIComponent("" + urn));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelDerivativeDefaultGuid(_response);
        });
    }

    protected processGetModelDerivativeDefaultGuid(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getModelDerivativeAllProperties(urn: string, guid: string, signal?: AbortSignal): Promise<AllPropertiesData> {
        let url_ = this.baseUrl + "/api/model-derivative/{urn}/metadata/{guid}/properties";
        if (urn === undefined || urn === null)
            throw new globalThis.Error("The parameter 'urn' must be defined.");
        url_ = url_.replace("{urn}", encodeURIComponent("" + urn));
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelDerivativeAllProperties(_response);
        });
    }

    protected processGetModelDerivativeAllProperties(response: AxiosResponse): Promise<AllPropertiesData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AllPropertiesData.fromJS(resultData200);
            return Promise.resolve<AllPropertiesData>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AllPropertiesData>(null as any);
    }
}

export class ModelScopesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    createModelScopeSettingItems(modelScopeSettingId: string | null, createModelScopeSettingsItemsRequest: CreateModelScopeSettingsItemsRequest, signal?: AbortSignal): Promise<ModelScopeSettingResponse> {
        let url_ = this.baseUrl + "/api/model-scopes/{modelScopeSettingId}";
        if (modelScopeSettingId === undefined || modelScopeSettingId === null)
            throw new globalThis.Error("The parameter 'modelScopeSettingId' must be defined.");
        url_ = url_.replace("{modelScopeSettingId}", encodeURIComponent("" + modelScopeSettingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createModelScopeSettingsItemsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateModelScopeSettingItems(_response);
        });
    }

    protected processCreateModelScopeSettingItems(response: AxiosResponse): Promise<ModelScopeSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopeSettingResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopeSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopeSettingResponse>(null as any);
    }

    getModelScopeSetting(modelScopeSettingId: string | null, signal?: AbortSignal): Promise<ModelScopeSettingResponse> {
        let url_ = this.baseUrl + "/api/model-scopes/{modelScopeSettingId}";
        if (modelScopeSettingId === undefined || modelScopeSettingId === null)
            throw new globalThis.Error("The parameter 'modelScopeSettingId' must be defined.");
        url_ = url_.replace("{modelScopeSettingId}", encodeURIComponent("" + modelScopeSettingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetModelScopeSetting(_response);
        });
    }

    protected processGetModelScopeSetting(response: AxiosResponse): Promise<ModelScopeSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopeSettingResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopeSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopeSettingResponse>(null as any);
    }

    updateModelScopeSettings(modelScopeSettingId: string | null, updateModelScopeSettingsRequest: UpdateModelScopeSettingsRequest, signal?: AbortSignal): Promise<ModelScopeSettingResponse> {
        let url_ = this.baseUrl + "/api/model-scopes/{modelScopeSettingId}";
        if (modelScopeSettingId === undefined || modelScopeSettingId === null)
            throw new globalThis.Error("The parameter 'modelScopeSettingId' must be defined.");
        url_ = url_.replace("{modelScopeSettingId}", encodeURIComponent("" + modelScopeSettingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateModelScopeSettingsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModelScopeSettings(_response);
        });
    }

    protected processUpdateModelScopeSettings(response: AxiosResponse): Promise<ModelScopeSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopeSettingResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopeSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopeSettingResponse>(null as any);
    }

    deleteModelScopeSettingItems(modelScopeSettingId: string | null, deleteModelScopeSettingsItemsRequest: DeleteModelScopeSettingsItemsRequest, signal?: AbortSignal): Promise<ModelScopeSettingResponse> {
        let url_ = this.baseUrl + "/api/model-scopes/{modelScopeSettingId}";
        if (modelScopeSettingId === undefined || modelScopeSettingId === null)
            throw new globalThis.Error("The parameter 'modelScopeSettingId' must be defined.");
        url_ = url_.replace("{modelScopeSettingId}", encodeURIComponent("" + modelScopeSettingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteModelScopeSettingsItemsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteModelScopeSettingItems(_response);
        });
    }

    protected processDeleteModelScopeSettingItems(response: AxiosResponse): Promise<ModelScopeSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopeSettingResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopeSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopeSettingResponse>(null as any);
    }

    updateModelScopeSettingItems(modelScopeSettingId: string | null, updateModelScopeSettingsItemsRequest: UpdateModelScopeSettingsItemsRequest, signal?: AbortSignal): Promise<ModelScopeSettingResponse> {
        let url_ = this.baseUrl + "/api/model-scopes/{modelScopeSettingId}/items";
        if (modelScopeSettingId === undefined || modelScopeSettingId === null)
            throw new globalThis.Error("The parameter 'modelScopeSettingId' must be defined.");
        url_ = url_.replace("{modelScopeSettingId}", encodeURIComponent("" + modelScopeSettingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateModelScopeSettingsItemsRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateModelScopeSettingItems(_response);
        });
    }

    protected processUpdateModelScopeSettingItems(response: AxiosResponse): Promise<ModelScopeSettingResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ModelScopeSettingResponse.fromJS(resultData200);
            return Promise.resolve<ModelScopeSettingResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ModelScopeSettingResponse>(null as any);
    }
}

export class ApsDataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getHubs(signal?: AbortSignal): Promise<ApsHub[]> {
        let url_ = this.baseUrl + "/api/aps/data/hubs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHubs(_response);
        });
    }

    protected processGetHubs(response: AxiosResponse): Promise<ApsHub[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsHub.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsHub[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsHub[]>(null as any);
    }

    getProjects(hubId: string, signal?: AbortSignal): Promise<ApsProject[]> {
        let url_ = this.baseUrl + "/api/aps/data/hubs/{hubId}/projects";
        if (hubId === undefined || hubId === null)
            throw new globalThis.Error("The parameter 'hubId' must be defined.");
        url_ = url_.replace("{hubId}", encodeURIComponent("" + hubId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjects(_response);
        });
    }

    protected processGetProjects(response: AxiosResponse): Promise<ApsProject[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsProject[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsProject[]>(null as any);
    }

    getFolders(apsProjectId: string, hubId: string | undefined, parentId: string | undefined, signal?: AbortSignal): Promise<ApsFolderContent[]> {
        let url_ = this.baseUrl + "/api/aps/data/projects/{apsProjectId}/folder/contents?";
        if (apsProjectId === undefined || apsProjectId === null)
            throw new globalThis.Error("The parameter 'apsProjectId' must be defined.");
        url_ = url_.replace("{apsProjectId}", encodeURIComponent("" + apsProjectId));
        if (hubId === null)
            throw new globalThis.Error("The parameter 'hubId' cannot be null.");
        else if (hubId !== undefined)
            url_ += "hubId=" + encodeURIComponent("" + hubId) + "&";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFolders(_response);
        });
    }

    protected processGetFolders(response: AxiosResponse): Promise<ApsFolderContent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsFolderContent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsFolderContent[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsFolderContent[]>(null as any);
    }

    searchFolders(apsProjectId: string, hubId: string | undefined, parentId: string | undefined, searchText: string | undefined, signal?: AbortSignal): Promise<ApsFolderContent[]> {
        let url_ = this.baseUrl + "/api/aps/data/projects/{apsProjectId}/folder/search?";
        if (apsProjectId === undefined || apsProjectId === null)
            throw new globalThis.Error("The parameter 'apsProjectId' must be defined.");
        url_ = url_.replace("{apsProjectId}", encodeURIComponent("" + apsProjectId));
        if (hubId === null)
            throw new globalThis.Error("The parameter 'hubId' cannot be null.");
        else if (hubId !== undefined)
            url_ += "hubId=" + encodeURIComponent("" + hubId) + "&";
        if (parentId === null)
            throw new globalThis.Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (searchText === null)
            throw new globalThis.Error("The parameter 'searchText' cannot be null.");
        else if (searchText !== undefined)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchFolders(_response);
        });
    }

    protected processSearchFolders(response: AxiosResponse): Promise<ApsFolderContent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsFolderContent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsFolderContent[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsFolderContent[]>(null as any);
    }

    getViews(apsProjectId: string, itemId: string, signal?: AbortSignal): Promise<ApsItemView[]> {
        let url_ = this.baseUrl + "/api/aps/data/projects/{apsProjectId}/items/{itemId}/views";
        if (apsProjectId === undefined || apsProjectId === null)
            throw new globalThis.Error("The parameter 'apsProjectId' must be defined.");
        url_ = url_.replace("{apsProjectId}", encodeURIComponent("" + apsProjectId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViews(_response);
        });
    }

    protected processGetViews(response: AxiosResponse): Promise<ApsItemView[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsItemView.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsItemView[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsItemView[]>(null as any);
    }

    getItemVersions(apsProjectId: string, itemId: string, signal?: AbortSignal): Promise<ApsFolderContent[]> {
        let url_ = this.baseUrl + "/api/aps/data/projects/{apsProjectId}/items/{itemId}/versions";
        if (apsProjectId === undefined || apsProjectId === null)
            throw new globalThis.Error("The parameter 'apsProjectId' must be defined.");
        url_ = url_.replace("{apsProjectId}", encodeURIComponent("" + apsProjectId));
        if (itemId === undefined || itemId === null)
            throw new globalThis.Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetItemVersions(_response);
        });
    }

    protected processGetItemVersions(response: AxiosResponse): Promise<ApsFolderContent[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApsFolderContent.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApsFolderContent[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApsFolderContent[]>(null as any);
    }
}

export class ApsProjectUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProjectUsers(apsProjectIdPath: string, apsProjectIdQuery: string | undefined, searchText: string | null | undefined, signal?: AbortSignal): Promise<GetProjectUsers200Response> {
        let url_ = this.baseUrl + "/api/aps/project/{apsProjectId}/users?";
        if (apsProjectIdPath === undefined || apsProjectIdPath === null)
            throw new globalThis.Error("The parameter 'apsProjectIdPath' must be defined.");
        url_ = url_.replace("{apsProjectId}", encodeURIComponent("" + apsProjectIdPath));
        if (apsProjectIdQuery === null)
            throw new globalThis.Error("The parameter 'apsProjectIdQuery' cannot be null.");
        else if (apsProjectIdQuery !== undefined)
            url_ += "ApsProjectId=" + encodeURIComponent("" + apsProjectIdQuery) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectUsers(_response);
        });
    }

    protected processGetProjectUsers(response: AxiosResponse): Promise<GetProjectUsers200Response> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetProjectUsers200Response.fromJS(resultData200);
            return Promise.resolve<GetProjectUsers200Response>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetProjectUsers200Response>(null as any);
    }

    syncApsUsers(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/aps/commands/sync-aps-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncApsUsers(_response);
        });
    }

    protected processSyncApsUsers(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DocumentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getDocuments(signal?: AbortSignal): Promise<Documents[]> {
        let url_ = this.baseUrl + "/api/documents";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<Documents[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Documents.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<Documents[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Documents[]>(null as any);
    }

    uploadDocument(file: FileParameter | null | undefined, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/commands/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    downloadDocument(filename: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/documents/{filename}/commands/download";
        if (filename === undefined || filename === null)
            throw new globalThis.Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteDocument(filename: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/documents/{filename}";
        if (filename === undefined || filename === null)
            throw new globalThis.Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class HealthClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    check(signal?: AbortSignal): Promise<HealthCheckResponse[]> {
        let url_ = this.baseUrl + "/api/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: AxiosResponse): Promise<HealthCheckResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HealthCheckResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<HealthCheckResponse[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HealthCheckResponse[]>(null as any);
    }
}

export class LogsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getLogFilenames(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/logs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogFilenames(_response);
        });
    }

    protected processGetLogFilenames(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getLogFileContents(fileName: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/logs/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new globalThis.Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogFileContents(_response);
        });
    }

    protected processGetLogFileContents(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AnalysesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getProjectData(projectId: string, signal?: AbortSignal): Promise<ProjectData> {
        let url_ = this.baseUrl + "/api/analyses/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectData(_response);
        });
    }

    protected processGetProjectData(response: AxiosResponse): Promise<ProjectData> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectData.fromJS(resultData200);
            return Promise.resolve<ProjectData>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectData>(null as any);
    }

    getExportSelectedData(projectId: string, jobId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/analyses/projects/{projectId}/commands/export/{jobId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportSelectedData(_response);
        });
    }

    protected processGetExportSelectedData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exportSelectedData(projectId: string, exportSelectedDataRequest: ExportSelectedDataRequest, signal?: AbortSignal): Promise<ExportSelectedDataResponse> {
        let url_ = this.baseUrl + "/api/analyses/projects/{projectId}/commands/export";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportSelectedDataRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportSelectedData(_response);
        });
    }

    protected processExportSelectedData(response: AxiosResponse): Promise<ExportSelectedDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSelectedDataResponse.fromJS(resultData200);
            return Promise.resolve<ExportSelectedDataResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSelectedDataResponse>(null as any);
    }

    /**
     * Exports baseline and final scenarios from multiple projects into a single Excel workbook.
    Restricted to administrators only.
     */
    exportMultiProjectData(projectIds: string[], signal?: AbortSignal): Promise<ExportSelectedDataResponse> {
        let url_ = this.baseUrl + "/api/analyses/commands/export-multi-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectIds);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportMultiProjectData(_response);
        });
    }

    protected processExportMultiProjectData(response: AxiosResponse): Promise<ExportSelectedDataResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ExportSelectedDataResponse.fromJS(resultData200);
            return Promise.resolve<ExportSelectedDataResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ExportSelectedDataResponse>(null as any);
    }

    /**
     * Downloads the multi-project export file after background job completes.
    Downloads from Azure Blob Storage if BlobName is set, otherwise falls back to FileContent in database.
     */
    getExportMultiProjectData(jobId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/analyses/commands/export-multi/{jobId}";
        if (jobId === undefined || jobId === null)
            throw new globalThis.Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExportMultiProjectData(_response);
        });
    }

    protected processGetExportMultiProjectData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class SustainabilitySyncResponse implements ISustainabilitySyncResponse {
    status?: string;
    message?: string;

    constructor(data?: ISustainabilitySyncResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SustainabilitySyncResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SustainabilitySyncResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface ISustainabilitySyncResponse {
    status?: string;
    message?: string;
}

export class DashboardProject implements IDashboardProject {
    projectId?: string;
    name?: string;
    description?: string | undefined;
    projectNumber?: string | undefined;
    projectEmissionReductionTarget?: number | undefined;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    modelCount?: number;
    scenarioCount?: number;
    imageUrl?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    createdBy?: string | undefined;
    ownerName?: string;
    apsProjectId?: string;
    apsHubId?: string;
    permissions?: string[] | undefined;
    profileName?: string;

    constructor(data?: IDashboardProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectNumber = _data["projectNumber"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.nonModelledElementsStatus = _data["nonModelledElementsStatus"];
            this.modelCount = _data["modelCount"];
            this.scenarioCount = _data["scenarioCount"];
            this.imageUrl = _data["imageUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.ownerName = _data["ownerName"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsHubId = _data["apsHubId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.profileName = _data["profileName"];
        }
    }

    static fromJS(data: any): DashboardProject {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectNumber"] = this.projectNumber;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["nonModelledElementsStatus"] = this.nonModelledElementsStatus;
        data["modelCount"] = this.modelCount;
        data["scenarioCount"] = this.scenarioCount;
        data["imageUrl"] = this.imageUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["ownerName"] = this.ownerName;
        data["apsProjectId"] = this.apsProjectId;
        data["apsHubId"] = this.apsHubId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["profileName"] = this.profileName;
        return data;
    }
}

export interface IDashboardProject {
    projectId?: string;
    name?: string;
    description?: string | undefined;
    projectNumber?: string | undefined;
    projectEmissionReductionTarget?: number | undefined;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    modelCount?: number;
    scenarioCount?: number;
    imageUrl?: string;
    createdAt?: Date;
    modifiedAt?: Date;
    createdBy?: string | undefined;
    ownerName?: string;
    apsProjectId?: string;
    apsHubId?: string;
    permissions?: string[] | undefined;
    profileName?: string;
}

export enum RebarEstimationStatus {
    Disabled = "Disabled",
    Enabled = "Enabled",
    Estimated = "Estimated",
}

export enum NonModelledElementsStatus {
    Disabled = "Disabled",
    Enabled = "Enabled",
    Estimated = "Estimated",
}

export class Model implements IModel {
    modelId?: string;
    projectId?: string;
    description?: string | undefined;
    active?: boolean;
    status?: ModelState;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateTarget?: number | undefined;
    climateBudgetTarget?: number | undefined;
    elementCount?: number;
    componentCount?: number;
    materialCount?: number;
    elementWithComponentsCount?: number;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    /** Benchmark/carbon model type (e.g. Architecture, Structure, MEP). References MetadataEntity with Type = BenchmarkModelType. */
    modelTypeId?: string | undefined;
    /** Display name of the assigned benchmark model type. Not mapped to DB; populated when BenchmarkModelTypeEntity is loaded. */
    modelTypeName?: string | undefined;
    suffix?: string | undefined;
    version?: number;
    isSplitted?: boolean | undefined;
    parentId?: string | undefined;
    /** '|' delimited ModelDataType values */
    dataType?: string | undefined;
    /** '|' delimited ModelDataSourceType values */
    dataSource?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    scenarioCount?: number;
    /** Computed property that formats the display name based on ApsItemName and Suffix
- With suffix: basename-suffix.extension (e.g., Building-modified.rvt)
- Without suffix: originalfilename.extension (e.g., Building.rvt) */
    modelName?: string;
    /** Computed property that formats the version display
- With suffix and version: ICT{apsVersion}.{version} (e.g., ICT1.2)
- Without suffix: V{apsVersion} (e.g., V1)
- Adds asterisk (*) when IsSplitted is true */
    modelVersion?: string;

    constructor(data?: IModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.active = _data["active"];
            this.status = _data["status"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.floorArea = _data["floorArea"];
            this.developmentArea = _data["developmentArea"];
            this.totalArea = _data["totalArea"];
            this.climateTarget = _data["climateTarget"];
            this.climateBudgetTarget = _data["climateBudgetTarget"];
            this.elementCount = _data["elementCount"];
            this.componentCount = _data["componentCount"];
            this.materialCount = _data["materialCount"];
            this.elementWithComponentsCount = _data["elementWithComponentsCount"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsItemId = _data["apsItemId"];
            this.apsItemName = _data["apsItemName"];
            this.apsViewId = _data["apsViewId"];
            this.apsViewName = _data["apsViewName"];
            this.apsVersionId = _data["apsVersionId"];
            this.apsWebView = _data["apsWebView"];
            this.apsStorageId = _data["apsStorageId"];
            this.apsCreateUserName = _data["apsCreateUserName"];
            this.apsLastModifiedUserName = _data["apsLastModifiedUserName"];
            this.apsVersion = _data["apsVersion"];
            this.apsIsCompositeDesign = _data["apsIsCompositeDesign"];
            this.apsFileSize = _data["apsFileSize"];
            this.apsFileVersion = _data["apsFileVersion"];
            this.modelEmissionReductionTarget = _data["modelEmissionReductionTarget"];
            this.modelTypeId = _data["modelTypeId"];
            this.modelTypeName = _data["modelTypeName"];
            this.suffix = _data["suffix"];
            this.version = _data["version"];
            this.isSplitted = _data["isSplitted"];
            this.parentId = _data["parentId"];
            this.dataType = _data["dataType"];
            this.dataSource = _data["dataSource"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.scenarioCount = _data["scenarioCount"];
            this.modelName = _data["modelName"];
            this.modelVersion = _data["modelVersion"];
        }
    }

    static fromJS(data: any): Model {
        data = typeof data === 'object' ? data : {};
        let result = new Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["active"] = this.active;
        data["status"] = this.status;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["floorArea"] = this.floorArea;
        data["developmentArea"] = this.developmentArea;
        data["totalArea"] = this.totalArea;
        data["climateTarget"] = this.climateTarget;
        data["climateBudgetTarget"] = this.climateBudgetTarget;
        data["elementCount"] = this.elementCount;
        data["componentCount"] = this.componentCount;
        data["materialCount"] = this.materialCount;
        data["elementWithComponentsCount"] = this.elementWithComponentsCount;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsItemId"] = this.apsItemId;
        data["apsItemName"] = this.apsItemName;
        data["apsViewId"] = this.apsViewId;
        data["apsViewName"] = this.apsViewName;
        data["apsVersionId"] = this.apsVersionId;
        data["apsWebView"] = this.apsWebView;
        data["apsStorageId"] = this.apsStorageId;
        data["apsCreateUserName"] = this.apsCreateUserName;
        data["apsLastModifiedUserName"] = this.apsLastModifiedUserName;
        data["apsVersion"] = this.apsVersion;
        data["apsIsCompositeDesign"] = this.apsIsCompositeDesign;
        data["apsFileSize"] = this.apsFileSize;
        data["apsFileVersion"] = this.apsFileVersion;
        data["modelEmissionReductionTarget"] = this.modelEmissionReductionTarget;
        data["modelTypeId"] = this.modelTypeId;
        data["modelTypeName"] = this.modelTypeName;
        data["suffix"] = this.suffix;
        data["version"] = this.version;
        data["isSplitted"] = this.isSplitted;
        data["parentId"] = this.parentId;
        data["dataType"] = this.dataType;
        data["dataSource"] = this.dataSource;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["scenarioCount"] = this.scenarioCount;
        data["modelName"] = this.modelName;
        data["modelVersion"] = this.modelVersion;
        return data;
    }
}

export interface IModel {
    modelId?: string;
    projectId?: string;
    description?: string | undefined;
    active?: boolean;
    status?: ModelState;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateTarget?: number | undefined;
    climateBudgetTarget?: number | undefined;
    elementCount?: number;
    componentCount?: number;
    materialCount?: number;
    elementWithComponentsCount?: number;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    /** Benchmark/carbon model type (e.g. Architecture, Structure, MEP). References MetadataEntity with Type = BenchmarkModelType. */
    modelTypeId?: string | undefined;
    /** Display name of the assigned benchmark model type. Not mapped to DB; populated when BenchmarkModelTypeEntity is loaded. */
    modelTypeName?: string | undefined;
    suffix?: string | undefined;
    version?: number;
    isSplitted?: boolean | undefined;
    parentId?: string | undefined;
    /** '|' delimited ModelDataType values */
    dataType?: string | undefined;
    /** '|' delimited ModelDataSourceType values */
    dataSource?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    scenarioCount?: number;
    /** Computed property that formats the display name based on ApsItemName and Suffix
- With suffix: basename-suffix.extension (e.g., Building-modified.rvt)
- Without suffix: originalfilename.extension (e.g., Building.rvt) */
    modelName?: string;
    /** Computed property that formats the version display
- With suffix and version: ICT{apsVersion}.{version} (e.g., ICT1.2)
- Without suffix: V{apsVersion} (e.g., V1)
- Adds asterisk (*) when IsSplitted is true */
    modelVersion?: string;
}

export enum ModelState {
    Created = "Created",
    Processing = "Processing",
    Success = "Success",
    ExtractionFailed = "ExtractionFailed",
}

export class UpsertModel implements IUpsertModel {
    modelId?: string | undefined;
    projectId?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    rebarEstimation?: boolean | undefined;
    modelTypeId?: string | undefined;

    constructor(data?: IUpsertModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.totalArea = _data["totalArea"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsItemId = _data["apsItemId"];
            this.apsItemName = _data["apsItemName"];
            this.apsViewId = _data["apsViewId"];
            this.apsViewName = _data["apsViewName"];
            this.apsVersionId = _data["apsVersionId"];
            this.apsWebView = _data["apsWebView"];
            this.apsStorageId = _data["apsStorageId"];
            this.apsCreateUserName = _data["apsCreateUserName"];
            this.apsLastModifiedUserName = _data["apsLastModifiedUserName"];
            this.apsVersion = _data["apsVersion"];
            this.apsIsCompositeDesign = _data["apsIsCompositeDesign"];
            this.apsFileSize = _data["apsFileSize"];
            this.apsFileVersion = _data["apsFileVersion"];
            this.modelEmissionReductionTarget = _data["modelEmissionReductionTarget"];
            this.rebarEstimation = _data["rebarEstimation"];
            this.modelTypeId = _data["modelTypeId"];
        }
    }

    static fromJS(data: any): UpsertModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["totalArea"] = this.totalArea;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsItemId"] = this.apsItemId;
        data["apsItemName"] = this.apsItemName;
        data["apsViewId"] = this.apsViewId;
        data["apsViewName"] = this.apsViewName;
        data["apsVersionId"] = this.apsVersionId;
        data["apsWebView"] = this.apsWebView;
        data["apsStorageId"] = this.apsStorageId;
        data["apsCreateUserName"] = this.apsCreateUserName;
        data["apsLastModifiedUserName"] = this.apsLastModifiedUserName;
        data["apsVersion"] = this.apsVersion;
        data["apsIsCompositeDesign"] = this.apsIsCompositeDesign;
        data["apsFileSize"] = this.apsFileSize;
        data["apsFileVersion"] = this.apsFileVersion;
        data["modelEmissionReductionTarget"] = this.modelEmissionReductionTarget;
        data["rebarEstimation"] = this.rebarEstimation;
        data["modelTypeId"] = this.modelTypeId;
        return data;
    }
}

export interface IUpsertModel {
    modelId?: string | undefined;
    projectId?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    rebarEstimation?: boolean | undefined;
    modelTypeId?: string | undefined;
}

export class ProjectResponse implements IProjectResponse {
    project?: Project;
    permissions?: string[];

    constructor(data?: IProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IProjectResponse {
    project?: Project;
    permissions?: string[];
}

export class Project implements IProject {
    imageUrl?: string;
    projectMetadata?: ProjectMetadata | undefined;
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateBudgetTarget?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    goal?: string | undefined;
    scope?: string | undefined;
    userId?: string;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    user?: ApplicationUser;
    jobs?: Job[];
    models?: Model[];
    projectImages?: ProjectImage[];
    scenarios?: Scenario[];
    co2MaterialAssignSettings?: Co2MaterialAssignSetting[];
    profileId?: string | undefined;
    /** Optional FK to MetadataEntities (Type = BenchmarkCatalog).
When set, the project is linked to the named catalog for read-only benchmark reference.
Null means no benchmark catalog is linked. */
    benchmarkCatalogEntityId?: string | undefined;
    profile?: Profile | undefined;
    /** Navigation to the linked BenchmarkCatalog MetadataEntity (read-only).
Load via .Include(p => p.BenchmarkCatalogEntity) to access Name/Description
and its BenchmarkCatalogValue children. */
    benchmarkCatalogEntity?: MetadataEntity | undefined;
    /** Editable project-specific CO2e target values.
One row per scope (Whole Building + one per BenchmarkModelType).
Copied from the linked catalog on first association; independently editable thereafter. */
    projectTargets?: ProjectTarget[];

    constructor(data?: IProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : undefined as any;
            this.projectId = _data["projectId"];
            this.projectStatus = _data["projectStatus"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.floorArea = _data["floorArea"];
            this.developmentArea = _data["developmentArea"];
            this.totalArea = _data["totalArea"];
            this.climateBudgetTarget = _data["climateBudgetTarget"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
            this.goal = _data["goal"];
            this.scope = _data["scope"];
            this.userId = _data["userId"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.nonModelledElementsStatus = _data["nonModelledElementsStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["jobs"])) {
                this.jobs = [] as any;
                for (let item of _data["jobs"])
                    this.jobs!.push(Job.fromJS(item));
            }
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(Model.fromJS(item));
            }
            if (Array.isArray(_data["projectImages"])) {
                this.projectImages = [] as any;
                for (let item of _data["projectImages"])
                    this.projectImages!.push(ProjectImage.fromJS(item));
            }
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(Scenario.fromJS(item));
            }
            if (Array.isArray(_data["co2MaterialAssignSettings"])) {
                this.co2MaterialAssignSettings = [] as any;
                for (let item of _data["co2MaterialAssignSettings"])
                    this.co2MaterialAssignSettings!.push(Co2MaterialAssignSetting.fromJS(item));
            }
            this.profileId = _data["profileId"];
            this.benchmarkCatalogEntityId = _data["benchmarkCatalogEntityId"];
            this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : undefined as any;
            this.benchmarkCatalogEntity = _data["benchmarkCatalogEntity"] ? MetadataEntity.fromJS(_data["benchmarkCatalogEntity"]) : undefined as any;
            if (Array.isArray(_data["projectTargets"])) {
                this.projectTargets = [] as any;
                for (let item of _data["projectTargets"])
                    this.projectTargets!.push(ProjectTarget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Project {
        data = typeof data === 'object' ? data : {};
        let result = new Project();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : undefined as any;
        data["projectId"] = this.projectId;
        data["projectStatus"] = this.projectStatus;
        data["name"] = this.name;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["floorArea"] = this.floorArea;
        data["developmentArea"] = this.developmentArea;
        data["totalArea"] = this.totalArea;
        data["climateBudgetTarget"] = this.climateBudgetTarget;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        data["goal"] = this.goal;
        data["scope"] = this.scope;
        data["userId"] = this.userId;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["nonModelledElementsStatus"] = this.nonModelledElementsStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.jobs)) {
            data["jobs"] = [];
            for (let item of this.jobs)
                data["jobs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectImages)) {
            data["projectImages"] = [];
            for (let item of this.projectImages)
                data["projectImages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.co2MaterialAssignSettings)) {
            data["co2MaterialAssignSettings"] = [];
            for (let item of this.co2MaterialAssignSettings)
                data["co2MaterialAssignSettings"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileId"] = this.profileId;
        data["benchmarkCatalogEntityId"] = this.benchmarkCatalogEntityId;
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        data["benchmarkCatalogEntity"] = this.benchmarkCatalogEntity ? this.benchmarkCatalogEntity.toJSON() : undefined as any;
        if (Array.isArray(this.projectTargets)) {
            data["projectTargets"] = [];
            for (let item of this.projectTargets)
                data["projectTargets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProject {
    imageUrl?: string;
    projectMetadata?: ProjectMetadata | undefined;
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateBudgetTarget?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    goal?: string | undefined;
    scope?: string | undefined;
    userId?: string;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    user?: ApplicationUser;
    jobs?: Job[];
    models?: Model[];
    projectImages?: ProjectImage[];
    scenarios?: Scenario[];
    co2MaterialAssignSettings?: Co2MaterialAssignSetting[];
    profileId?: string | undefined;
    /** Optional FK to MetadataEntities (Type = BenchmarkCatalog).
When set, the project is linked to the named catalog for read-only benchmark reference.
Null means no benchmark catalog is linked. */
    benchmarkCatalogEntityId?: string | undefined;
    profile?: Profile | undefined;
    /** Navigation to the linked BenchmarkCatalog MetadataEntity (read-only).
Load via .Include(p => p.BenchmarkCatalogEntity) to access Name/Description
and its BenchmarkCatalogValue children. */
    benchmarkCatalogEntity?: MetadataEntity | undefined;
    /** Editable project-specific CO2e target values.
One row per scope (Whole Building + one per BenchmarkModelType).
Copied from the linked catalog on first association; independently editable thereafter. */
    projectTargets?: ProjectTarget[];
}

export class ProjectMetadata implements IProjectMetadata {
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    goal?: string | undefined;
    scope?: string | undefined;

    constructor(data?: IProjectMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
            this.goal = _data["goal"];
            this.scope = _data["scope"];
        }
    }

    static fromJS(data: any): ProjectMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        data["goal"] = this.goal;
        data["scope"] = this.scope;
        return data;
    }
}

export interface IProjectMetadata {
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    goal?: string | undefined;
    scope?: string | undefined;
}

export enum ProjectStatus {
    Active = "Active",
    Deleted = "Deleted",
}

/** Represents a user in the identity system */
export class IdentityUser_1 implements IIdentityUser_1 {
    /** Gets or sets the primary key for this user. */
    id?: string;
    /** Gets or sets the user name for this user. */
    userName?: string | undefined;
    /** Gets or sets the normalized user name for this user. */
    normalizedUserName?: string | undefined;
    /** Gets or sets the email address for this user. */
    email?: string | undefined;
    /** Gets or sets the normalized email address for this user. */
    normalizedEmail?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their email address. */
    emailConfirmed?: boolean;
    /** Gets or sets a salted and hashed representation of the password for this user. */
    passwordHash?: string | undefined;
    /** A random value that must change whenever a users credentials change (password changed, login removed) */
    securityStamp?: string | undefined;
    /** A random value that must change whenever a user is persisted to the store */
    concurrencyStamp?: string | undefined;
    /** Gets or sets a telephone number for the user. */
    phoneNumber?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their telephone address. */
    phoneNumberConfirmed?: boolean;
    /** Gets or sets a flag indicating if two factor authentication is enabled for this user. */
    twoFactorEnabled?: boolean;
    /** Gets or sets the date and time, in UTC, when any user lockout ends. */
    lockoutEnd?: Date | undefined;
    /** Gets or sets a flag indicating if the user could be locked out. */
    lockoutEnabled?: boolean;
    /** Gets or sets the number of failed login attempts for the current user. */
    accessFailedCount?: number;

    constructor(data?: IIdentityUser_1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.normalizedUserName = _data["normalizedUserName"];
            this.email = _data["email"];
            this.normalizedEmail = _data["normalizedEmail"];
            this.emailConfirmed = _data["emailConfirmed"];
            this.passwordHash = _data["passwordHash"];
            this.securityStamp = _data["securityStamp"];
            this.concurrencyStamp = _data["concurrencyStamp"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberConfirmed = _data["phoneNumberConfirmed"];
            this.twoFactorEnabled = _data["twoFactorEnabled"];
            this.lockoutEnd = _data["lockoutEnd"] ? new Date(_data["lockoutEnd"].toString()) : undefined as any;
            this.lockoutEnabled = _data["lockoutEnabled"];
            this.accessFailedCount = _data["accessFailedCount"];
        }
    }

    static fromJS(data: any): IdentityUser_1 {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityUser_1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        data["email"] = this.email;
        data["normalizedEmail"] = this.normalizedEmail;
        data["emailConfirmed"] = this.emailConfirmed;
        data["passwordHash"] = this.passwordHash;
        data["securityStamp"] = this.securityStamp;
        data["concurrencyStamp"] = this.concurrencyStamp;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberConfirmed"] = this.phoneNumberConfirmed;
        data["twoFactorEnabled"] = this.twoFactorEnabled;
        data["lockoutEnd"] = this.lockoutEnd ? this.lockoutEnd.toISOString() : undefined as any;
        data["lockoutEnabled"] = this.lockoutEnabled;
        data["accessFailedCount"] = this.accessFailedCount;
        return data;
    }
}

/** Represents a user in the identity system */
export interface IIdentityUser_1 {
    /** Gets or sets the primary key for this user. */
    id?: string;
    /** Gets or sets the user name for this user. */
    userName?: string | undefined;
    /** Gets or sets the normalized user name for this user. */
    normalizedUserName?: string | undefined;
    /** Gets or sets the email address for this user. */
    email?: string | undefined;
    /** Gets or sets the normalized email address for this user. */
    normalizedEmail?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their email address. */
    emailConfirmed?: boolean;
    /** Gets or sets a salted and hashed representation of the password for this user. */
    passwordHash?: string | undefined;
    /** A random value that must change whenever a users credentials change (password changed, login removed) */
    securityStamp?: string | undefined;
    /** A random value that must change whenever a user is persisted to the store */
    concurrencyStamp?: string | undefined;
    /** Gets or sets a telephone number for the user. */
    phoneNumber?: string | undefined;
    /** Gets or sets a flag indicating if a user has confirmed their telephone address. */
    phoneNumberConfirmed?: boolean;
    /** Gets or sets a flag indicating if two factor authentication is enabled for this user. */
    twoFactorEnabled?: boolean;
    /** Gets or sets the date and time, in UTC, when any user lockout ends. */
    lockoutEnd?: Date | undefined;
    /** Gets or sets a flag indicating if the user could be locked out. */
    lockoutEnabled?: boolean;
    /** Gets or sets the number of failed login attempts for the current user. */
    accessFailedCount?: number;
}

export class ApplicationUser extends IdentityUser_1 implements IApplicationUser {
    apsUserId?: string | undefined;
    firstName?: string;
    lastName?: string;
    imageUrl?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    isVerified?: boolean | undefined;
    fullName?: string;

    constructor(data?: IApplicationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.apsUserId = _data["apsUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imageUrl = _data["imageUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.isVerified = _data["isVerified"];
            this.fullName = _data["fullName"];
        }
    }

    static override fromJS(data: any): ApplicationUser {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apsUserId"] = this.apsUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imageUrl"] = this.imageUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["isVerified"] = this.isVerified;
        data["fullName"] = this.fullName;
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationUser extends IIdentityUser_1 {
    apsUserId?: string | undefined;
    firstName?: string;
    lastName?: string;
    imageUrl?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    isVerified?: boolean | undefined;
    fullName?: string;
}

export class Job implements IJob {
    jobId?: string;
    projectId?: string;
    modelId?: string;
    type?: string;
    status?: string;
    apsWorkItemId?: string;
    apsOutputFile?: string | undefined;
    debugInfo?: string | undefined;
    report?: string | undefined;
    completedAt?: Date | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    model?: Model;
    project?: Project;

    constructor(data?: IJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.apsWorkItemId = _data["apsWorkItemId"];
            this.apsOutputFile = _data["apsOutputFile"];
            this.debugInfo = _data["debugInfo"];
            this.report = _data["report"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
            this.model = _data["model"] ? Model.fromJS(_data["model"]) : undefined as any;
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
        }
    }

    static fromJS(data: any): Job {
        data = typeof data === 'object' ? data : {};
        let result = new Job();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["type"] = this.type;
        data["status"] = this.status;
        data["apsWorkItemId"] = this.apsWorkItemId;
        data["apsOutputFile"] = this.apsOutputFile;
        data["debugInfo"] = this.debugInfo;
        data["report"] = this.report;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        data["model"] = this.model ? this.model.toJSON() : undefined as any;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        return data;
    }
}

export interface IJob {
    jobId?: string;
    projectId?: string;
    modelId?: string;
    type?: string;
    status?: string;
    apsWorkItemId?: string;
    apsOutputFile?: string | undefined;
    debugInfo?: string | undefined;
    report?: string | undefined;
    completedAt?: Date | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    model?: Model;
    project?: Project;
}

export enum SoftDeleteStatusType {
    Active = "Active",
    Deleted = "Deleted",
}

export class ProjectImage implements IProjectImage {
    projectImageId?: string;
    projectId?: string;
    contentType?: string;
    data?: string;
    project?: Project;

    constructor(data?: IProjectImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectImageId = _data["projectImageId"];
            this.projectId = _data["projectId"];
            this.contentType = _data["contentType"];
            this.data = _data["data"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectImage {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectImageId"] = this.projectImageId;
        data["projectId"] = this.projectId;
        data["contentType"] = this.contentType;
        data["data"] = this.data;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectImage {
    projectImageId?: string;
    projectId?: string;
    contentType?: string;
    data?: string;
    project?: Project;
}

export class Scenario implements IScenario {
    /** Computed as: Scenario.TotalCo2 / Project.ClimateBudgetTarget */
    percentOfEmissionReductionTarget?: number;
    fullName?: string | undefined;
    scenarioMetadata?: ScenarioMetadata | undefined;
    scenarioTypeLastModifiedByUserName?: string | undefined;
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    /** Refers Metedataentities */
    projectPhaseId?: string | undefined;
    isFinalForProjectPhase?: boolean | undefined;
    /** References MetadataEntities where Type = ScenarioType. */
    scenarioTypeId?: string | undefined;
    /** Navigation property to the ScenarioType MetadataEntity. */
    scenarioTypeEntity?: MetadataEntity | undefined;
    scenarioTypeLastModifiedAt?: Date | undefined;
    scenarioTypeLastModifiedBy?: string | undefined;
    scenarioTypeChangeReason?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    project?: Project;
    materials?: Material[];
    scenarioModels?: ScenarioModel[];
    snapshots?: Snapshot[];
    profileId?: string | undefined;
    profile?: Profile | undefined;
    /** ProjectPhase in this context is a navigation property of the Scenario class, representing a link to a MetadataEntity. 
  */
    projectPhase?: MetadataEntity | undefined;

    constructor(data?: IScenario) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentOfEmissionReductionTarget = _data["percentOfEmissionReductionTarget"];
            this.fullName = _data["fullName"];
            this.scenarioMetadata = _data["scenarioMetadata"] ? ScenarioMetadata.fromJS(_data["scenarioMetadata"]) : undefined as any;
            this.scenarioTypeLastModifiedByUserName = _data["scenarioTypeLastModifiedByUserName"];
            this.scenarioId = _data["scenarioId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.nonModelledElementsStatus = _data["nonModelledElementsStatus"];
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.isFinalForProjectPhase = _data["isFinalForProjectPhase"];
            this.scenarioTypeId = _data["scenarioTypeId"];
            this.scenarioTypeEntity = _data["scenarioTypeEntity"] ? MetadataEntity.fromJS(_data["scenarioTypeEntity"]) : undefined as any;
            this.scenarioTypeLastModifiedAt = _data["scenarioTypeLastModifiedAt"] ? new Date(_data["scenarioTypeLastModifiedAt"].toString()) : undefined as any;
            this.scenarioTypeLastModifiedBy = _data["scenarioTypeLastModifiedBy"];
            this.scenarioTypeChangeReason = _data["scenarioTypeChangeReason"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(Material.fromJS(item));
            }
            if (Array.isArray(_data["scenarioModels"])) {
                this.scenarioModels = [] as any;
                for (let item of _data["scenarioModels"])
                    this.scenarioModels!.push(ScenarioModel.fromJS(item));
            }
            if (Array.isArray(_data["snapshots"])) {
                this.snapshots = [] as any;
                for (let item of _data["snapshots"])
                    this.snapshots!.push(Snapshot.fromJS(item));
            }
            this.profileId = _data["profileId"];
            this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : undefined as any;
            this.projectPhase = _data["projectPhase"] ? MetadataEntity.fromJS(_data["projectPhase"]) : undefined as any;
        }
    }

    static fromJS(data: any): Scenario {
        data = typeof data === 'object' ? data : {};
        let result = new Scenario();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentOfEmissionReductionTarget"] = this.percentOfEmissionReductionTarget;
        data["fullName"] = this.fullName;
        data["scenarioMetadata"] = this.scenarioMetadata ? this.scenarioMetadata.toJSON() : undefined as any;
        data["scenarioTypeLastModifiedByUserName"] = this.scenarioTypeLastModifiedByUserName;
        data["scenarioId"] = this.scenarioId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["nonModelledElementsStatus"] = this.nonModelledElementsStatus;
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        data["projectPhaseId"] = this.projectPhaseId;
        data["isFinalForProjectPhase"] = this.isFinalForProjectPhase;
        data["scenarioTypeId"] = this.scenarioTypeId;
        data["scenarioTypeEntity"] = this.scenarioTypeEntity ? this.scenarioTypeEntity.toJSON() : undefined as any;
        data["scenarioTypeLastModifiedAt"] = this.scenarioTypeLastModifiedAt ? this.scenarioTypeLastModifiedAt.toISOString() : undefined as any;
        data["scenarioTypeLastModifiedBy"] = this.scenarioTypeLastModifiedBy;
        data["scenarioTypeChangeReason"] = this.scenarioTypeChangeReason;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.scenarioModels)) {
            data["scenarioModels"] = [];
            for (let item of this.scenarioModels)
                data["scenarioModels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.snapshots)) {
            data["snapshots"] = [];
            for (let item of this.snapshots)
                data["snapshots"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileId"] = this.profileId;
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : undefined as any;
        return data;
    }
}

export interface IScenario {
    /** Computed as: Scenario.TotalCo2 / Project.ClimateBudgetTarget */
    percentOfEmissionReductionTarget?: number;
    fullName?: string | undefined;
    scenarioMetadata?: ScenarioMetadata | undefined;
    scenarioTypeLastModifiedByUserName?: string | undefined;
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    /** Refers Metedataentities */
    projectPhaseId?: string | undefined;
    isFinalForProjectPhase?: boolean | undefined;
    /** References MetadataEntities where Type = ScenarioType. */
    scenarioTypeId?: string | undefined;
    /** Navigation property to the ScenarioType MetadataEntity. */
    scenarioTypeEntity?: MetadataEntity | undefined;
    scenarioTypeLastModifiedAt?: Date | undefined;
    scenarioTypeLastModifiedBy?: string | undefined;
    scenarioTypeChangeReason?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    project?: Project;
    materials?: Material[];
    scenarioModels?: ScenarioModel[];
    snapshots?: Snapshot[];
    profileId?: string | undefined;
    profile?: Profile | undefined;
    /** ProjectPhase in this context is a navigation property of the Scenario class, representing a link to a MetadataEntity. 
  */
    projectPhase?: MetadataEntity | undefined;
}

export class ScenarioMetadata implements IScenarioMetadata {
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;

    constructor(data?: IScenarioMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
        }
    }

    static fromJS(data: any): ScenarioMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        return data;
    }
}

export interface IScenarioMetadata {
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
}

/** Represents a metadata entity that can participate in a hierarchy (e.g., System → Subsystem, Region → Country → State). Stores default English name/description and optional JSON metadata. */
export class MetadataEntity implements IMetadataEntity {
    /** Primary key (identity column in DB). */
    metadataEntityId?: string;
    /** Default name (English).
Translations are stored in MetadataEntityTranslations table. */
    name?: string;
    /** Type of entity (e.g., "System", "Subsystem", "Region", etc.). */
    type?: MetadataEntityType;
    /** Foreign key to the parent entity (nullable for root nodes). */
    parentId?: string | undefined;
    /** Materialized path: stores the hierarchy as a string like "/1/5/12/"
for easy subtree queries and portability across DB engines. */
    path?: string | undefined;
    description?: string | undefined;
    /** Optional structured JSON payload for entity types that require typed properties
beyond Name and Description (e.g. BenchmarkCatalogValue stores scope,
modelTypeEntityId, and valueKgCo2ePerM2 here). Null for all other types. */
    metadata?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Navigation property to the parent entity. */
    parent?: MetadataEntity | undefined;
    /** Navigation property for child entities in the hierarchy. */
    children?: MetadataEntity[];

    constructor(data?: IMetadataEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.path = _data["path"];
            this.description = _data["description"];
            this.metadata = _data["metadata"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.parent = _data["parent"] ? MetadataEntity.fromJS(_data["parent"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MetadataEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataEntity {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["path"] = this.path;
        data["description"] = this.description;
        data["metadata"] = this.metadata;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Represents a metadata entity that can participate in a hierarchy (e.g., System → Subsystem, Region → Country → State). Stores default English name/description and optional JSON metadata. */
export interface IMetadataEntity {
    /** Primary key (identity column in DB). */
    metadataEntityId?: string;
    /** Default name (English).
Translations are stored in MetadataEntityTranslations table. */
    name?: string;
    /** Type of entity (e.g., "System", "Subsystem", "Region", etc.). */
    type?: MetadataEntityType;
    /** Foreign key to the parent entity (nullable for root nodes). */
    parentId?: string | undefined;
    /** Materialized path: stores the hierarchy as a string like "/1/5/12/"
for easy subtree queries and portability across DB engines. */
    path?: string | undefined;
    description?: string | undefined;
    /** Optional structured JSON payload for entity types that require typed properties
beyond Name and Description (e.g. BenchmarkCatalogValue stores scope,
modelTypeEntityId, and valueKgCo2ePerM2 here). Null for all other types. */
    metadata?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Navigation property to the parent entity. */
    parent?: MetadataEntity | undefined;
    /** Navigation property for child entities in the hierarchy. */
    children?: MetadataEntity[];
}

export enum MetadataEntityType {
    System = "System",
    Subsystem = "Subsystem",
    Region = "Region",
    Country = "Country",
    State = "State",
    ModelFamily = "ModelFamily",
    ModelFamilyType = "ModelFamilyType",
    ProjectPhase = "ProjectPhase",
    ScenarioType = "ScenarioType",
    BenchmarkModelType = "BenchmarkModelType",
    BenchmarkCatalog = "BenchmarkCatalog",
    BenchmarkCatalogValue = "BenchmarkCatalogValue",
}

export class Material implements IMaterial {
    materialId?: string;
    modelId?: string;
    scenarioId?: string;
    parentId?: string;
    co2MaterialTypeId?: string | undefined;
    cadModelCategoryId?: string | undefined;
    type?: MaterialType;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    /** Represents the A1A2A3 TotalCo2 before A-D was added.
Now it should be the total CO2 emissions across all phases (A-D). */
    totalCo2?: number | undefined;
    cadModelCategory?: CadModelCategory;
    co2MaterialType?: Co2MaterialType;
    model?: Model;
    scenario?: Scenario;

    constructor(data?: IMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            this.parentId = _data["parentId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.type = _data["type"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
            this.cadModelCategory = _data["cadModelCategory"] ? CadModelCategory.fromJS(_data["cadModelCategory"]) : undefined as any;
            this.co2MaterialType = _data["co2MaterialType"] ? Co2MaterialType.fromJS(_data["co2MaterialType"]) : undefined as any;
            this.model = _data["model"] ? Model.fromJS(_data["model"]) : undefined as any;
            this.scenario = _data["scenario"] ? Scenario.fromJS(_data["scenario"]) : undefined as any;
        }
    }

    static fromJS(data: any): Material {
        data = typeof data === 'object' ? data : {};
        let result = new Material();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        data["parentId"] = this.parentId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["type"] = this.type;
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        data["cadModelCategory"] = this.cadModelCategory ? this.cadModelCategory.toJSON() : undefined as any;
        data["co2MaterialType"] = this.co2MaterialType ? this.co2MaterialType.toJSON() : undefined as any;
        data["model"] = this.model ? this.model.toJSON() : undefined as any;
        data["scenario"] = this.scenario ? this.scenario.toJSON() : undefined as any;
        return data;
    }
}

export interface IMaterial {
    materialId?: string;
    modelId?: string;
    scenarioId?: string;
    parentId?: string;
    co2MaterialTypeId?: string | undefined;
    cadModelCategoryId?: string | undefined;
    type?: MaterialType;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    /** Represents the A1A2A3 TotalCo2 before A-D was added.
Now it should be the total CO2 emissions across all phases (A-D). */
    totalCo2?: number | undefined;
    cadModelCategory?: CadModelCategory;
    co2MaterialType?: Co2MaterialType;
    model?: Model;
    scenario?: Scenario;
}

export enum MaterialType {
    Element = "Element",
    Component = "Component",
    PrimarySupplemental = "PrimarySupplemental",
    RebarSupplemental = "RebarSupplemental",
    NonModelledSupplemental = "NonModelledSupplemental",
    AdhocSupplemental = "AdhocSupplemental",
    Aggregate = "Aggregate",
}

export class CadModelCategory implements ICadModelCategory {
    cadModelCategoryId?: string;
    /** Name of the category */
    name?: string;
    /** Localized display label of the category */
    label?: string;
    /** Stores the enum member name of the category if available (e.g. OST_Walls) */
    key?: string | undefined;
    /** Stores the enum value of the category if available (e.g. -2000011) */
    value?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: ICadModelCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): CadModelCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CadModelCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["name"] = this.name;
        data["label"] = this.label;
        data["key"] = this.key;
        data["value"] = this.value;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface ICadModelCategory {
    cadModelCategoryId?: string;
    /** Name of the category */
    name?: string;
    /** Localized display label of the category */
    label?: string;
    /** Stores the enum member name of the category if available (e.g. OST_Walls) */
    key?: string | undefined;
    /** Stores the enum value of the category if available (e.g. -2000011) */
    value?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
}

export class Co2MaterialType implements ICo2MaterialType {
    co2MaterialTypeId?: string;
    co2MaterialCategoryId?: string;
    co2MaterialLibraryId?: string;
    externalId?: string | undefined;
    name?: string;
    description?: string | undefined;
    unit?: string;
    displayUnit?: string | undefined;
    category?: string | undefined;
    categoryName?: string | undefined;
    dateOfIssue?: Date | undefined;
    declarationUrl?: string | undefined;
    declaredUnit?: string | undefined;
    epdCount?: number | undefined;
    genericEstimateCount?: number | undefined;
    jurisdiction?: string | undefined;
    language?: string | undefined;
    link?: string | undefined;
    manufacturerName?: string | undefined;
    manufacturerUrl?: string | undefined;
    qty?: number | undefined;
    validUntil?: Date | undefined;
    co2sequestration?: string | undefined;
    co2sequestrationSource?: string | undefined;
    methodologyType?: string | undefined;
    resource?: string | undefined;
    source?: string | undefined;
    sourceData?: string | undefined;
    a1A2A3?: number | undefined;
    a1A2A3_ECF?: number | undefined;
    a4?: number | undefined;
    a4_ECF?: number | undefined;
    a5?: number | undefined;
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    unitQuantity?: number | undefined;
    density?: number | undefined;
    densityType?: DensityType | undefined;
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    approvedAt?: Date | undefined;
    rejectedAt?: Date | undefined;
    approvedBy?: string | undefined;
    rejectedBy?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    version?: number;
    versionStatus?: VersionStatusType;
    deleteStatus?: SoftDeleteStatusType;
    co2MaterialCategory?: Co2MaterialCategory;
    co2MaterialLibrary?: Co2MaterialLibrary;
    cadMaterialsCo2MaterialTypes?: CadMaterialsCo2MaterialType[];
    materials?: Material[];
    isDeleted?: boolean;

    constructor(data?: ICo2MaterialType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.unitQuantity = 1;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.co2MaterialCategoryId = _data["co2MaterialCategoryId"];
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.displayUnit = _data["displayUnit"];
            this.category = _data["category"];
            this.categoryName = _data["categoryName"];
            this.dateOfIssue = _data["dateOfIssue"] ? new Date(_data["dateOfIssue"].toString()) : undefined as any;
            this.declarationUrl = _data["declarationUrl"];
            this.declaredUnit = _data["declaredUnit"];
            this.epdCount = _data["epdCount"];
            this.genericEstimateCount = _data["genericEstimateCount"];
            this.jurisdiction = _data["jurisdiction"];
            this.language = _data["language"];
            this.link = _data["link"];
            this.manufacturerName = _data["manufacturerName"];
            this.manufacturerUrl = _data["manufacturerUrl"];
            this.qty = _data["qty"];
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : undefined as any;
            this.co2sequestration = _data["co2sequestration"];
            this.co2sequestrationSource = _data["co2sequestrationSource"];
            this.methodologyType = _data["methodologyType"];
            this.resource = _data["resource"];
            this.source = _data["source"];
            this.sourceData = _data["sourceData"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a1A2A3_ECF = _data["a1A2A3_ECF"];
            this.a4 = _data["a4"];
            this.a4_ECF = _data["a4_ECF"];
            this.a5 = _data["a5"];
            this.a5_ECF = _data["a5_ECF"];
            this.b1 = _data["b1"];
            this.b1_ECF = _data["b1_ECF"];
            this.b2 = _data["b2"];
            this.b2_ECF = _data["b2_ECF"];
            this.b3 = _data["b3"];
            this.b3_ECF = _data["b3_ECF"];
            this.b4 = _data["b4"];
            this.b4_ECF = _data["b4_ECF"];
            this.b5 = _data["b5"];
            this.b5_ECF = _data["b5_ECF"];
            this.b6 = _data["b6"];
            this.b6_ECF = _data["b6_ECF"];
            this.b7 = _data["b7"];
            this.b7_ECF = _data["b7_ECF"];
            this.c1 = _data["c1"];
            this.c1_ECF = _data["c1_ECF"];
            this.c2 = _data["c2"];
            this.c2_ECF = _data["c2_ECF"];
            this.c3 = _data["c3"];
            this.c3_ECF = _data["c3_ECF"];
            this.c4 = _data["c4"];
            this.c4_ECF = _data["c4_ECF"];
            this.d = _data["d"];
            this.d_ECF = _data["d_ECF"];
            this.biogenic = _data["biogenic"];
            this.biogenic_ECF = _data["biogenic_ECF"];
            this.wastage = _data["wastage"];
            this.unitQuantity = _data["unitQuantity"] !== undefined ? _data["unitQuantity"] : 1;
            this.density = _data["density"];
            this.densityType = _data["densityType"];
            this.massPerUnit = _data["massPerUnit"];
            this.omniClassNumber = _data["omniClassNumber"];
            this.omniClassTitle = _data["omniClassTitle"];
            this.uniFormatNumber = _data["uniFormatNumber"];
            this.uniFormatTitle = _data["uniFormatTitle"];
            this.masterFormatNumber = _data["masterFormatNumber"];
            this.masterFormatTitle = _data["masterFormatTitle"];
            this.approvedAt = _data["approvedAt"] ? new Date(_data["approvedAt"].toString()) : undefined as any;
            this.rejectedAt = _data["rejectedAt"] ? new Date(_data["rejectedAt"].toString()) : undefined as any;
            this.approvedBy = _data["approvedBy"];
            this.rejectedBy = _data["rejectedBy"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.version = _data["version"];
            this.versionStatus = _data["versionStatus"];
            this.deleteStatus = _data["deleteStatus"];
            this.co2MaterialCategory = _data["co2MaterialCategory"] ? Co2MaterialCategory.fromJS(_data["co2MaterialCategory"]) : undefined as any;
            this.co2MaterialLibrary = _data["co2MaterialLibrary"] ? Co2MaterialLibrary.fromJS(_data["co2MaterialLibrary"]) : undefined as any;
            if (Array.isArray(_data["cadMaterialsCo2MaterialTypes"])) {
                this.cadMaterialsCo2MaterialTypes = [] as any;
                for (let item of _data["cadMaterialsCo2MaterialTypes"])
                    this.cadMaterialsCo2MaterialTypes!.push(CadMaterialsCo2MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["materials"])) {
                this.materials = [] as any;
                for (let item of _data["materials"])
                    this.materials!.push(Material.fromJS(item));
            }
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): Co2MaterialType {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["co2MaterialCategoryId"] = this.co2MaterialCategoryId;
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["displayUnit"] = this.displayUnit;
        data["category"] = this.category;
        data["categoryName"] = this.categoryName;
        data["dateOfIssue"] = this.dateOfIssue ? this.dateOfIssue.toISOString() : undefined as any;
        data["declarationUrl"] = this.declarationUrl;
        data["declaredUnit"] = this.declaredUnit;
        data["epdCount"] = this.epdCount;
        data["genericEstimateCount"] = this.genericEstimateCount;
        data["jurisdiction"] = this.jurisdiction;
        data["language"] = this.language;
        data["link"] = this.link;
        data["manufacturerName"] = this.manufacturerName;
        data["manufacturerUrl"] = this.manufacturerUrl;
        data["qty"] = this.qty;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : undefined as any;
        data["co2sequestration"] = this.co2sequestration;
        data["co2sequestrationSource"] = this.co2sequestrationSource;
        data["methodologyType"] = this.methodologyType;
        data["resource"] = this.resource;
        data["source"] = this.source;
        data["sourceData"] = this.sourceData;
        data["a1A2A3"] = this.a1A2A3;
        data["a1A2A3_ECF"] = this.a1A2A3_ECF;
        data["a4"] = this.a4;
        data["a4_ECF"] = this.a4_ECF;
        data["a5"] = this.a5;
        data["a5_ECF"] = this.a5_ECF;
        data["b1"] = this.b1;
        data["b1_ECF"] = this.b1_ECF;
        data["b2"] = this.b2;
        data["b2_ECF"] = this.b2_ECF;
        data["b3"] = this.b3;
        data["b3_ECF"] = this.b3_ECF;
        data["b4"] = this.b4;
        data["b4_ECF"] = this.b4_ECF;
        data["b5"] = this.b5;
        data["b5_ECF"] = this.b5_ECF;
        data["b6"] = this.b6;
        data["b6_ECF"] = this.b6_ECF;
        data["b7"] = this.b7;
        data["b7_ECF"] = this.b7_ECF;
        data["c1"] = this.c1;
        data["c1_ECF"] = this.c1_ECF;
        data["c2"] = this.c2;
        data["c2_ECF"] = this.c2_ECF;
        data["c3"] = this.c3;
        data["c3_ECF"] = this.c3_ECF;
        data["c4"] = this.c4;
        data["c4_ECF"] = this.c4_ECF;
        data["d"] = this.d;
        data["d_ECF"] = this.d_ECF;
        data["biogenic"] = this.biogenic;
        data["biogenic_ECF"] = this.biogenic_ECF;
        data["wastage"] = this.wastage;
        data["unitQuantity"] = this.unitQuantity;
        data["density"] = this.density;
        data["densityType"] = this.densityType;
        data["massPerUnit"] = this.massPerUnit;
        data["omniClassNumber"] = this.omniClassNumber;
        data["omniClassTitle"] = this.omniClassTitle;
        data["uniFormatNumber"] = this.uniFormatNumber;
        data["uniFormatTitle"] = this.uniFormatTitle;
        data["masterFormatNumber"] = this.masterFormatNumber;
        data["masterFormatTitle"] = this.masterFormatTitle;
        data["approvedAt"] = this.approvedAt ? this.approvedAt.toISOString() : undefined as any;
        data["rejectedAt"] = this.rejectedAt ? this.rejectedAt.toISOString() : undefined as any;
        data["approvedBy"] = this.approvedBy;
        data["rejectedBy"] = this.rejectedBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["version"] = this.version;
        data["versionStatus"] = this.versionStatus;
        data["deleteStatus"] = this.deleteStatus;
        data["co2MaterialCategory"] = this.co2MaterialCategory ? this.co2MaterialCategory.toJSON() : undefined as any;
        data["co2MaterialLibrary"] = this.co2MaterialLibrary ? this.co2MaterialLibrary.toJSON() : undefined as any;
        if (Array.isArray(this.cadMaterialsCo2MaterialTypes)) {
            data["cadMaterialsCo2MaterialTypes"] = [];
            for (let item of this.cadMaterialsCo2MaterialTypes)
                data["cadMaterialsCo2MaterialTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.materials)) {
            data["materials"] = [];
            for (let item of this.materials)
                data["materials"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICo2MaterialType {
    co2MaterialTypeId?: string;
    co2MaterialCategoryId?: string;
    co2MaterialLibraryId?: string;
    externalId?: string | undefined;
    name?: string;
    description?: string | undefined;
    unit?: string;
    displayUnit?: string | undefined;
    category?: string | undefined;
    categoryName?: string | undefined;
    dateOfIssue?: Date | undefined;
    declarationUrl?: string | undefined;
    declaredUnit?: string | undefined;
    epdCount?: number | undefined;
    genericEstimateCount?: number | undefined;
    jurisdiction?: string | undefined;
    language?: string | undefined;
    link?: string | undefined;
    manufacturerName?: string | undefined;
    manufacturerUrl?: string | undefined;
    qty?: number | undefined;
    validUntil?: Date | undefined;
    co2sequestration?: string | undefined;
    co2sequestrationSource?: string | undefined;
    methodologyType?: string | undefined;
    resource?: string | undefined;
    source?: string | undefined;
    sourceData?: string | undefined;
    a1A2A3?: number | undefined;
    a1A2A3_ECF?: number | undefined;
    a4?: number | undefined;
    a4_ECF?: number | undefined;
    a5?: number | undefined;
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    unitQuantity?: number | undefined;
    density?: number | undefined;
    densityType?: DensityType | undefined;
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    approvedAt?: Date | undefined;
    rejectedAt?: Date | undefined;
    approvedBy?: string | undefined;
    rejectedBy?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    version?: number;
    versionStatus?: VersionStatusType;
    deleteStatus?: SoftDeleteStatusType;
    co2MaterialCategory?: Co2MaterialCategory;
    co2MaterialLibrary?: Co2MaterialLibrary;
    cadMaterialsCo2MaterialTypes?: CadMaterialsCo2MaterialType[];
    materials?: Material[];
    isDeleted?: boolean;
}

export enum DensityType {
    Area = "Area",
    Volume = "Volume",
}

export enum VersionStatusType {
    Active = "Active",
    Archived = "Archived",
}

export class Co2MaterialCategory implements ICo2MaterialCategory {
    co2MaterialCategoryId?: string;
    id?: number;
    path?: string;
    name?: string;
    description?: string | undefined;
    source?: string | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    unspsc?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;

    constructor(data?: ICo2MaterialCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialCategoryId = _data["co2MaterialCategoryId"];
            this.id = _data["id"];
            this.path = _data["path"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.omniClassNumber = _data["omniClassNumber"];
            this.omniClassTitle = _data["omniClassTitle"];
            this.uniFormatNumber = _data["uniFormatNumber"];
            this.uniFormatTitle = _data["uniFormatTitle"];
            this.masterFormatNumber = _data["masterFormatNumber"];
            this.masterFormatTitle = _data["masterFormatTitle"];
            this.unspsc = _data["unspsc"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): Co2MaterialCategory {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialCategoryId"] = this.co2MaterialCategoryId;
        data["id"] = this.id;
        data["path"] = this.path;
        data["name"] = this.name;
        data["description"] = this.description;
        data["source"] = this.source;
        data["omniClassNumber"] = this.omniClassNumber;
        data["omniClassTitle"] = this.omniClassTitle;
        data["uniFormatNumber"] = this.uniFormatNumber;
        data["uniFormatTitle"] = this.uniFormatTitle;
        data["masterFormatNumber"] = this.masterFormatNumber;
        data["masterFormatTitle"] = this.masterFormatTitle;
        data["unspsc"] = this.unspsc;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ICo2MaterialCategory {
    co2MaterialCategoryId?: string;
    id?: number;
    path?: string;
    name?: string;
    description?: string | undefined;
    source?: string | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    unspsc?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
}

export class Co2MaterialLibrary implements ICo2MaterialLibrary {
    co2MaterialLibraryId?: string;
    isDefault?: boolean;
    name?: string;
    description?: string | undefined;
    materialLibraryType?: MaterialLibraryType;
    isLazyLoading?: boolean;
    pageSize?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    co2MaterialTypes?: Co2MaterialType[];

    constructor(data?: ICo2MaterialLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.isDefault = _data["isDefault"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.materialLibraryType = _data["materialLibraryType"];
            this.isLazyLoading = _data["isLazyLoading"];
            this.pageSize = _data["pageSize"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["co2MaterialTypes"])) {
                this.co2MaterialTypes = [] as any;
                for (let item of _data["co2MaterialTypes"])
                    this.co2MaterialTypes!.push(Co2MaterialType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Co2MaterialLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["isDefault"] = this.isDefault;
        data["name"] = this.name;
        data["description"] = this.description;
        data["materialLibraryType"] = this.materialLibraryType;
        data["isLazyLoading"] = this.isLazyLoading;
        data["pageSize"] = this.pageSize;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.co2MaterialTypes)) {
            data["co2MaterialTypes"] = [];
            for (let item of this.co2MaterialTypes)
                data["co2MaterialTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICo2MaterialLibrary {
    co2MaterialLibraryId?: string;
    isDefault?: boolean;
    name?: string;
    description?: string | undefined;
    materialLibraryType?: MaterialLibraryType;
    isLazyLoading?: boolean;
    pageSize?: number | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    co2MaterialTypes?: Co2MaterialType[];
}

export enum MaterialLibraryType {
    PrimarySQL = "PrimarySQL",
    RemoteSQL = "RemoteSQL",
    RemoteAPI = "RemoteAPI",
}

export class CadMaterialsCo2MaterialType implements ICadMaterialsCo2MaterialType {
    cadMaterialCo2MaterialTypeId?: string;
    cadMaterialId?: string;
    co2MaterialTypeId?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    cadMaterial?: CadMaterial;
    co2MaterialType?: Co2MaterialType;

    constructor(data?: ICadMaterialsCo2MaterialType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadMaterialCo2MaterialTypeId = _data["cadMaterialCo2MaterialTypeId"];
            this.cadMaterialId = _data["cadMaterialId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.cadMaterial = _data["cadMaterial"] ? CadMaterial.fromJS(_data["cadMaterial"]) : undefined as any;
            this.co2MaterialType = _data["co2MaterialType"] ? Co2MaterialType.fromJS(_data["co2MaterialType"]) : undefined as any;
        }
    }

    static fromJS(data: any): CadMaterialsCo2MaterialType {
        data = typeof data === 'object' ? data : {};
        let result = new CadMaterialsCo2MaterialType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadMaterialCo2MaterialTypeId"] = this.cadMaterialCo2MaterialTypeId;
        data["cadMaterialId"] = this.cadMaterialId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["cadMaterial"] = this.cadMaterial ? this.cadMaterial.toJSON() : undefined as any;
        data["co2MaterialType"] = this.co2MaterialType ? this.co2MaterialType.toJSON() : undefined as any;
        return data;
    }
}

export interface ICadMaterialsCo2MaterialType {
    cadMaterialCo2MaterialTypeId?: string;
    cadMaterialId?: string;
    co2MaterialTypeId?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    cadMaterial?: CadMaterial;
    co2MaterialType?: Co2MaterialType;
}

export class CadMaterial implements ICadMaterial {
    cadMaterialId?: string;
    name?: string;
    authoringTool?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    cadMaterialsCo2MaterialTypes?: CadMaterialsCo2MaterialType[];

    constructor(data?: ICadMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadMaterialId = _data["cadMaterialId"];
            this.name = _data["name"];
            this.authoringTool = _data["authoringTool"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["cadMaterialsCo2MaterialTypes"])) {
                this.cadMaterialsCo2MaterialTypes = [] as any;
                for (let item of _data["cadMaterialsCo2MaterialTypes"])
                    this.cadMaterialsCo2MaterialTypes!.push(CadMaterialsCo2MaterialType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CadMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new CadMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadMaterialId"] = this.cadMaterialId;
        data["name"] = this.name;
        data["authoringTool"] = this.authoringTool;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.cadMaterialsCo2MaterialTypes)) {
            data["cadMaterialsCo2MaterialTypes"] = [];
            for (let item of this.cadMaterialsCo2MaterialTypes)
                data["cadMaterialsCo2MaterialTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICadMaterial {
    cadMaterialId?: string;
    name?: string;
    authoringTool?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    cadMaterialsCo2MaterialTypes?: CadMaterialsCo2MaterialType[];
}

export class ScenarioModel implements IScenarioModel {
    percentageAssign?: number;
    scenarioModelId?: string;
    scenarioId?: string;
    modelId?: string;
    active?: boolean;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
    materialCount?: number;
    supplementalCount?: number;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    model?: Model;
    scenario?: Scenario;

    constructor(data?: IScenarioModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentageAssign = _data["percentageAssign"];
            this.scenarioModelId = _data["scenarioModelId"];
            this.scenarioId = _data["scenarioId"];
            this.modelId = _data["modelId"];
            this.active = _data["active"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
            this.materialCount = _data["materialCount"];
            this.supplementalCount = _data["supplementalCount"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.nonModelledElementsStatus = _data["nonModelledElementsStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.model = _data["model"] ? Model.fromJS(_data["model"]) : undefined as any;
            this.scenario = _data["scenario"] ? Scenario.fromJS(_data["scenario"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScenarioModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentageAssign"] = this.percentageAssign;
        data["scenarioModelId"] = this.scenarioModelId;
        data["scenarioId"] = this.scenarioId;
        data["modelId"] = this.modelId;
        data["active"] = this.active;
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        data["materialCount"] = this.materialCount;
        data["supplementalCount"] = this.supplementalCount;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["nonModelledElementsStatus"] = this.nonModelledElementsStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["model"] = this.model ? this.model.toJSON() : undefined as any;
        data["scenario"] = this.scenario ? this.scenario.toJSON() : undefined as any;
        return data;
    }
}

export interface IScenarioModel {
    percentageAssign?: number;
    scenarioModelId?: string;
    scenarioId?: string;
    modelId?: string;
    active?: boolean;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
    materialCount?: number;
    supplementalCount?: number;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    model?: Model;
    scenario?: Scenario;
}

export class Snapshot implements ISnapshot {
    snapshotId?: string;
    scenarioId?: string;
    totalCo2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    scenario?: Scenario;

    constructor(data?: ISnapshot) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.snapshotId = _data["snapshotId"];
            this.scenarioId = _data["scenarioId"];
            this.totalCo2 = _data["totalCo2"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.scenario = _data["scenario"] ? Scenario.fromJS(_data["scenario"]) : undefined as any;
        }
    }

    static fromJS(data: any): Snapshot {
        data = typeof data === 'object' ? data : {};
        let result = new Snapshot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["snapshotId"] = this.snapshotId;
        data["scenarioId"] = this.scenarioId;
        data["totalCo2"] = this.totalCo2;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["scenario"] = this.scenario ? this.scenario.toJSON() : undefined as any;
        return data;
    }
}

export interface ISnapshot {
    snapshotId?: string;
    scenarioId?: string;
    totalCo2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    scenario?: Scenario;
}

export class Profile implements IProfile {
    profileId?: string;
    name!: string;
    description?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    rebarEstimationStatus?: RebarEstimationStatus;
    profileLevelType?: ProfileLevelType;
    configuration?: string | undefined;
    isDeleted?: boolean;
    modelCommands?: ModelCommand[] | undefined;

    constructor(data?: IProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.deleteStatus = _data["deleteStatus"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.profileLevelType = _data["profileLevelType"];
            this.configuration = _data["configuration"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["modelCommands"])) {
                this.modelCommands = [] as any;
                for (let item of _data["modelCommands"])
                    this.modelCommands!.push(ModelCommand.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Profile {
        data = typeof data === 'object' ? data : {};
        let result = new Profile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["deleteStatus"] = this.deleteStatus;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["profileLevelType"] = this.profileLevelType;
        data["configuration"] = this.configuration;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.modelCommands)) {
            data["modelCommands"] = [];
            for (let item of this.modelCommands)
                data["modelCommands"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfile {
    profileId?: string;
    name: string;
    description?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    rebarEstimationStatus?: RebarEstimationStatus;
    profileLevelType?: ProfileLevelType;
    configuration?: string | undefined;
    isDeleted?: boolean;
    modelCommands?: ModelCommand[] | undefined;
}

export enum ProfileLevelType {
    Application = "Application",
    Project = "Project",
    Scenario = "Scenario",
}

/** ModelCommand */
export class ModelCommand implements IModelCommand {
    /** Primary key for this table */
    modelCommandId?: string;
    /** Name Indicates the Name of the This command */
    name?: string | undefined;
    /** Description Indicates the Purpose of this ModelCommand */
    description?: string | undefined;
    /** CommandType Indicates the category of command */
    modelCommandType?: string;
    /** Arguments holds the JSON configuration for Filter Selection */
    arguments?: string | undefined;
    /** Captures the time an object of this entity is inserted */
    createdAt?: Date;
    /** Captures the name of the person by whom a record of this entity is inserted */
    createdBy?: string | undefined;
    /** Captures the time a record of this entity is last modified */
    modifiedAt?: Date;
    /** Captures the name of the person by whom a record of this entity is last modified */
    modifiedBy?: string | undefined;
    /** Indicates if a command is Active or Inactive */
    status?: number;
    profileId?: string | undefined;
    profile?: Profile | undefined;

    constructor(data?: IModelCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelCommandId = _data["modelCommandId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.modelCommandType = _data["modelCommandType"];
            this.arguments = _data["arguments"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.status = _data["status"];
            this.profileId = _data["profileId"];
            this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : undefined as any;
        }
    }

    static fromJS(data: any): ModelCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ModelCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelCommandId"] = this.modelCommandId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["modelCommandType"] = this.modelCommandType;
        data["arguments"] = this.arguments;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["status"] = this.status;
        data["profileId"] = this.profileId;
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        return data;
    }
}

/** ModelCommand */
export interface IModelCommand {
    /** Primary key for this table */
    modelCommandId?: string;
    /** Name Indicates the Name of the This command */
    name?: string | undefined;
    /** Description Indicates the Purpose of this ModelCommand */
    description?: string | undefined;
    /** CommandType Indicates the category of command */
    modelCommandType?: string;
    /** Arguments holds the JSON configuration for Filter Selection */
    arguments?: string | undefined;
    /** Captures the time an object of this entity is inserted */
    createdAt?: Date;
    /** Captures the name of the person by whom a record of this entity is inserted */
    createdBy?: string | undefined;
    /** Captures the time a record of this entity is last modified */
    modifiedAt?: Date;
    /** Captures the name of the person by whom a record of this entity is last modified */
    modifiedBy?: string | undefined;
    /** Indicates if a command is Active or Inactive */
    status?: number;
    profileId?: string | undefined;
    profile?: Profile | undefined;
}

/** Entity class for CO2_MaterialAssignSettings table */
export class Co2MaterialAssignSetting implements ICo2MaterialAssignSetting {
    /** Primary key for this table */
    co2MaterialAssignSettingId?: string;
    co2MaterialSettingType!: Co2MaterialSettingType;
    /** Container to hold the Setting Name like Global,Region-Global */
    name!: string;
    /** Description about this setting */
    description?: string | undefined;
    /** Maps to UserId in case of user Level setting and is a foreign key in this entity */
    userId?: string | undefined;
    /** Maps to Project and is a foreign key in this entity */
    projectId?: string | undefined;
    /** Refers to Project object */
    project?: Project | undefined;
    /** Maps to Scenario and is a foreign key in this entity */
    scenarioId?: string | undefined;
    /** Refers to Scenario object */
    scenario?: Scenario | undefined;
    /** Maps to ScenarioModel and is a foreign key in this entity */
    scenarioModelId?: string | undefined;
    /** Refers to Scenario Model object */
    scenarioModel?: ScenarioModel | undefined;
    /** Container to capture the state of Setting */
    status!: string;
    /** Maps to ProfileID  */
    profileId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Maps to List of Setting Items  */
    co2MaterialAssignSettingsItems?: Co2MaterialAssignSettingsItem[];

    constructor(data?: ICo2MaterialAssignSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.co2MaterialSettingType = _data["co2MaterialSettingType"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            this.scenarioId = _data["scenarioId"];
            this.scenario = _data["scenario"] ? Scenario.fromJS(_data["scenario"]) : undefined as any;
            this.scenarioModelId = _data["scenarioModelId"];
            this.scenarioModel = _data["scenarioModel"] ? ScenarioModel.fromJS(_data["scenarioModel"]) : undefined as any;
            this.status = _data["status"];
            this.profileId = _data["profileId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["co2MaterialAssignSettingsItems"])) {
                this.co2MaterialAssignSettingsItems = [] as any;
                for (let item of _data["co2MaterialAssignSettingsItems"])
                    this.co2MaterialAssignSettingsItems!.push(Co2MaterialAssignSettingsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Co2MaterialAssignSetting {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialAssignSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["co2MaterialSettingType"] = this.co2MaterialSettingType;
        data["name"] = this.name;
        data["description"] = this.description;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["scenarioId"] = this.scenarioId;
        data["scenario"] = this.scenario ? this.scenario.toJSON() : undefined as any;
        data["scenarioModelId"] = this.scenarioModelId;
        data["scenarioModel"] = this.scenarioModel ? this.scenarioModel.toJSON() : undefined as any;
        data["status"] = this.status;
        data["profileId"] = this.profileId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.co2MaterialAssignSettingsItems)) {
            data["co2MaterialAssignSettingsItems"] = [];
            for (let item of this.co2MaterialAssignSettingsItems)
                data["co2MaterialAssignSettingsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Entity class for CO2_MaterialAssignSettings table */
export interface ICo2MaterialAssignSetting {
    /** Primary key for this table */
    co2MaterialAssignSettingId?: string;
    co2MaterialSettingType: Co2MaterialSettingType;
    /** Container to hold the Setting Name like Global,Region-Global */
    name: string;
    /** Description about this setting */
    description?: string | undefined;
    /** Maps to UserId in case of user Level setting and is a foreign key in this entity */
    userId?: string | undefined;
    /** Maps to Project and is a foreign key in this entity */
    projectId?: string | undefined;
    /** Refers to Project object */
    project?: Project | undefined;
    /** Maps to Scenario and is a foreign key in this entity */
    scenarioId?: string | undefined;
    /** Refers to Scenario object */
    scenario?: Scenario | undefined;
    /** Maps to ScenarioModel and is a foreign key in this entity */
    scenarioModelId?: string | undefined;
    /** Refers to Scenario Model object */
    scenarioModel?: ScenarioModel | undefined;
    /** Container to capture the state of Setting */
    status: string;
    /** Maps to ProfileID  */
    profileId?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Maps to List of Setting Items  */
    co2MaterialAssignSettingsItems?: Co2MaterialAssignSettingsItem[];
}

export enum Co2MaterialSettingType {
    Global = "Global",
    Project = "Project",
    Scenario = "Scenario",
    Profile = "Profile",
}

/** Entity class for CO2_MaterialAssignSettingsItems table */
export class Co2MaterialAssignSettingsItem implements ICo2MaterialAssignSettingsItem {
    /** Primary key for this table */
    co2MaterialAssignSettingsItemId?: string;
    /** Maps to Co2MaterialAssignSettingId and is a foreign key in this entity  */
    co2MaterialAssignSettingId?: string | undefined;
    /** Refers to CO2MaterialAssignSetting object */
    co2MaterialAssignSetting?: Co2MaterialAssignSetting;
    /** Maps to Cad_ModelCategory and is a foreign key in this entity */
    cadModelCategoryId?: string;
    /** Refers to Cad_ModelCategory object */
    cadModelCategory?: CadModelCategory;
    /** Maps to Co2Material Type and is a foreign key in this entity */
    co2MaterialTypeId?: string | undefined;
    /** Refers to Co2MaterialType object */
    co2MaterialType?: Co2MaterialType;
    /** Container to capture the Rebar value for a combination of CadModelCategory and Co2MaterialType */
    value?: string | undefined;
    /** Holds the type of Rebar value(Amount/Percent) */
    valueType?: string | undefined;
    /** low limit */
    lowLimit?: string | undefined;
    /** high limit */
    highLimit?: string | undefined;
    rowVersion?: string;
    /** Holds the status of an Item.Usually used for Soft Delete */
    status?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: ICo2MaterialAssignSettingsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingsItemId = _data["co2MaterialAssignSettingsItemId"];
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.co2MaterialAssignSetting = _data["co2MaterialAssignSetting"] ? Co2MaterialAssignSetting.fromJS(_data["co2MaterialAssignSetting"]) : undefined as any;
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.cadModelCategory = _data["cadModelCategory"] ? CadModelCategory.fromJS(_data["cadModelCategory"]) : undefined as any;
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.co2MaterialType = _data["co2MaterialType"] ? Co2MaterialType.fromJS(_data["co2MaterialType"]) : undefined as any;
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.lowLimit = _data["lowLimit"];
            this.highLimit = _data["highLimit"];
            this.rowVersion = _data["rowVersion"];
            this.status = _data["status"];
            this.isRebarFilterByMaterialsEnabled = _data["isRebarFilterByMaterialsEnabled"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): Co2MaterialAssignSettingsItem {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialAssignSettingsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingsItemId"] = this.co2MaterialAssignSettingsItemId;
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["co2MaterialAssignSetting"] = this.co2MaterialAssignSetting ? this.co2MaterialAssignSetting.toJSON() : undefined as any;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["cadModelCategory"] = this.cadModelCategory ? this.cadModelCategory.toJSON() : undefined as any;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["co2MaterialType"] = this.co2MaterialType ? this.co2MaterialType.toJSON() : undefined as any;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["lowLimit"] = this.lowLimit;
        data["highLimit"] = this.highLimit;
        data["rowVersion"] = this.rowVersion;
        data["status"] = this.status;
        data["isRebarFilterByMaterialsEnabled"] = this.isRebarFilterByMaterialsEnabled;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

/** Entity class for CO2_MaterialAssignSettingsItems table */
export interface ICo2MaterialAssignSettingsItem {
    /** Primary key for this table */
    co2MaterialAssignSettingsItemId?: string;
    /** Maps to Co2MaterialAssignSettingId and is a foreign key in this entity  */
    co2MaterialAssignSettingId?: string | undefined;
    /** Refers to CO2MaterialAssignSetting object */
    co2MaterialAssignSetting?: Co2MaterialAssignSetting;
    /** Maps to Cad_ModelCategory and is a foreign key in this entity */
    cadModelCategoryId?: string;
    /** Refers to Cad_ModelCategory object */
    cadModelCategory?: CadModelCategory;
    /** Maps to Co2Material Type and is a foreign key in this entity */
    co2MaterialTypeId?: string | undefined;
    /** Refers to Co2MaterialType object */
    co2MaterialType?: Co2MaterialType;
    /** Container to capture the Rebar value for a combination of CadModelCategory and Co2MaterialType */
    value?: string | undefined;
    /** Holds the type of Rebar value(Amount/Percent) */
    valueType?: string | undefined;
    /** low limit */
    lowLimit?: string | undefined;
    /** high limit */
    highLimit?: string | undefined;
    rowVersion?: string;
    /** Holds the status of an Item.Usually used for Soft Delete */
    status?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
}

/** Stores project-specific editable CO2e target values per scope. One row for Whole Building (ModelTypeEntityId = null) and one row per BenchmarkModelType (ModelTypeEntityId = FK to MetadataEntities).            Rows are initially copied from the linked BenchmarkCatalog's values when a catalog is first associated with the project. They are then independently editable without affecting the source catalog. */
export class ProjectTarget implements IProjectTarget {
    projectTargetId?: string;
    /** FK to Projects. */
    projectId?: string;
    /** Scope of this target value.
Use constants: "WholeBuilding" or "ModelType". */
    scope?: string;
    /** FK to MetadataEntities (Type = BenchmarkModelType).
Null when Scope = "WholeBuilding". */
    modelTypeEntityId?: string | undefined;
    /** Target value in kgCO2e/m². */
    valueKgCo2ePerM2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Navigation to the owning project. */
    project?: Project;
    /** Navigation to the BenchmarkModelType MetadataEntity.
Null when Scope = "WholeBuilding".
Use .Include(t => t.ModelTypeEntity) to resolve the display name. */
    modelTypeEntity?: MetadataEntity | undefined;

    constructor(data?: IProjectTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTargetId = _data["projectTargetId"];
            this.projectId = _data["projectId"];
            this.scope = _data["scope"];
            this.modelTypeEntityId = _data["modelTypeEntityId"];
            this.valueKgCo2ePerM2 = _data["valueKgCo2ePerM2"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.project = _data["project"] ? Project.fromJS(_data["project"]) : undefined as any;
            this.modelTypeEntity = _data["modelTypeEntity"] ? MetadataEntity.fromJS(_data["modelTypeEntity"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTarget {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTargetId"] = this.projectTargetId;
        data["projectId"] = this.projectId;
        data["scope"] = this.scope;
        data["modelTypeEntityId"] = this.modelTypeEntityId;
        data["valueKgCo2ePerM2"] = this.valueKgCo2ePerM2;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["project"] = this.project ? this.project.toJSON() : undefined as any;
        data["modelTypeEntity"] = this.modelTypeEntity ? this.modelTypeEntity.toJSON() : undefined as any;
        return data;
    }
}

/** Stores project-specific editable CO2e target values per scope. One row for Whole Building (ModelTypeEntityId = null) and one row per BenchmarkModelType (ModelTypeEntityId = FK to MetadataEntities).            Rows are initially copied from the linked BenchmarkCatalog's values when a catalog is first associated with the project. They are then independently editable without affecting the source catalog. */
export interface IProjectTarget {
    projectTargetId?: string;
    /** FK to Projects. */
    projectId?: string;
    /** Scope of this target value.
Use constants: "WholeBuilding" or "ModelType". */
    scope?: string;
    /** FK to MetadataEntities (Type = BenchmarkModelType).
Null when Scope = "WholeBuilding". */
    modelTypeEntityId?: string | undefined;
    /** Target value in kgCO2e/m². */
    valueKgCo2ePerM2?: number;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    /** Navigation to the owning project. */
    project?: Project;
    /** Navigation to the BenchmarkModelType MetadataEntity.
Null when Scope = "WholeBuilding".
Use .Include(t => t.ModelTypeEntity) to resolve the display name. */
    modelTypeEntity?: MetadataEntity | undefined;
}

export class CreateProjectRequest implements ICreateProjectRequest {
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    models?: UpsertModel[] | undefined;
    profileId?: string | undefined;
    projectMetadata?: ProjectMetadata | undefined;
    /** Optional FK to a BenchmarkCatalog MetadataEntity. */
    benchmarkCatalogEntityId?: string | undefined;
    /** Explicit target values to save.  When null and BenchmarkCatalogEntityId
is provided, catalog values are copied automatically. */
    projectTargets?: ProjectTargetInput[] | undefined;

    constructor(data?: ICreateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.totalArea = _data["totalArea"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.rebarEstimation = _data["rebarEstimation"];
            this.nonModelledElements = _data["nonModelledElements"];
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(UpsertModel.fromJS(item));
            }
            this.profileId = _data["profileId"];
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : undefined as any;
            this.benchmarkCatalogEntityId = _data["benchmarkCatalogEntityId"];
            if (Array.isArray(_data["projectTargets"])) {
                this.projectTargets = [] as any;
                for (let item of _data["projectTargets"])
                    this.projectTargets!.push(ProjectTargetInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["totalArea"] = this.totalArea;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["rebarEstimation"] = this.rebarEstimation;
        data["nonModelledElements"] = this.nonModelledElements;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileId"] = this.profileId;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : undefined as any;
        data["benchmarkCatalogEntityId"] = this.benchmarkCatalogEntityId;
        if (Array.isArray(this.projectTargets)) {
            data["projectTargets"] = [];
            for (let item of this.projectTargets)
                data["projectTargets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateProjectRequest {
    userId?: string;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    models?: UpsertModel[] | undefined;
    profileId?: string | undefined;
    projectMetadata?: ProjectMetadata | undefined;
    /** Optional FK to a BenchmarkCatalog MetadataEntity. */
    benchmarkCatalogEntityId?: string | undefined;
    /** Explicit target values to save.  When null and BenchmarkCatalogEntityId
is provided, catalog values are copied automatically. */
    projectTargets?: ProjectTargetInput[] | undefined;
}

export class ProjectTargetInput implements IProjectTargetInput {
    scope?: string;
    modelTypeEntityId?: string | undefined;
    valueKgCo2ePerM2?: number;

    constructor(data?: IProjectTargetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.modelTypeEntityId = _data["modelTypeEntityId"];
            this.valueKgCo2ePerM2 = _data["valueKgCo2ePerM2"];
        }
    }

    static fromJS(data: any): ProjectTargetInput {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTargetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["modelTypeEntityId"] = this.modelTypeEntityId;
        data["valueKgCo2ePerM2"] = this.valueKgCo2ePerM2;
        return data;
    }
}

export interface IProjectTargetInput {
    scope?: string;
    modelTypeEntityId?: string | undefined;
    valueKgCo2ePerM2?: number;
}

export class UpdateProjectRequest implements IUpdateProjectRequest {
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    projectMetadata?: ProjectMetadata | undefined;
    /** When provided, updates the linked BenchmarkCatalog. Pass Guid.Empty to clear. */
    benchmarkCatalogEntityId?: string | undefined;
    /** When provided, merges these target values into the project's ProjectTargets. */
    projectTargets?: ProjectTargetInput[] | undefined;

    constructor(data?: IUpdateProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.totalArea = _data["totalArea"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : undefined as any;
            this.benchmarkCatalogEntityId = _data["benchmarkCatalogEntityId"];
            if (Array.isArray(_data["projectTargets"])) {
                this.projectTargets = [] as any;
                for (let item of _data["projectTargets"])
                    this.projectTargets!.push(ProjectTargetInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["totalArea"] = this.totalArea;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : undefined as any;
        data["benchmarkCatalogEntityId"] = this.benchmarkCatalogEntityId;
        if (Array.isArray(this.projectTargets)) {
            data["projectTargets"] = [];
            for (let item of this.projectTargets)
                data["projectTargets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateProjectRequest {
    projectId?: string;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    totalArea?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    projectMetadata?: ProjectMetadata | undefined;
    /** When provided, updates the linked BenchmarkCatalog. Pass Guid.Empty to clear. */
    benchmarkCatalogEntityId?: string | undefined;
    /** When provided, merges these target values into the project's ProjectTargets. */
    projectTargets?: ProjectTargetInput[] | undefined;
}

export class ApsProjectDataRequest implements IApsProjectDataRequest {
    projectId?: string;
    apsProjectId?: string;
    apsProjectName?: string;
    apsHubId?: string;
    apsHubName?: string;

    constructor(data?: IApsProjectDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
        }
    }

    static fromJS(data: any): ApsProjectDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApsProjectDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        return data;
    }
}

export interface IApsProjectDataRequest {
    projectId?: string;
    apsProjectId?: string;
    apsProjectName?: string;
    apsHubId?: string;
    apsHubName?: string;
}

export class CreateScenarioRequest implements ICreateScenarioRequest {
    projectId?: string;
    name?: string;
    description?: string;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    modelIds?: string[];
    scenarioMetadata?: ScenarioMetadata | undefined;
    profileId?: string | undefined;
    projectPhaseId?: string | undefined;
    isFinalforProjectPhase?: boolean;
    scenarioTypeId?: string | undefined;

    constructor(data?: ICreateScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rebarEstimation = _data["rebarEstimation"];
            this.nonModelledElements = _data["nonModelledElements"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.scenarioMetadata = _data["scenarioMetadata"] ? ScenarioMetadata.fromJS(_data["scenarioMetadata"]) : undefined as any;
            this.profileId = _data["profileId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.isFinalforProjectPhase = _data["isFinalforProjectPhase"];
            this.scenarioTypeId = _data["scenarioTypeId"];
        }
    }

    static fromJS(data: any): CreateScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rebarEstimation"] = this.rebarEstimation;
        data["nonModelledElements"] = this.nonModelledElements;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["scenarioMetadata"] = this.scenarioMetadata ? this.scenarioMetadata.toJSON() : undefined as any;
        data["profileId"] = this.profileId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["isFinalforProjectPhase"] = this.isFinalforProjectPhase;
        data["scenarioTypeId"] = this.scenarioTypeId;
        return data;
    }
}

export interface ICreateScenarioRequest {
    projectId?: string;
    name?: string;
    description?: string;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    modelIds?: string[];
    scenarioMetadata?: ScenarioMetadata | undefined;
    profileId?: string | undefined;
    projectPhaseId?: string | undefined;
    isFinalforProjectPhase?: boolean;
    scenarioTypeId?: string | undefined;
}

export class UpdateScenarioRequest implements IUpdateScenarioRequest {
    scenarioId?: string;
    /** Scenario name (required when updating). */
    name?: string | undefined;
    /** Scenario description. */
    description?: string | undefined;
    /** Included model IDs for this scenario. When provided, must all belong to the scenario's project. */
    modelIds?: string[] | undefined;
    scenarioMetadata?: ScenarioMetadata | undefined;
    projectPhaseId?: string | undefined;
    scenarioTypeId?: string | undefined;
    /** Optional reason for changing the scenario type, used for audit purposes when a scenario is marked as "Final". */
    scenarioTypeChangeReason?: string | undefined;

    constructor(data?: IUpdateScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.scenarioMetadata = _data["scenarioMetadata"] ? ScenarioMetadata.fromJS(_data["scenarioMetadata"]) : undefined as any;
            this.projectPhaseId = _data["projectPhaseId"];
            this.scenarioTypeId = _data["scenarioTypeId"];
            this.scenarioTypeChangeReason = _data["scenarioTypeChangeReason"];
        }
    }

    static fromJS(data: any): UpdateScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["scenarioMetadata"] = this.scenarioMetadata ? this.scenarioMetadata.toJSON() : undefined as any;
        data["projectPhaseId"] = this.projectPhaseId;
        data["scenarioTypeId"] = this.scenarioTypeId;
        data["scenarioTypeChangeReason"] = this.scenarioTypeChangeReason;
        return data;
    }
}

export interface IUpdateScenarioRequest {
    scenarioId?: string;
    /** Scenario name (required when updating). */
    name?: string | undefined;
    /** Scenario description. */
    description?: string | undefined;
    /** Included model IDs for this scenario. When provided, must all belong to the scenario's project. */
    modelIds?: string[] | undefined;
    scenarioMetadata?: ScenarioMetadata | undefined;
    projectPhaseId?: string | undefined;
    scenarioTypeId?: string | undefined;
    /** Optional reason for changing the scenario type, used for audit purposes when a scenario is marked as "Final". */
    scenarioTypeChangeReason?: string | undefined;
}

export class CloneScenarioRequest implements ICloneScenarioRequest {
    scenarioId?: string;
    name?: string;
    description?: string | undefined;
    rebarEstimation?: boolean;
    profileId?: string | undefined;

    constructor(data?: ICloneScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rebarEstimation = _data["rebarEstimation"];
            this.profileId = _data["profileId"];
        }
    }

    static fromJS(data: any): CloneScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CloneScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rebarEstimation"] = this.rebarEstimation;
        data["profileId"] = this.profileId;
        return data;
    }
}

export interface ICloneScenarioRequest {
    scenarioId?: string;
    name?: string;
    description?: string | undefined;
    rebarEstimation?: boolean;
    profileId?: string | undefined;
}

export class CopyModelMaterialRequest implements ICopyModelMaterialRequest {
    srcScenarioId?: string;
    srcModelId?: string;
    dstScenarioId?: string;
    dstModelId?: string;
    modelName?: string;

    constructor(data?: ICopyModelMaterialRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.srcScenarioId = _data["srcScenarioId"];
            this.srcModelId = _data["srcModelId"];
            this.dstScenarioId = _data["dstScenarioId"];
            this.dstModelId = _data["dstModelId"];
            this.modelName = _data["modelName"];
        }
    }

    static fromJS(data: any): CopyModelMaterialRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CopyModelMaterialRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["srcScenarioId"] = this.srcScenarioId;
        data["srcModelId"] = this.srcModelId;
        data["dstScenarioId"] = this.dstScenarioId;
        data["dstModelId"] = this.dstModelId;
        data["modelName"] = this.modelName;
        return data;
    }
}

export interface ICopyModelMaterialRequest {
    srcScenarioId?: string;
    srcModelId?: string;
    dstScenarioId?: string;
    dstModelId?: string;
    modelName?: string;
}

export class PluginHistory implements IPluginHistory {
    daPluginsHistoryId?: number;
    fileName?: string;
    version?: string;
    bundleName?: string;
    bundleAlias?: string;
    activityName?: string;
    activityAlias?: string;
    engine?: string;
    description?: string;
    status?: string;
    message?: string;
    createdAt?: Date;

    constructor(data?: IPluginHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.daPluginsHistoryId = _data["daPluginsHistoryId"];
            this.fileName = _data["fileName"];
            this.version = _data["version"];
            this.bundleName = _data["bundleName"];
            this.bundleAlias = _data["bundleAlias"];
            this.activityName = _data["activityName"];
            this.activityAlias = _data["activityAlias"];
            this.engine = _data["engine"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PluginHistory {
        data = typeof data === 'object' ? data : {};
        let result = new PluginHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["daPluginsHistoryId"] = this.daPluginsHistoryId;
        data["fileName"] = this.fileName;
        data["version"] = this.version;
        data["bundleName"] = this.bundleName;
        data["bundleAlias"] = this.bundleAlias;
        data["activityName"] = this.activityName;
        data["activityAlias"] = this.activityAlias;
        data["engine"] = this.engine;
        data["description"] = this.description;
        data["status"] = this.status;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IPluginHistory {
    daPluginsHistoryId?: number;
    fileName?: string;
    version?: string;
    bundleName?: string;
    bundleAlias?: string;
    activityName?: string;
    activityAlias?: string;
    engine?: string;
    description?: string;
    status?: string;
    message?: string;
    createdAt?: Date;
}

export class CreateObjectSigned implements ICreateObjectSigned {
    signedUrl?: string | undefined;
    expiration?: number | undefined;
    allowedIpAddresses?: string[] | undefined;

    constructor(data?: ICreateObjectSigned) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signedUrl = _data["signedUrl"];
            this.expiration = _data["expiration"];
            if (Array.isArray(_data["allowedIpAddresses"])) {
                this.allowedIpAddresses = [] as any;
                for (let item of _data["allowedIpAddresses"])
                    this.allowedIpAddresses!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateObjectSigned {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObjectSigned();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signedUrl"] = this.signedUrl;
        data["expiration"] = this.expiration;
        if (Array.isArray(this.allowedIpAddresses)) {
            data["allowedIpAddresses"] = [];
            for (let item of this.allowedIpAddresses)
                data["allowedIpAddresses"].push(item);
        }
        return data;
    }
}

export interface ICreateObjectSigned {
    signedUrl?: string | undefined;
    expiration?: number | undefined;
    allowedIpAddresses?: string[] | undefined;
}

export class ProgressUpdate implements IProgressUpdate {
    jobId?: string;
    userId?: string;
    projectId?: string;
    modelId?: string;
    type?: ProgressType;
    progress?: number;
    processedCount?: number;
    totalCount?: number;
    message?: string;
    timestamp?: Date;
    elapsedSeconds?: number;
    estimatedRemainingSeconds?: number;

    constructor(data?: IProgressUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.type = _data["type"];
            this.progress = _data["progress"];
            this.processedCount = _data["processedCount"];
            this.totalCount = _data["totalCount"];
            this.message = _data["message"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : undefined as any;
            this.elapsedSeconds = _data["elapsedSeconds"];
            this.estimatedRemainingSeconds = _data["estimatedRemainingSeconds"];
        }
    }

    static fromJS(data: any): ProgressUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["type"] = this.type;
        data["progress"] = this.progress;
        data["processedCount"] = this.processedCount;
        data["totalCount"] = this.totalCount;
        data["message"] = this.message;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined as any;
        data["elapsedSeconds"] = this.elapsedSeconds;
        data["estimatedRemainingSeconds"] = this.estimatedRemainingSeconds;
        return data;
    }
}

export interface IProgressUpdate {
    jobId?: string;
    userId?: string;
    projectId?: string;
    modelId?: string;
    type?: ProgressType;
    progress?: number;
    processedCount?: number;
    totalCount?: number;
    message?: string;
    timestamp?: Date;
    elapsedSeconds?: number;
    estimatedRemainingSeconds?: number;
}

export enum ProgressType {
    Extract = "Extract",
    Import = "Import",
}

export class ModelCommandResponse implements IModelCommandResponse {
    commandId?: string;
    /** command name */
    name?: string;
    /** Description */
    description?: string;
    /** JSOn config */
    arguments?: string;
    profileId?: string | undefined;
    profileName?: string | undefined;
    lastUpdatedTime?: Date | undefined;
    /** Returns LastUpdatedTime converted to the preferred local time zone if available. */
    lastUpdatedTimeinLocalTimeZone?: Date | undefined;

    constructor(data?: IModelCommandResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commandId = _data["commandId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.arguments = _data["arguments"];
            this.profileId = _data["profileId"];
            this.profileName = _data["profileName"];
            this.lastUpdatedTime = _data["lastUpdatedTime"] ? new Date(_data["lastUpdatedTime"].toString()) : undefined as any;
            this.lastUpdatedTimeinLocalTimeZone = _data["lastUpdatedTimeinLocalTimeZone"] ? new Date(_data["lastUpdatedTimeinLocalTimeZone"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ModelCommandResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelCommandResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commandId"] = this.commandId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["arguments"] = this.arguments;
        data["profileId"] = this.profileId;
        data["profileName"] = this.profileName;
        data["lastUpdatedTime"] = this.lastUpdatedTime ? this.lastUpdatedTime.toISOString() : undefined as any;
        data["lastUpdatedTimeinLocalTimeZone"] = this.lastUpdatedTimeinLocalTimeZone ? this.lastUpdatedTimeinLocalTimeZone.toISOString() : undefined as any;
        return data;
    }
}

export interface IModelCommandResponse {
    commandId?: string;
    /** command name */
    name?: string;
    /** Description */
    description?: string;
    /** JSOn config */
    arguments?: string;
    profileId?: string | undefined;
    profileName?: string | undefined;
    lastUpdatedTime?: Date | undefined;
    /** Returns LastUpdatedTime converted to the preferred local time zone if available. */
    lastUpdatedTimeinLocalTimeZone?: Date | undefined;
}

export class CreateModelCommandRequest implements ICreateModelCommandRequest {
    /** Description of Configuraion */
    name?: string;
    /** Description of Configuraion */
    description?: string;
    arguments?: string;
    command?: string;
    profileId?: string | undefined;

    constructor(data?: ICreateModelCommandRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.arguments = _data["arguments"];
            this.command = _data["command"];
            this.profileId = _data["profileId"];
        }
    }

    static fromJS(data: any): CreateModelCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModelCommandRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["arguments"] = this.arguments;
        data["command"] = this.command;
        data["profileId"] = this.profileId;
        return data;
    }
}

export interface ICreateModelCommandRequest {
    /** Description of Configuraion */
    name?: string;
    /** Description of Configuraion */
    description?: string;
    arguments?: string;
    command?: string;
    profileId?: string | undefined;
}

export class UpdateModelCommandRequest extends CreateModelCommandRequest implements IUpdateModelCommandRequest {

    constructor(data?: IUpdateModelCommandRequest) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UpdateModelCommandRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModelCommandRequest();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateModelCommandRequest extends ICreateModelCommandRequest {
}

export class Category implements ICategory {
    cadModelCategoryId?: string | undefined;
    modelId?: string | undefined;
    assigned?: boolean;
    scoped?: boolean;
    childCount?: number;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    co2Totals?: Co2Aggregates | undefined;
    rebar?: Supplemental | undefined;
    nonMod?: Supplemental | undefined;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.modelId = _data["modelId"];
            this.assigned = _data["assigned"];
            this.scoped = _data["scoped"];
            this.childCount = _data["childCount"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.co2Totals = _data["co2Totals"] ? Co2Aggregates.fromJS(_data["co2Totals"]) : undefined as any;
            this.rebar = _data["rebar"] ? Supplemental.fromJS(_data["rebar"]) : undefined as any;
            this.nonMod = _data["nonMod"] ? Supplemental.fromJS(_data["nonMod"]) : undefined as any;
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["modelId"] = this.modelId;
        data["assigned"] = this.assigned;
        data["scoped"] = this.scoped;
        data["childCount"] = this.childCount;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["co2Totals"] = this.co2Totals ? this.co2Totals.toJSON() : undefined as any;
        data["rebar"] = this.rebar ? this.rebar.toJSON() : undefined as any;
        data["nonMod"] = this.nonMod ? this.nonMod.toJSON() : undefined as any;
        return data;
    }
}

export interface ICategory {
    cadModelCategoryId?: string | undefined;
    modelId?: string | undefined;
    assigned?: boolean;
    scoped?: boolean;
    childCount?: number;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    co2Totals?: Co2Aggregates | undefined;
    rebar?: Supplemental | undefined;
    nonMod?: Supplemental | undefined;
}

export class Co2Aggregates implements ICo2Aggregates {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;

    constructor(data?: ICo2Aggregates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
        }
    }

    static fromJS(data: any): Co2Aggregates {
        data = typeof data === 'object' ? data : {};
        let result = new Co2Aggregates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        return data;
    }
}

export interface ICo2Aggregates {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
}

export class Supplemental implements ISupplemental {
    supplementalId?: string | undefined;
    supplementalType?: SupplementalType | undefined;
    supplementalMethod?: SupplementalMethod | undefined;
    supplementalValueType?: SupplementalValueType | undefined;
    value?: number | undefined;
    volume?: number | undefined;
    co2Totals?: Co2Aggregates | undefined;

    constructor(data?: ISupplemental) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplementalId = _data["supplementalId"];
            this.supplementalType = _data["supplementalType"];
            this.supplementalMethod = _data["supplementalMethod"];
            this.supplementalValueType = _data["supplementalValueType"];
            this.value = _data["value"];
            this.volume = _data["volume"];
            this.co2Totals = _data["co2Totals"] ? Co2Aggregates.fromJS(_data["co2Totals"]) : undefined as any;
        }
    }

    static fromJS(data: any): Supplemental {
        data = typeof data === 'object' ? data : {};
        let result = new Supplemental();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplementalId"] = this.supplementalId;
        data["supplementalType"] = this.supplementalType;
        data["supplementalMethod"] = this.supplementalMethod;
        data["supplementalValueType"] = this.supplementalValueType;
        data["value"] = this.value;
        data["volume"] = this.volume;
        data["co2Totals"] = this.co2Totals ? this.co2Totals.toJSON() : undefined as any;
        return data;
    }
}

export interface ISupplemental {
    supplementalId?: string | undefined;
    supplementalType?: SupplementalType | undefined;
    supplementalMethod?: SupplementalMethod | undefined;
    supplementalValueType?: SupplementalValueType | undefined;
    value?: number | undefined;
    volume?: number | undefined;
    co2Totals?: Co2Aggregates | undefined;
}

export enum SupplementalType {
    Primary = "Primary",
    Rebar = "Rebar",
    NonModelled = "NonModelled",
    Adhoc = "Adhoc",
}

export enum SupplementalMethod {
    None = "None",
    Subtractive = "Subtractive",
    Additive = "Additive",
}

export enum SupplementalValueType {
    None = "None",
    Percent = "Percent",
    Amount = "Amount",
    Quantity = "Quantity",
}

export class ProjectModelDto implements IProjectModelDto {
    categories?: CategoryDto[];
    elements?: ElementDto[];
    components?: ComponentDto[];
    modelExtendedData?: { [key: string]: { [key: string]: any; }; } | undefined;

    constructor(data?: IProjectModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ElementDto.fromJS(item));
            }
            if (Array.isArray(_data["components"])) {
                this.components = [] as any;
                for (let item of _data["components"])
                    this.components!.push(ComponentDto.fromJS(item));
            }
            if (_data["modelExtendedData"]) {
                this.modelExtendedData = {} as any;
                for (let key in _data["modelExtendedData"]) {
                    if (_data["modelExtendedData"].hasOwnProperty(key))
                        (this.modelExtendedData as any)![key] = _data["modelExtendedData"][key] !== undefined ? _data["modelExtendedData"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): ProjectModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.components)) {
            data["components"] = [];
            for (let item of this.components)
                data["components"].push(item ? item.toJSON() : undefined as any);
        }
        if (this.modelExtendedData) {
            data["modelExtendedData"] = {};
            for (let key in this.modelExtendedData) {
                if (this.modelExtendedData.hasOwnProperty(key))
                    (data["modelExtendedData"] as any)[key] = (this.modelExtendedData as any)[key];
            }
        }
        return data;
    }
}

export interface IProjectModelDto {
    categories?: CategoryDto[];
    elements?: ElementDto[];
    components?: ComponentDto[];
    modelExtendedData?: { [key: string]: { [key: string]: any; }; } | undefined;
}

export class CategoryDto implements ICategoryDto {
    modelId?: string;
    cadModelCategoryId?: string;
    assigned?: boolean;
    scoped?: boolean;
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    hasChildMultiplierOverride?: boolean;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;

    constructor(data?: ICategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.assigned = _data["assigned"];
            this.scoped = _data["scoped"];
            this.elementCount = _data["elementCount"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.multiplierInput = _data["multiplierInput"];
            this.multiplierValue = _data["multiplierValue"];
            this.notes = _data["notes"];
            this.systemId = _data["systemId"];
            this.subSystemId = _data["subSystemId"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.hasChildMultiplierOverride = _data["hasChildMultiplierOverride"];
            this.carbonImpactValue = _data["carbonImpactValue"];
            this.carbonImpactInput = _data["carbonImpactInput"];
            this.carbonImpactNotes = _data["carbonImpactNotes"];
            this.hasChildCarbonImpactOverride = _data["hasChildCarbonImpactOverride"];
        }
    }

    static fromJS(data: any): CategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["assigned"] = this.assigned;
        data["scoped"] = this.scoped;
        data["elementCount"] = this.elementCount;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["multiplierInput"] = this.multiplierInput;
        data["multiplierValue"] = this.multiplierValue;
        data["notes"] = this.notes;
        data["systemId"] = this.systemId;
        data["subSystemId"] = this.subSystemId;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["hasChildMultiplierOverride"] = this.hasChildMultiplierOverride;
        data["carbonImpactValue"] = this.carbonImpactValue;
        data["carbonImpactInput"] = this.carbonImpactInput;
        data["carbonImpactNotes"] = this.carbonImpactNotes;
        data["hasChildCarbonImpactOverride"] = this.hasChildCarbonImpactOverride;
        return data;
    }
}

export interface ICategoryDto {
    modelId?: string;
    cadModelCategoryId?: string;
    assigned?: boolean;
    scoped?: boolean;
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    hasChildMultiplierOverride?: boolean;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
}

export class ElementDto implements IElementDto {
    elementId?: string;
    type?: ElementType;
    cadModelCategoryId?: string;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string | undefined;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    componentCount?: number;
    quantity?: number;
    length?: number;
    area?: number;
    volume?: number;
    thickness?: number;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    hasChildMultiplierOverride?: boolean;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
    co2MaterialTypeSpec?: any | undefined;
    cadModelCategory?: CadModelCategoryDto;
    modelParameters?: ModelParameterDto[];

    constructor(data?: IElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.type = _data["type"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.cadId = _data["cadId"];
            this.cadFamily = _data["cadFamily"];
            this.cadName = _data["cadName"];
            this.cadMaterial = _data["cadMaterial"];
            this.cadReferenceId = _data["cadReferenceId"];
            this.isStructuralMaterial = _data["isStructuralMaterial"];
            this.scopeId = _data["scopeId"];
            this.componentCount = _data["componentCount"];
            this.quantity = _data["quantity"];
            this.length = _data["length"];
            this.area = _data["area"];
            this.volume = _data["volume"];
            this.thickness = _data["thickness"];
            this.originalLength = _data["originalLength"];
            this.originalArea = _data["originalArea"];
            this.originalVolume = _data["originalVolume"];
            this.originalQuantity = _data["originalQuantity"];
            this.assigned = _data["assigned"];
            this.scoped = _data["scoped"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.hasChildMultiplierOverride = _data["hasChildMultiplierOverride"];
            this.multiplierInput = _data["multiplierInput"];
            this.multiplierValue = _data["multiplierValue"];
            this.notes = _data["notes"];
            this.systemId = _data["systemId"];
            this.subSystemId = _data["subSystemId"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.carbonImpactValue = _data["carbonImpactValue"];
            this.carbonImpactInput = _data["carbonImpactInput"];
            this.carbonImpactNotes = _data["carbonImpactNotes"];
            this.hasChildCarbonImpactOverride = _data["hasChildCarbonImpactOverride"];
            this.co2MaterialTypeSpec = _data["co2MaterialTypeSpec"];
            this.cadModelCategory = _data["cadModelCategory"] ? CadModelCategoryDto.fromJS(_data["cadModelCategory"]) : undefined as any;
            if (Array.isArray(_data["modelParameters"])) {
                this.modelParameters = [] as any;
                for (let item of _data["modelParameters"])
                    this.modelParameters!.push(ModelParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["type"] = this.type;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["cadId"] = this.cadId;
        data["cadFamily"] = this.cadFamily;
        data["cadName"] = this.cadName;
        data["cadMaterial"] = this.cadMaterial;
        data["cadReferenceId"] = this.cadReferenceId;
        data["isStructuralMaterial"] = this.isStructuralMaterial;
        data["scopeId"] = this.scopeId;
        data["componentCount"] = this.componentCount;
        data["quantity"] = this.quantity;
        data["length"] = this.length;
        data["area"] = this.area;
        data["volume"] = this.volume;
        data["thickness"] = this.thickness;
        data["originalLength"] = this.originalLength;
        data["originalArea"] = this.originalArea;
        data["originalVolume"] = this.originalVolume;
        data["originalQuantity"] = this.originalQuantity;
        data["assigned"] = this.assigned;
        data["scoped"] = this.scoped;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["hasChildMultiplierOverride"] = this.hasChildMultiplierOverride;
        data["multiplierInput"] = this.multiplierInput;
        data["multiplierValue"] = this.multiplierValue;
        data["notes"] = this.notes;
        data["systemId"] = this.systemId;
        data["subSystemId"] = this.subSystemId;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["carbonImpactValue"] = this.carbonImpactValue;
        data["carbonImpactInput"] = this.carbonImpactInput;
        data["carbonImpactNotes"] = this.carbonImpactNotes;
        data["hasChildCarbonImpactOverride"] = this.hasChildCarbonImpactOverride;
        data["co2MaterialTypeSpec"] = this.co2MaterialTypeSpec;
        data["cadModelCategory"] = this.cadModelCategory ? this.cadModelCategory.toJSON() : undefined as any;
        if (Array.isArray(this.modelParameters)) {
            data["modelParameters"] = [];
            for (let item of this.modelParameters)
                data["modelParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElementDto {
    elementId?: string;
    type?: ElementType;
    cadModelCategoryId?: string;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string | undefined;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    componentCount?: number;
    quantity?: number;
    length?: number;
    area?: number;
    volume?: number;
    thickness?: number;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    hasChildMultiplierOverride?: boolean;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
    co2MaterialTypeSpec?: any | undefined;
    cadModelCategory?: CadModelCategoryDto;
    modelParameters?: ModelParameterDto[];
}

export enum ElementType {
    CAD = "CAD",
    Adhoc = "Adhoc",
}

export class CadModelCategoryDto implements ICadModelCategoryDto {
    cadModelCategoryId?: string;
    name?: string;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICadModelCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CadModelCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CadModelCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["name"] = this.name;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ICadModelCategoryDto {
    cadModelCategoryId?: string;
    name?: string;
    key?: string | undefined;
    value?: string | undefined;
}

export class ModelParameterDto implements IModelParameterDto {
    modelParameterId?: string;
    name?: string;
    value?: string;

    constructor(data?: IModelParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelParameterId = _data["modelParameterId"];
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ModelParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelParameterId"] = this.modelParameterId;
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IModelParameterDto {
    modelParameterId?: string;
    name?: string;
    value?: string;
}

export class ComponentDto implements IComponentDto {
    componentId?: string;
    elementId?: string;
    cadModelCategoryId?: string;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string | undefined;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number | undefined;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    co2MaterialTypeSpec?: any | undefined;
    cadModelCategory?: CadModelCategoryDto;
    modelParameters?: ModelParameterDto[];

    constructor(data?: IComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.componentId = _data["componentId"];
            this.elementId = _data["elementId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.cadId = _data["cadId"];
            this.cadFamily = _data["cadFamily"];
            this.cadName = _data["cadName"];
            this.cadMaterial = _data["cadMaterial"];
            this.cadReferenceId = _data["cadReferenceId"];
            this.isStructuralMaterial = _data["isStructuralMaterial"];
            this.scopeId = _data["scopeId"];
            this.length = _data["length"];
            this.area = _data["area"];
            this.volume = _data["volume"];
            this.thickness = _data["thickness"];
            this.quantity = _data["quantity"];
            this.originalLength = _data["originalLength"];
            this.originalArea = _data["originalArea"];
            this.originalVolume = _data["originalVolume"];
            this.originalQuantity = _data["originalQuantity"];
            this.assigned = _data["assigned"];
            this.scoped = _data["scoped"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.multiplierInput = _data["multiplierInput"];
            this.multiplierValue = _data["multiplierValue"];
            this.notes = _data["notes"];
            this.systemId = _data["systemId"];
            this.subSystemId = _data["subSystemId"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.carbonImpactValue = _data["carbonImpactValue"];
            this.carbonImpactInput = _data["carbonImpactInput"];
            this.carbonImpactNotes = _data["carbonImpactNotes"];
            this.co2MaterialTypeSpec = _data["co2MaterialTypeSpec"];
            this.cadModelCategory = _data["cadModelCategory"] ? CadModelCategoryDto.fromJS(_data["cadModelCategory"]) : undefined as any;
            if (Array.isArray(_data["modelParameters"])) {
                this.modelParameters = [] as any;
                for (let item of _data["modelParameters"])
                    this.modelParameters!.push(ModelParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["componentId"] = this.componentId;
        data["elementId"] = this.elementId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["cadId"] = this.cadId;
        data["cadFamily"] = this.cadFamily;
        data["cadName"] = this.cadName;
        data["cadMaterial"] = this.cadMaterial;
        data["cadReferenceId"] = this.cadReferenceId;
        data["isStructuralMaterial"] = this.isStructuralMaterial;
        data["scopeId"] = this.scopeId;
        data["length"] = this.length;
        data["area"] = this.area;
        data["volume"] = this.volume;
        data["thickness"] = this.thickness;
        data["quantity"] = this.quantity;
        data["originalLength"] = this.originalLength;
        data["originalArea"] = this.originalArea;
        data["originalVolume"] = this.originalVolume;
        data["originalQuantity"] = this.originalQuantity;
        data["assigned"] = this.assigned;
        data["scoped"] = this.scoped;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["multiplierInput"] = this.multiplierInput;
        data["multiplierValue"] = this.multiplierValue;
        data["notes"] = this.notes;
        data["systemId"] = this.systemId;
        data["subSystemId"] = this.subSystemId;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["carbonImpactValue"] = this.carbonImpactValue;
        data["carbonImpactInput"] = this.carbonImpactInput;
        data["carbonImpactNotes"] = this.carbonImpactNotes;
        data["co2MaterialTypeSpec"] = this.co2MaterialTypeSpec;
        data["cadModelCategory"] = this.cadModelCategory ? this.cadModelCategory.toJSON() : undefined as any;
        if (Array.isArray(this.modelParameters)) {
            data["modelParameters"] = [];
            for (let item of this.modelParameters)
                data["modelParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IComponentDto {
    componentId?: string;
    elementId?: string;
    cadModelCategoryId?: string;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string | undefined;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number | undefined;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    co2MaterialTypeSpec?: any | undefined;
    cadModelCategory?: CadModelCategoryDto;
    modelParameters?: ModelParameterDto[];
}

export class Element implements IElement {
    elementId?: string;
    parentId?: string | undefined;
    nodeType?: NodeType;
    type?: ElementType;
    active?: boolean;
    cadModelCategoryId?: string | undefined;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    childCount?: number | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number | undefined;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    thicknessTotal?: number | undefined;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
    co2MaterialTypeSpec?: any | undefined;
    co2Totals?: Co2Aggregates | undefined;
    rebar?: Supplemental | undefined;
    nonMod?: Supplemental | undefined;
    supplementals?: Supplemental[] | undefined;

    constructor(data?: IElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.parentId = _data["parentId"];
            this.nodeType = _data["nodeType"];
            this.type = _data["type"];
            this.active = _data["active"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.cadId = _data["cadId"];
            this.cadFamily = _data["cadFamily"];
            this.cadName = _data["cadName"];
            this.cadMaterial = _data["cadMaterial"];
            this.cadReferenceId = _data["cadReferenceId"];
            this.isStructuralMaterial = _data["isStructuralMaterial"];
            this.scopeId = _data["scopeId"];
            this.assigned = _data["assigned"];
            this.scoped = _data["scoped"];
            this.childCount = _data["childCount"];
            this.length = _data["length"];
            this.area = _data["area"];
            this.volume = _data["volume"];
            this.thickness = _data["thickness"];
            this.quantity = _data["quantity"];
            this.originalLength = _data["originalLength"];
            this.originalArea = _data["originalArea"];
            this.originalVolume = _data["originalVolume"];
            this.originalQuantity = _data["originalQuantity"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.thicknessTotal = _data["thicknessTotal"];
            this.multiplierInput = _data["multiplierInput"];
            this.multiplierValue = _data["multiplierValue"];
            this.notes = _data["notes"];
            this.systemId = _data["systemId"];
            this.subSystemId = _data["subSystemId"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.carbonImpactValue = _data["carbonImpactValue"];
            this.carbonImpactInput = _data["carbonImpactInput"];
            this.carbonImpactNotes = _data["carbonImpactNotes"];
            this.hasChildCarbonImpactOverride = _data["hasChildCarbonImpactOverride"];
            this.co2MaterialTypeSpec = _data["co2MaterialTypeSpec"];
            this.co2Totals = _data["co2Totals"] ? Co2Aggregates.fromJS(_data["co2Totals"]) : undefined as any;
            this.rebar = _data["rebar"] ? Supplemental.fromJS(_data["rebar"]) : undefined as any;
            this.nonMod = _data["nonMod"] ? Supplemental.fromJS(_data["nonMod"]) : undefined as any;
            if (Array.isArray(_data["supplementals"])) {
                this.supplementals = [] as any;
                for (let item of _data["supplementals"])
                    this.supplementals!.push(Supplemental.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Element {
        data = typeof data === 'object' ? data : {};
        let result = new Element();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["parentId"] = this.parentId;
        data["nodeType"] = this.nodeType;
        data["type"] = this.type;
        data["active"] = this.active;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["cadId"] = this.cadId;
        data["cadFamily"] = this.cadFamily;
        data["cadName"] = this.cadName;
        data["cadMaterial"] = this.cadMaterial;
        data["cadReferenceId"] = this.cadReferenceId;
        data["isStructuralMaterial"] = this.isStructuralMaterial;
        data["scopeId"] = this.scopeId;
        data["assigned"] = this.assigned;
        data["scoped"] = this.scoped;
        data["childCount"] = this.childCount;
        data["length"] = this.length;
        data["area"] = this.area;
        data["volume"] = this.volume;
        data["thickness"] = this.thickness;
        data["quantity"] = this.quantity;
        data["originalLength"] = this.originalLength;
        data["originalArea"] = this.originalArea;
        data["originalVolume"] = this.originalVolume;
        data["originalQuantity"] = this.originalQuantity;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["thicknessTotal"] = this.thicknessTotal;
        data["multiplierInput"] = this.multiplierInput;
        data["multiplierValue"] = this.multiplierValue;
        data["notes"] = this.notes;
        data["systemId"] = this.systemId;
        data["subSystemId"] = this.subSystemId;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["carbonImpactValue"] = this.carbonImpactValue;
        data["carbonImpactInput"] = this.carbonImpactInput;
        data["carbonImpactNotes"] = this.carbonImpactNotes;
        data["hasChildCarbonImpactOverride"] = this.hasChildCarbonImpactOverride;
        data["co2MaterialTypeSpec"] = this.co2MaterialTypeSpec;
        data["co2Totals"] = this.co2Totals ? this.co2Totals.toJSON() : undefined as any;
        data["rebar"] = this.rebar ? this.rebar.toJSON() : undefined as any;
        data["nonMod"] = this.nonMod ? this.nonMod.toJSON() : undefined as any;
        if (Array.isArray(this.supplementals)) {
            data["supplementals"] = [];
            for (let item of this.supplementals)
                data["supplementals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IElement {
    elementId?: string;
    parentId?: string | undefined;
    nodeType?: NodeType;
    type?: ElementType;
    active?: boolean;
    cadModelCategoryId?: string | undefined;
    cadId?: string | undefined;
    cadFamily?: string | undefined;
    cadName?: string;
    cadMaterial?: string | undefined;
    cadReferenceId?: string | undefined;
    isStructuralMaterial?: boolean | undefined;
    scopeId?: number | undefined;
    assigned?: boolean;
    scoped?: boolean;
    childCount?: number | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number | undefined;
    originalLength?: number | undefined;
    originalArea?: number | undefined;
    originalVolume?: number | undefined;
    originalQuantity?: number | undefined;
    quantityTotal?: number | undefined;
    lengthTotal?: number | undefined;
    areaTotal?: number | undefined;
    volumeTotal?: number | undefined;
    thicknessTotal?: number | undefined;
    multiplierInput?: string | undefined;
    multiplierValue?: number | undefined;
    notes?: string | undefined;
    systemId?: string | undefined;
    subSystemId?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
    co2MaterialTypeSpec?: any | undefined;
    co2Totals?: Co2Aggregates | undefined;
    rebar?: Supplemental | undefined;
    nonMod?: Supplemental | undefined;
    supplementals?: Supplemental[] | undefined;
}

export enum NodeType {
    Node = "Node",
    Model = "Model",
    Group = "Group",
    Element = "Element",
    Component = "Component",
    Supplemental = "Supplemental",
}

export class ModelScopesResponse implements IModelScopesResponse {
    /** Key: ScopeId
Value: List of CadIds */
    scopes?: { [key: string]: string[]; };

    constructor(data?: IModelScopesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["scopes"]) {
                this.scopes = {} as any;
                for (let key in _data["scopes"]) {
                    if (_data["scopes"].hasOwnProperty(key))
                        (this.scopes as any)![key] = _data["scopes"][key] !== undefined ? _data["scopes"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ModelScopesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelScopesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.scopes) {
            data["scopes"] = {};
            for (let key in this.scopes) {
                if (this.scopes.hasOwnProperty(key))
                    (data["scopes"] as any)[key] = (this.scopes as any)[key];
            }
        }
        return data;
    }
}

export interface IModelScopesResponse {
    /** Key: ScopeId
Value: List of CadIds */
    scopes?: { [key: string]: string[]; };
}

export class Material2 implements IMaterial2 {
    materialId?: string;
    modelId?: string;
    scenarioId?: string;
    parentId?: string;
    co2MaterialTypeId?: string | undefined;
    cadModelCategoryId?: string | undefined;
    type?: MaterialType;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    /** Represents the A1A2A3 Total tCO2e before A-D was added.
Now it should be the Total tCO2e emissions across all phases (A-D). */
    totalCo2?: number | undefined;

    constructor(data?: IMaterial2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialId = _data["materialId"];
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            this.parentId = _data["parentId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.type = _data["type"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
        }
    }

    static fromJS(data: any): Material2 {
        data = typeof data === 'object' ? data : {};
        let result = new Material2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialId"] = this.materialId;
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        data["parentId"] = this.parentId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["type"] = this.type;
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        return data;
    }
}

export interface IMaterial2 {
    materialId?: string;
    modelId?: string;
    scenarioId?: string;
    parentId?: string;
    co2MaterialTypeId?: string | undefined;
    cadModelCategoryId?: string | undefined;
    type?: MaterialType;
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    /** Represents the A1A2A3 Total tCO2e before A-D was added.
Now it should be the Total tCO2e emissions across all phases (A-D). */
    totalCo2?: number | undefined;
}

export class AssignMaterialsRequest implements IAssignMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    co2MaterialTypeId?: string | undefined;
    /** Co2MaterialLibraryId */
    co2MaterialLibraryId?: string | undefined;
    /** Material category provided by external source */
    materialCategory?: string | undefined;
    /** Material ExternalId */
    externalId?: string | undefined;
    /** Material Name */
    name?: string | undefined;
    /** Material data from external source */
    sourceData?: string | undefined;
    categories?: AssignCategoryMaterial[] | undefined;
    elements?: AssignElementMaterial[] | undefined;

    constructor(data?: IAssignMaterialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.materialCategory = _data["materialCategory"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.sourceData = _data["sourceData"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AssignCategoryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(AssignElementMaterial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignMaterialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignMaterialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["materialCategory"] = this.materialCategory;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["sourceData"] = this.sourceData;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    co2MaterialTypeId?: string | undefined;
    /** Co2MaterialLibraryId */
    co2MaterialLibraryId?: string | undefined;
    /** Material category provided by external source */
    materialCategory?: string | undefined;
    /** Material ExternalId */
    externalId?: string | undefined;
    /** Material Name */
    name?: string | undefined;
    /** Material data from external source */
    sourceData?: string | undefined;
    categories?: AssignCategoryMaterial[] | undefined;
    elements?: AssignElementMaterial[] | undefined;
}

export class AssignCategoryMaterial implements IAssignCategoryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;

    constructor(data?: IAssignCategoryMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
        }
    }

    static fromJS(data: any): AssignCategoryMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCategoryMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        return data;
    }
}

export interface IAssignCategoryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;
}

export class AssignElementMaterial implements IAssignElementMaterial {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;

    constructor(data?: IAssignElementMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.elementId = _data["elementId"];
        }
    }

    static fromJS(data: any): AssignElementMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new AssignElementMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["elementId"] = this.elementId;
        return data;
    }
}

export interface IAssignElementMaterial {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;
}

export class AutoAssignMaterialsRequest implements IAutoAssignMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: AutoAssignCateogryMaterial[] | undefined;
    elements?: AutoAssignElementMaterial[] | undefined;

    constructor(data?: IAutoAssignMaterialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(AutoAssignCateogryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(AutoAssignElementMaterial.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AutoAssignMaterialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AutoAssignMaterialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAutoAssignMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: AutoAssignCateogryMaterial[] | undefined;
    elements?: AutoAssignElementMaterial[] | undefined;
}

export class AutoAssignCateogryMaterial implements IAutoAssignCateogryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;

    constructor(data?: IAutoAssignCateogryMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
        }
    }

    static fromJS(data: any): AutoAssignCateogryMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new AutoAssignCateogryMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        return data;
    }
}

export interface IAutoAssignCateogryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;
}

export class AutoAssignElementMaterial implements IAutoAssignElementMaterial {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;

    constructor(data?: IAutoAssignElementMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.elementId = _data["elementId"];
        }
    }

    static fromJS(data: any): AutoAssignElementMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new AutoAssignElementMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["elementId"] = this.elementId;
        return data;
    }
}

export interface IAutoAssignElementMaterial {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;
}

export class AssignRebarEstimationEditsRequest implements IAssignRebarEstimationEditsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    edits?: RebarEstimationEdit[] | undefined;

    constructor(data?: IAssignRebarEstimationEditsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["edits"])) {
                this.edits = [] as any;
                for (let item of _data["edits"])
                    this.edits!.push(RebarEstimationEdit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignRebarEstimationEditsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRebarEstimationEditsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.edits)) {
            data["edits"] = [];
            for (let item of this.edits)
                data["edits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignRebarEstimationEditsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    edits?: RebarEstimationEdit[] | undefined;
}

export class RebarEstimationEdit implements IRebarEstimationEdit {
    scenarioId?: string | undefined;
    elementId?: string;
    value?: number;
    valueType?: string;

    constructor(data?: IRebarEstimationEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.elementId = _data["elementId"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): RebarEstimationEdit {
        data = typeof data === 'object' ? data : {};
        let result = new RebarEstimationEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["elementId"] = this.elementId;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface IRebarEstimationEdit {
    scenarioId?: string | undefined;
    elementId?: string;
    value?: number;
    valueType?: string;
}

export class AssignRebarEstimationsRequest implements IAssignRebarEstimationsRequest {
    projectId?: string;
    modelId?: string;
    scenarioId?: string;

    constructor(data?: IAssignRebarEstimationsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
        }
    }

    static fromJS(data: any): AssignRebarEstimationsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignRebarEstimationsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        return data;
    }
}

export interface IAssignRebarEstimationsRequest {
    projectId?: string;
    modelId?: string;
    scenarioId?: string;
}

export class AssignNonModelledElementsEditsRequest implements IAssignNonModelledElementsEditsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    edits?: NonModelledElementsEdit[] | undefined;

    constructor(data?: IAssignNonModelledElementsEditsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["edits"])) {
                this.edits = [] as any;
                for (let item of _data["edits"])
                    this.edits!.push(NonModelledElementsEdit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignNonModelledElementsEditsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignNonModelledElementsEditsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.edits)) {
            data["edits"] = [];
            for (let item of this.edits)
                data["edits"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignNonModelledElementsEditsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    edits?: NonModelledElementsEdit[] | undefined;
}

export class NonModelledElementsEdit implements INonModelledElementsEdit {
    scenarioId?: string | undefined;
    elementId?: string;
    value?: number;
    valueType?: string;

    constructor(data?: INonModelledElementsEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.elementId = _data["elementId"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): NonModelledElementsEdit {
        data = typeof data === 'object' ? data : {};
        let result = new NonModelledElementsEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["elementId"] = this.elementId;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface INonModelledElementsEdit {
    scenarioId?: string | undefined;
    elementId?: string;
    value?: number;
    valueType?: string;
}

export class AssignNonModelledElementsRequest implements IAssignNonModelledElementsRequest {
    projectId?: string;
    modelId?: string;
    scenarioId?: string;

    constructor(data?: IAssignNonModelledElementsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
        }
    }

    static fromJS(data: any): AssignNonModelledElementsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignNonModelledElementsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        return data;
    }
}

export interface IAssignNonModelledElementsRequest {
    projectId?: string;
    modelId?: string;
    scenarioId?: string;
}

export class AssignScopesRequest implements IAssignScopesRequest {
    modelId?: string;
    categoryScopes?: AssignScopeCategory[];
    elementScopes?: AssignScopeElement[];

    constructor(data?: IAssignScopesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["categoryScopes"])) {
                this.categoryScopes = [] as any;
                for (let item of _data["categoryScopes"])
                    this.categoryScopes!.push(AssignScopeCategory.fromJS(item));
            }
            if (Array.isArray(_data["elementScopes"])) {
                this.elementScopes = [] as any;
                for (let item of _data["elementScopes"])
                    this.elementScopes!.push(AssignScopeElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssignScopesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignScopesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        if (Array.isArray(this.categoryScopes)) {
            data["categoryScopes"] = [];
            for (let item of this.categoryScopes)
                data["categoryScopes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elementScopes)) {
            data["elementScopes"] = [];
            for (let item of this.elementScopes)
                data["elementScopes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAssignScopesRequest {
    modelId?: string;
    categoryScopes?: AssignScopeCategory[];
    elementScopes?: AssignScopeElement[];
}

export class AssignScopeCategory implements IAssignScopeCategory {
    cadModelCategoryId?: string;
    scopeId?: number;

    constructor(data?: IAssignScopeCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.scopeId = _data["scopeId"];
        }
    }

    static fromJS(data: any): AssignScopeCategory {
        data = typeof data === 'object' ? data : {};
        let result = new AssignScopeCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["scopeId"] = this.scopeId;
        return data;
    }
}

export interface IAssignScopeCategory {
    cadModelCategoryId?: string;
    scopeId?: number;
}

export class AssignScopeElement implements IAssignScopeElement {
    elementId?: string;
    scopeId?: number;

    constructor(data?: IAssignScopeElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.elementId = _data["elementId"];
            this.scopeId = _data["scopeId"];
        }
    }

    static fromJS(data: any): AssignScopeElement {
        data = typeof data === 'object' ? data : {};
        let result = new AssignScopeElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        data["scopeId"] = this.scopeId;
        return data;
    }
}

export interface IAssignScopeElement {
    elementId?: string;
    scopeId?: number;
}

export class RemoveMaterialsRequest implements IRemoveMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: RemoveCategoryMaterial[];
    elements?: RemoveByElement[];

    constructor(data?: IRemoveMaterialsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(RemoveCategoryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(RemoveByElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoveMaterialsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveMaterialsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRemoveMaterialsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: RemoveCategoryMaterial[];
    elements?: RemoveByElement[];
}

export class RemoveCategoryMaterial implements IRemoveCategoryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;

    constructor(data?: IRemoveCategoryMaterial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
        }
    }

    static fromJS(data: any): RemoveCategoryMaterial {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveCategoryMaterial();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        return data;
    }
}

export interface IRemoveCategoryMaterial {
    scenarioId?: string | undefined;
    cadModelCategoryId?: string;
}

export class RemoveByElement implements IRemoveByElement {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;

    constructor(data?: IRemoveByElement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.elementId = _data["elementId"];
        }
    }

    static fromJS(data: any): RemoveByElement {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveByElement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["elementId"] = this.elementId;
        return data;
    }
}

export interface IRemoveByElement {
    scenarioId?: string | undefined;
    /** Can be an ElementId or ComponentId */
    elementId?: string;
}

export class RemoveSupplementalsRequest implements IRemoveSupplementalsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: RemoveCategoryMaterial[];
    elements?: RemoveByElement[];

    constructor(data?: IRemoveSupplementalsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(RemoveCategoryMaterial.fromJS(item));
            }
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(RemoveByElement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RemoveSupplementalsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveSupplementalsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRemoveSupplementalsRequest {
    modelId?: string;
    scenarioId?: string | undefined;
    categories?: RemoveCategoryMaterial[];
    elements?: RemoveByElement[];
}

export class ModelSplitRequest implements IModelSplitRequest {
    modelId?: string;
    projectId?: string;
    parts?: Part[];

    constructor(data?: IModelSplitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["parts"])) {
                this.parts = [] as any;
                for (let item of _data["parts"])
                    this.parts!.push(Part.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelSplitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ModelSplitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.parts)) {
            data["parts"] = [];
            for (let item of this.parts)
                data["parts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModelSplitRequest {
    modelId?: string;
    projectId?: string;
    parts?: Part[];
}

export class Part implements IPart {
    partName?: string;
    cadModelCategoryIds?: string[];

    constructor(data?: IPart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partName = _data["partName"];
            if (Array.isArray(_data["cadModelCategoryIds"])) {
                this.cadModelCategoryIds = [] as any;
                for (let item of _data["cadModelCategoryIds"])
                    this.cadModelCategoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Part {
        data = typeof data === 'object' ? data : {};
        let result = new Part();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partName"] = this.partName;
        if (Array.isArray(this.cadModelCategoryIds)) {
            data["cadModelCategoryIds"] = [];
            for (let item of this.cadModelCategoryIds)
                data["cadModelCategoryIds"].push(item);
        }
        return data;
    }
}

export interface IPart {
    partName?: string;
    cadModelCategoryIds?: string[];
}

export class CreateModelVersionRequest implements ICreateModelVersionRequest {
    /** Project ID where the new version will be created */
    projectId?: string;
    /** Source model ID to create version from */
    sourceModelId?: string;
    /** Optional suffix for the version name (from dialog input) */
    suffix?: string | undefined;
    /** All extended data entries - differentiated by NodeType (Element, Component, Category, Family) */
    extendedData?: ModelExtendedData[];

    constructor(data?: ICreateModelVersionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.sourceModelId = _data["sourceModelId"];
            this.suffix = _data["suffix"];
            if (Array.isArray(_data["extendedData"])) {
                this.extendedData = [] as any;
                for (let item of _data["extendedData"])
                    this.extendedData!.push(ModelExtendedData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateModelVersionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModelVersionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["sourceModelId"] = this.sourceModelId;
        data["suffix"] = this.suffix;
        if (Array.isArray(this.extendedData)) {
            data["extendedData"] = [];
            for (let item of this.extendedData)
                data["extendedData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateModelVersionRequest {
    /** Project ID where the new version will be created */
    projectId?: string;
    /** Source model ID to create version from */
    sourceModelId?: string;
    /** Optional suffix for the version name (from dialog input) */
    suffix?: string | undefined;
    /** All extended data entries - differentiated by NodeType (Element, Component, Category, Family) */
    extendedData?: ModelExtendedData[];
}

/** Unified class for model extended data that consolidates all multiplier data types Uses NodeType to differentiate between Element, Component, Category, and Family data */
export class ModelExtendedData implements IModelExtendedData {
    /** Unique identifier for the node (ElementId, ComponentId, CategoryId, or FamilyKey as string) */
    nodeId?: string;
    /** Type of node this data belongs to - discriminator for the data type */
    nodeType?: ExtendedDataNodeType;
    /** Multiplier input expression as entered by user */
    multiplierInput?: string | undefined;
    /** Calculated multiplier value */
    multiplierValue?: number | undefined;
    /** User notes/comments */
    notes?: string | undefined;
    /** System classification ID (frontend sends string, convert to Guid) */
    systemId?: string | undefined;
    /** SubSystem classification ID (frontend sends string, convert to Guid) */
    subSystemId?: string | undefined;
    /** Custom attribute 1 */
    attribute1?: string | undefined;
    /** Custom attribute 2 */
    attribute2?: string | undefined;
    /** Custom attribute 3 */
    attribute3?: string | undefined;
    /** HasChildMultiplierOverride. */
    hasChildMultiplierOverride?: boolean;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;

    constructor(data?: IModelExtendedData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeId = _data["nodeId"];
            this.nodeType = _data["nodeType"];
            this.multiplierInput = _data["multiplierInput"];
            this.multiplierValue = _data["multiplierValue"];
            this.notes = _data["notes"];
            this.systemId = _data["systemId"];
            this.subSystemId = _data["subSystemId"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.hasChildMultiplierOverride = _data["hasChildMultiplierOverride"];
            this.carbonImpactValue = _data["carbonImpactValue"];
            this.carbonImpactInput = _data["carbonImpactInput"];
            this.carbonImpactNotes = _data["carbonImpactNotes"];
            this.hasChildCarbonImpactOverride = _data["hasChildCarbonImpactOverride"];
        }
    }

    static fromJS(data: any): ModelExtendedData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelExtendedData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeId"] = this.nodeId;
        data["nodeType"] = this.nodeType;
        data["multiplierInput"] = this.multiplierInput;
        data["multiplierValue"] = this.multiplierValue;
        data["notes"] = this.notes;
        data["systemId"] = this.systemId;
        data["subSystemId"] = this.subSystemId;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["hasChildMultiplierOverride"] = this.hasChildMultiplierOverride;
        data["carbonImpactValue"] = this.carbonImpactValue;
        data["carbonImpactInput"] = this.carbonImpactInput;
        data["carbonImpactNotes"] = this.carbonImpactNotes;
        data["hasChildCarbonImpactOverride"] = this.hasChildCarbonImpactOverride;
        return data;
    }
}

/** Unified class for model extended data that consolidates all multiplier data types Uses NodeType to differentiate between Element, Component, Category, and Family data */
export interface IModelExtendedData {
    /** Unique identifier for the node (ElementId, ComponentId, CategoryId, or FamilyKey as string) */
    nodeId?: string;
    /** Type of node this data belongs to - discriminator for the data type */
    nodeType?: ExtendedDataNodeType;
    /** Multiplier input expression as entered by user */
    multiplierInput?: string | undefined;
    /** Calculated multiplier value */
    multiplierValue?: number | undefined;
    /** User notes/comments */
    notes?: string | undefined;
    /** System classification ID (frontend sends string, convert to Guid) */
    systemId?: string | undefined;
    /** SubSystem classification ID (frontend sends string, convert to Guid) */
    subSystemId?: string | undefined;
    /** Custom attribute 1 */
    attribute1?: string | undefined;
    /** Custom attribute 2 */
    attribute2?: string | undefined;
    /** Custom attribute 3 */
    attribute3?: string | undefined;
    /** HasChildMultiplierOverride. */
    hasChildMultiplierOverride?: boolean;
    carbonImpactValue?: number | undefined;
    carbonImpactInput?: string | undefined;
    carbonImpactNotes?: string | undefined;
    hasChildCarbonImpactOverride?: boolean;
}

export enum ExtendedDataNodeType {
    Group = "Group",
    Category = "Category",
    Family = "Family",
    Element = "Element",
    Component = "Component",
    Supplemental = "Supplemental",
}

export class DeleteModelRequest implements IDeleteModelRequest {
    /** ID of the model to delete */
    modelId?: string;
    /** Project ID for validation */
    projectId?: string;

    constructor(data?: IDeleteModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): DeleteModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IDeleteModelRequest {
    /** ID of the model to delete */
    modelId?: string;
    /** Project ID for validation */
    projectId?: string;
}

export class ModelUsageInfo implements IModelUsageInfo {
    isUsedInScenarios?: boolean;
    isUsedInMaterials?: boolean;
    isDeleteOrUpdateEligible?: boolean;
    usageDetails?: string[];

    constructor(data?: IModelUsageInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUsedInScenarios = _data["isUsedInScenarios"];
            this.isUsedInMaterials = _data["isUsedInMaterials"];
            this.isDeleteOrUpdateEligible = _data["isDeleteOrUpdateEligible"];
            if (Array.isArray(_data["usageDetails"])) {
                this.usageDetails = [] as any;
                for (let item of _data["usageDetails"])
                    this.usageDetails!.push(item);
            }
        }
    }

    static fromJS(data: any): ModelUsageInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ModelUsageInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUsedInScenarios"] = this.isUsedInScenarios;
        data["isUsedInMaterials"] = this.isUsedInMaterials;
        data["isDeleteOrUpdateEligible"] = this.isDeleteOrUpdateEligible;
        if (Array.isArray(this.usageDetails)) {
            data["usageDetails"] = [];
            for (let item of this.usageDetails)
                data["usageDetails"].push(item);
        }
        return data;
    }
}

export interface IModelUsageInfo {
    isUsedInScenarios?: boolean;
    isUsedInMaterials?: boolean;
    isDeleteOrUpdateEligible?: boolean;
    usageDetails?: string[];
}

export class ModelTypeDto implements IModelTypeDto {
    cadFamily?: string;
    cadName?: string;
    display?: string;

    constructor(data?: IModelTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadFamily = _data["cadFamily"];
            this.cadName = _data["cadName"];
            this.display = _data["display"];
        }
    }

    static fromJS(data: any): ModelTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadFamily"] = this.cadFamily;
        data["cadName"] = this.cadName;
        data["display"] = this.display;
        return data;
    }
}

export interface IModelTypeDto {
    cadFamily?: string;
    cadName?: string;
    display?: string;
}

export class UpdateModelVersionRequest implements IUpdateModelVersionRequest {
    /** Model ID to update */
    modelId?: string;
    /** All extended data entries with their updated values - differentiated by NodeType */
    extendedData?: ModelExtendedData[];

    constructor(data?: IUpdateModelVersionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["extendedData"])) {
                this.extendedData = [] as any;
                for (let item of _data["extendedData"])
                    this.extendedData!.push(ModelExtendedData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateModelVersionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModelVersionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        if (Array.isArray(this.extendedData)) {
            data["extendedData"] = [];
            for (let item of this.extendedData)
                data["extendedData"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateModelVersionRequest {
    /** Model ID to update */
    modelId?: string;
    /** All extended data entries with their updated values - differentiated by NodeType */
    extendedData?: ModelExtendedData[];
}

export class NodeHierarchyDto implements INodeHierarchyDto {
    id?: number;
    name?: string;
    nodeType?: string;
    parentId?: number | undefined;

    constructor(data?: INodeHierarchyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.nodeType = _data["nodeType"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): NodeHierarchyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodeHierarchyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["nodeType"] = this.nodeType;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface INodeHierarchyDto {
    id?: number;
    name?: string;
    nodeType?: string;
    parentId?: number | undefined;
}

export class EtlJob implements IEtlJob {
    jobId?: number;
    jobGuid?: string;
    templateType?: TemplateType;
    filename?: string;
    name?: string;
    revision?: number;
    createdAt?: Date;
    completedAt?: Date | undefined;
    templateData?: any | undefined;
    templateErrors?: any | undefined;
    arguments?: any | undefined;
    status?: EtlStatus;

    constructor(data?: IEtlJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobGuid = _data["jobGuid"];
            this.templateType = _data["templateType"];
            this.filename = _data["filename"];
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.templateData = _data["templateData"];
            this.templateErrors = _data["templateErrors"];
            this.arguments = _data["arguments"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): EtlJob {
        data = typeof data === 'object' ? data : {};
        let result = new EtlJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobGuid"] = this.jobGuid;
        data["templateType"] = this.templateType;
        data["filename"] = this.filename;
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["templateData"] = this.templateData;
        data["templateErrors"] = this.templateErrors;
        data["arguments"] = this.arguments;
        data["status"] = this.status;
        return data;
    }
}

export interface IEtlJob {
    jobId?: number;
    jobGuid?: string;
    templateType?: TemplateType;
    filename?: string;
    name?: string;
    revision?: number;
    createdAt?: Date;
    completedAt?: Date | undefined;
    templateData?: any | undefined;
    templateErrors?: any | undefined;
    arguments?: any | undefined;
    status?: EtlStatus;
}

export enum TemplateType {
    Unknown = "unknown",
    CadMaterials = "cad-materials",
    CadMaterialCategories = "cad-material-categories",
    Co2MaterialCategores = "co2-material-categories",
    Co2MaterialTypes = "co2-material-types",
    Co2MaterialUnits = "co2-material-units",
    MaterialMappings = "material-mappings",
    ModelCategories = "model-categories",
    Models = "models",
    ModelElements = "model-elements",
    LanguageTranslations = "language-translations",
    Users = "users",
    ProjectResults = "project-results",
    ModelExcelImport = "model-excel-import",
    ModelIfcImport = "model-ifc-import",
    VeracityCo2MaterialTypes = "veracity-co2-material-types",
    SustainabilityImport = "sustainability-import",
    ProfileMapping = "profile-mapping",
    MultiProjectResults = "multi-project-results",
    NonModelledElementsExport = "non-modelled-elements",
}

export enum EtlStatus {
    Unknown = "unknown",
    Pending = "pending",
    Inprogress = "inprogress",
    Cancelled = "cancelled",
    FailedInstructions = "failedInstructions",
    Success = "success",
}

export class ImportModelEtlJobsRequest implements IImportModelEtlJobsRequest {
    projectIds?: string[];

    constructor(data?: IImportModelEtlJobsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ImportModelEtlJobsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportModelEtlJobsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IImportModelEtlJobsRequest {
    projectIds?: string[];
}

export class JobsRequest implements IJobsRequest {
    projectIds?: string[] | undefined;
    modelIds?: string[] | undefined;

    constructor(data?: IJobsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): JobsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new JobsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        return data;
    }
}

export interface IJobsRequest {
    projectIds?: string[] | undefined;
    modelIds?: string[] | undefined;
}

export class UserProfileResult implements IUserProfileResult {
    token?: Token;
    userProfile?: UserProfile;

    constructor(data?: IUserProfileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"] ? Token.fromJS(_data["token"]) : undefined as any;
            this.userProfile = _data["userProfile"] ? UserProfile.fromJS(_data["userProfile"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserProfileResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token ? this.token.toJSON() : undefined as any;
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserProfileResult {
    token?: Token;
    userProfile?: UserProfile;
}

export class Token implements IToken {
    accessToken?: string;
    tokenType?: string;
    expiresIn?: number;

    constructor(data?: IToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.tokenType = _data["tokenType"];
            this.expiresIn = _data["expiresIn"];
        }
    }

    static fromJS(data: any): Token {
        data = typeof data === 'object' ? data : {};
        let result = new Token();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["tokenType"] = this.tokenType;
        data["expiresIn"] = this.expiresIn;
        return data;
    }
}

export interface IToken {
    accessToken?: string;
    tokenType?: string;
    expiresIn?: number;
}

export class UserProfile implements IUserProfile {
    userId?: string;
    apsUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    imageUrl?: string | undefined;
    createdAt?: Date;
    modifiedAt?: Date;
    countryCode?: string | undefined;
    emailId?: string | undefined;
    language?: string | undefined;

    constructor(data?: IUserProfile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.apsUserId = _data["apsUserId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.userName = _data["userName"];
            this.imageUrl = _data["imageUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.countryCode = _data["countryCode"];
            this.emailId = _data["emailId"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): UserProfile {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["apsUserId"] = this.apsUserId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["imageUrl"] = this.imageUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["countryCode"] = this.countryCode;
        data["emailId"] = this.emailId;
        data["language"] = this.language;
        return data;
    }
}

export interface IUserProfile {
    userId?: string;
    apsUserId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    imageUrl?: string | undefined;
    createdAt?: Date;
    modifiedAt?: Date;
    countryCode?: string | undefined;
    emailId?: string | undefined;
    language?: string | undefined;
}

export class PermissionsResponse implements IPermissionsResponse {
    permissions?: PermissionResponse[];

    constructor(data?: IPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPermissionsResponse {
    permissions?: PermissionResponse[];
}

export class PermissionResponse implements IPermissionResponse {
    permissionId?: string;
    name?: string;
    description?: string | undefined;

    constructor(data?: IPermissionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.permissionId = _data["permissionId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["permissionId"] = this.permissionId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IPermissionResponse {
    permissionId?: string;
    name?: string;
    description?: string | undefined;
}

export class CreateResourceUserRequest implements ICreateResourceUserRequest {
    resourceId?: string;
    apsProjectId?: string | undefined;
    apsUserId?: string | undefined;
    apsRoles?: ProjectUserResponseAllOfRoles[];
    resourceType?: ResourceType;
    email?: string;

    constructor(data?: ICreateResourceUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsUserId = _data["apsUserId"];
            if (Array.isArray(_data["apsRoles"])) {
                this.apsRoles = [] as any;
                for (let item of _data["apsRoles"])
                    this.apsRoles!.push(ProjectUserResponseAllOfRoles.fromJS(item));
            }
            this.resourceType = _data["resourceType"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateResourceUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResourceUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["apsProjectId"] = this.apsProjectId;
        data["apsUserId"] = this.apsUserId;
        if (Array.isArray(this.apsRoles)) {
            data["apsRoles"] = [];
            for (let item of this.apsRoles)
                data["apsRoles"].push(item ? item.toJSON() : undefined as any);
        }
        data["resourceType"] = this.resourceType;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateResourceUserRequest {
    resourceId?: string;
    apsProjectId?: string | undefined;
    apsUserId?: string | undefined;
    apsRoles?: ProjectUserResponseAllOfRoles[];
    resourceType?: ResourceType;
    email?: string;
}

export class ProjectUserResponseAllOfRoles implements IProjectUserResponseAllOfRoles {
    id?: string | undefined;
    name?: string;

    constructor(data?: IProjectUserResponseAllOfRoles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectUserResponseAllOfRoles {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserResponseAllOfRoles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectUserResponseAllOfRoles {
    id?: string | undefined;
    name?: string;
}

export enum ResourceType {
    Unknown = "Unknown",
    Project = "Project",
}

export class DeleteResourceUserRequest implements IDeleteResourceUserRequest {
    resourceId?: string;
    userId?: string;

    constructor(data?: IDeleteResourceUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): DeleteResourceUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteResourceUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IDeleteResourceUserRequest {
    resourceId?: string;
    userId?: string;
}

export class RolesResponse implements IRolesResponse {
    roles?: RoleResponse[];

    constructor(data?: IRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRolesResponse {
    roles?: RoleResponse[];
}

export class RoleResponse implements IRoleResponse {
    roleId?: string;
    name?: string;
    description?: string;

    constructor(data?: IRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IRoleResponse {
    roleId?: string;
    name?: string;
    description?: string;
}

export class CreateRoleRequest implements ICreateRoleRequest {
    name?: string;
    description?: string;

    constructor(data?: ICreateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateRoleRequest {
    name?: string;
    description?: string;
}

export class UpdateUserRolesRequest implements IUpdateUserRolesRequest {
    userId?: string;
    roles?: string[];

    constructor(data?: IUpdateUserRolesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserRolesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRolesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserRolesRequest {
    userId?: string;
    roles?: string[];
}

export class RolePermissionsResponse implements IRolePermissionsResponse {
    roleId?: string;
    roleName?: string;
    availablePermissions?: string[];
    selectedPermissions?: string[];
    defaultPermissions?: string[];

    constructor(data?: IRolePermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            if (Array.isArray(_data["availablePermissions"])) {
                this.availablePermissions = [] as any;
                for (let item of _data["availablePermissions"])
                    this.availablePermissions!.push(item);
            }
            if (Array.isArray(_data["selectedPermissions"])) {
                this.selectedPermissions = [] as any;
                for (let item of _data["selectedPermissions"])
                    this.selectedPermissions!.push(item);
            }
            if (Array.isArray(_data["defaultPermissions"])) {
                this.defaultPermissions = [] as any;
                for (let item of _data["defaultPermissions"])
                    this.defaultPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RolePermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RolePermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        if (Array.isArray(this.availablePermissions)) {
            data["availablePermissions"] = [];
            for (let item of this.availablePermissions)
                data["availablePermissions"].push(item);
        }
        if (Array.isArray(this.selectedPermissions)) {
            data["selectedPermissions"] = [];
            for (let item of this.selectedPermissions)
                data["selectedPermissions"].push(item);
        }
        if (Array.isArray(this.defaultPermissions)) {
            data["defaultPermissions"] = [];
            for (let item of this.defaultPermissions)
                data["defaultPermissions"].push(item);
        }
        return data;
    }
}

export interface IRolePermissionsResponse {
    roleId?: string;
    roleName?: string;
    availablePermissions?: string[];
    selectedPermissions?: string[];
    defaultPermissions?: string[];
}

export class UpdateRolePermissionsRequest implements IUpdateRolePermissionsRequest {
    permissions?: string[];

    constructor(data?: IUpdateRolePermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRolePermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRolePermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IUpdateRolePermissionsRequest {
    permissions?: string[];
}

export class ExternalRolesResponse implements IExternalRolesResponse {
    externalRoles?: ExternalRoleResponse[];

    constructor(data?: IExternalRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalRoles"])) {
                this.externalRoles = [] as any;
                for (let item of _data["externalRoles"])
                    this.externalRoles!.push(ExternalRoleResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalRoles)) {
            data["externalRoles"] = [];
            for (let item of this.externalRoles)
                data["externalRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExternalRolesResponse {
    externalRoles?: ExternalRoleResponse[];
}

export class ExternalRoleResponse implements IExternalRoleResponse {
    externalRoleId?: string;
    name?: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    linkedRoleIds?: string[];

    constructor(data?: IExternalRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalRoleId = _data["externalRoleId"];
            this.name = _data["name"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["linkedRoleIds"])) {
                this.linkedRoleIds = [] as any;
                for (let item of _data["linkedRoleIds"])
                    this.linkedRoleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalRoleId"] = this.externalRoleId;
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.linkedRoleIds)) {
            data["linkedRoleIds"] = [];
            for (let item of this.linkedRoleIds)
                data["linkedRoleIds"].push(item);
        }
        return data;
    }
}

export interface IExternalRoleResponse {
    externalRoleId?: string;
    name?: string;
    normalizedName?: string | undefined;
    description?: string | undefined;
    linkedRoleIds?: string[];
}

export class CreateExternalRoleRequest implements ICreateExternalRoleRequest {
    name?: string;
    description?: string | undefined;
    roleId?: string | undefined;

    constructor(data?: ICreateExternalRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): CreateExternalRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateExternalRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface ICreateExternalRoleRequest {
    name?: string;
    description?: string | undefined;
    roleId?: string | undefined;
}

export class UpdateExternalRoleRequest implements IUpdateExternalRoleRequest {
    externalRoleId?: string;
    name?: string;
    description?: string | undefined;
    roleId?: string | undefined;

    constructor(data?: IUpdateExternalRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalRoleId = _data["externalRoleId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.roleId = _data["roleId"];
        }
    }

    static fromJS(data: any): UpdateExternalRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalRoleId"] = this.externalRoleId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["roleId"] = this.roleId;
        return data;
    }
}

export interface IUpdateExternalRoleRequest {
    externalRoleId?: string;
    name?: string;
    description?: string | undefined;
    roleId?: string | undefined;
}

export class CreateUserRequest implements ICreateUserRequest {
    email?: string;
    role?: DefaultRoles;

    constructor(data?: ICreateUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["role"] = this.role;
        return data;
    }
}

export interface ICreateUserRequest {
    email?: string;
    role?: DefaultRoles;
}

export enum DefaultRoles {
    Admin = "Admin",
    NonAdmin = "NonAdmin",
}

export class ApplicationUserResponse implements IApplicationUserResponse {
    userId?: string;
    apsUserId?: string | undefined;
    email?: string;
    firstName?: string;
    lastName?: string;
    imageUrl?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    isVerified?: boolean | undefined;
    name?: string;
    roles?: string[];

    constructor(data?: IApplicationUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.apsUserId = _data["apsUserId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.imageUrl = _data["imageUrl"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.isVerified = _data["isVerified"];
            this.name = _data["name"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["apsUserId"] = this.apsUserId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["imageUrl"] = this.imageUrl;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["isVerified"] = this.isVerified;
        data["name"] = this.name;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IApplicationUserResponse {
    userId?: string;
    apsUserId?: string | undefined;
    email?: string;
    firstName?: string;
    lastName?: string;
    imageUrl?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    isVerified?: boolean | undefined;
    name?: string;
    roles?: string[];
}

export class Claim implements IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | undefined;
    type?: string;
    value?: string;
    valueType?: string;

    constructor(data?: IClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.originalIssuer = _data["originalIssuer"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
            this.subject = _data["subject"] ? ClaimsIdentity.fromJS(_data["subject"]) : undefined as any;
            this.type = _data["type"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
        }
    }

    static fromJS(data: any): Claim {
        data = typeof data === 'object' ? data : {};
        let result = new Claim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["originalIssuer"] = this.originalIssuer;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        data["subject"] = this.subject ? this.subject.toJSON() : undefined as any;
        data["type"] = this.type;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        return data;
    }
}

export interface IClaim {
    issuer?: string;
    originalIssuer?: string;
    properties?: { [key: string]: string; };
    subject?: ClaimsIdentity | undefined;
    type?: string;
    value?: string;
    valueType?: string;
}

export class ClaimsIdentity implements IClaimsIdentity {
    authenticationType?: string | undefined;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | undefined;
    bootstrapContext?: any | undefined;
    claims?: Claim[];
    label?: string | undefined;
    name?: string | undefined;
    nameClaimType?: string;
    roleClaimType?: string;

    constructor(data?: IClaimsIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authenticationType = _data["authenticationType"];
            this.isAuthenticated = _data["isAuthenticated"];
            this.actor = _data["actor"] ? ClaimsIdentity.fromJS(_data["actor"]) : undefined as any;
            this.bootstrapContext = _data["bootstrapContext"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [] as any;
                for (let item of _data["claims"])
                    this.claims!.push(Claim.fromJS(item));
            }
            this.label = _data["label"];
            this.name = _data["name"];
            this.nameClaimType = _data["nameClaimType"];
            this.roleClaimType = _data["roleClaimType"];
        }
    }

    static fromJS(data: any): ClaimsIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimsIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authenticationType"] = this.authenticationType;
        data["isAuthenticated"] = this.isAuthenticated;
        data["actor"] = this.actor ? this.actor.toJSON() : undefined as any;
        data["bootstrapContext"] = this.bootstrapContext;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item ? item.toJSON() : undefined as any);
        }
        data["label"] = this.label;
        data["name"] = this.name;
        data["nameClaimType"] = this.nameClaimType;
        data["roleClaimType"] = this.roleClaimType;
        return data;
    }
}

export interface IClaimsIdentity {
    authenticationType?: string | undefined;
    isAuthenticated?: boolean;
    actor?: ClaimsIdentity | undefined;
    bootstrapContext?: any | undefined;
    claims?: Claim[];
    label?: string | undefined;
    name?: string | undefined;
    nameClaimType?: string;
    roleClaimType?: string;
}

export class DeleteUserRolesRequest implements IDeleteUserRolesRequest {
    email?: string;

    constructor(data?: IDeleteUserRolesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DeleteUserRolesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUserRolesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IDeleteUserRolesRequest {
    email?: string;
}

/** Lightweight catalog summary used in project dropdowns. */
export class BenchmarkCatalogSummaryDto implements IBenchmarkCatalogSummaryDto {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;

    constructor(data?: IBenchmarkCatalogSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): BenchmarkCatalogSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

/** Lightweight catalog summary used in project dropdowns. */
export interface IBenchmarkCatalogSummaryDto {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;
}

/** Full catalog with all value rows (existing + [NEW] gaps). */
export class BenchmarkCatalogDto implements IBenchmarkCatalogDto {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueDto[];
    /** True when this catalog is linked to one or more projects.
Used by the UI to conditionally hide the delete action. */
    isInUse?: boolean;

    constructor(data?: IBenchmarkCatalogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(BenchmarkCatalogValueDto.fromJS(item));
            }
            this.isInUse = _data["isInUse"];
        }
    }

    static fromJS(data: any): BenchmarkCatalogDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        data["isInUse"] = this.isInUse;
        return data;
    }
}

/** Full catalog with all value rows (existing + [NEW] gaps). */
export interface IBenchmarkCatalogDto {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueDto[];
    /** True when this catalog is linked to one or more projects.
Used by the UI to conditionally hide the delete action. */
    isInUse?: boolean;
}

/** Single value row within a catalog (one row per scope). IsNew is true when a BenchmarkModelType exists in the system but has no value row in this catalog yet (used by the dialog to show a [NEW] indicator and blank input). */
export class BenchmarkCatalogValueDto implements IBenchmarkCatalogValueDto {
    /** ID of the child MetadataEntity (BenchmarkCatalogValue).
Empty GUID when IsNew = true. */
    metadataEntityId?: string;
    scope?: string;
    modelTypeEntityId?: string | undefined;
    modelTypeName?: string | undefined;
    valueKgCo2ePerM2?: number;
    isNew?: boolean;

    constructor(data?: IBenchmarkCatalogValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.scope = _data["scope"];
            this.modelTypeEntityId = _data["modelTypeEntityId"];
            this.modelTypeName = _data["modelTypeName"];
            this.valueKgCo2ePerM2 = _data["valueKgCo2ePerM2"];
            this.isNew = _data["isNew"];
        }
    }

    static fromJS(data: any): BenchmarkCatalogValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["scope"] = this.scope;
        data["modelTypeEntityId"] = this.modelTypeEntityId;
        data["modelTypeName"] = this.modelTypeName;
        data["valueKgCo2ePerM2"] = this.valueKgCo2ePerM2;
        data["isNew"] = this.isNew;
        return data;
    }
}

/** Single value row within a catalog (one row per scope). IsNew is true when a BenchmarkModelType exists in the system but has no value row in this catalog yet (used by the dialog to show a [NEW] indicator and blank input). */
export interface IBenchmarkCatalogValueDto {
    /** ID of the child MetadataEntity (BenchmarkCatalogValue).
Empty GUID when IsNew = true. */
    metadataEntityId?: string;
    scope?: string;
    modelTypeEntityId?: string | undefined;
    modelTypeName?: string | undefined;
    valueKgCo2ePerM2?: number;
    isNew?: boolean;
}

export class BenchmarkCatalogCreateRequest implements IBenchmarkCatalogCreateRequest {
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueInput[];

    constructor(data?: IBenchmarkCatalogCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(BenchmarkCatalogValueInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BenchmarkCatalogCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBenchmarkCatalogCreateRequest {
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueInput[];
}

export class BenchmarkCatalogValueInput implements IBenchmarkCatalogValueInput {
    /** "WholeBuilding" or "ModelType". */
    scope?: string;
    /** Null when Scope is "WholeBuilding". */
    modelTypeEntityId?: string | undefined;
    valueKgCo2ePerM2?: number;

    constructor(data?: IBenchmarkCatalogValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scope = _data["scope"];
            this.modelTypeEntityId = _data["modelTypeEntityId"];
            this.valueKgCo2ePerM2 = _data["valueKgCo2ePerM2"];
        }
    }

    static fromJS(data: any): BenchmarkCatalogValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scope"] = this.scope;
        data["modelTypeEntityId"] = this.modelTypeEntityId;
        data["valueKgCo2ePerM2"] = this.valueKgCo2ePerM2;
        return data;
    }
}

export interface IBenchmarkCatalogValueInput {
    /** "WholeBuilding" or "ModelType". */
    scope?: string;
    /** Null when Scope is "WholeBuilding". */
    modelTypeEntityId?: string | undefined;
    valueKgCo2ePerM2?: number;
}

export class BenchmarkCatalogUpdateRequest implements IBenchmarkCatalogUpdateRequest {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueInput[];

    constructor(data?: IBenchmarkCatalogUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(BenchmarkCatalogValueInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BenchmarkCatalogUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BenchmarkCatalogUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBenchmarkCatalogUpdateRequest {
    metadataEntityId?: string;
    name?: string;
    description?: string | undefined;
    values?: BenchmarkCatalogValueInput[];
}

/** Response payload for GET /api/projects/{id}/benchmark-and-targets. Used by the Results page to render reference line overlays. */
export class ProjectBenchmarkAndTargetsDto implements IProjectBenchmarkAndTargetsDto {
    /** Read-only values from the linked BenchmarkCatalog. Empty if no catalog is linked. */
    benchmarkValues?: BenchmarkCatalogValueDto[];
    /** Editable project-specific target values from the ProjectTargets table. */
    targetValues?: ProjectTargetDto[];

    constructor(data?: IProjectBenchmarkAndTargetsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["benchmarkValues"])) {
                this.benchmarkValues = [] as any;
                for (let item of _data["benchmarkValues"])
                    this.benchmarkValues!.push(BenchmarkCatalogValueDto.fromJS(item));
            }
            if (Array.isArray(_data["targetValues"])) {
                this.targetValues = [] as any;
                for (let item of _data["targetValues"])
                    this.targetValues!.push(ProjectTargetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectBenchmarkAndTargetsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBenchmarkAndTargetsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.benchmarkValues)) {
            data["benchmarkValues"] = [];
            for (let item of this.benchmarkValues)
                data["benchmarkValues"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.targetValues)) {
            data["targetValues"] = [];
            for (let item of this.targetValues)
                data["targetValues"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Response payload for GET /api/projects/{id}/benchmark-and-targets. Used by the Results page to render reference line overlays. */
export interface IProjectBenchmarkAndTargetsDto {
    /** Read-only values from the linked BenchmarkCatalog. Empty if no catalog is linked. */
    benchmarkValues?: BenchmarkCatalogValueDto[];
    /** Editable project-specific target values from the ProjectTargets table. */
    targetValues?: ProjectTargetDto[];
}

export class ProjectTargetDto implements IProjectTargetDto {
    projectTargetId?: string;
    scope?: string;
    modelTypeEntityId?: string | undefined;
    modelTypeName?: string | undefined;
    valueKgCo2ePerM2?: number;

    constructor(data?: IProjectTargetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectTargetId = _data["projectTargetId"];
            this.scope = _data["scope"];
            this.modelTypeEntityId = _data["modelTypeEntityId"];
            this.modelTypeName = _data["modelTypeName"];
            this.valueKgCo2ePerM2 = _data["valueKgCo2ePerM2"];
        }
    }

    static fromJS(data: any): ProjectTargetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTargetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectTargetId"] = this.projectTargetId;
        data["scope"] = this.scope;
        data["modelTypeEntityId"] = this.modelTypeEntityId;
        data["modelTypeName"] = this.modelTypeName;
        data["valueKgCo2ePerM2"] = this.valueKgCo2ePerM2;
        return data;
    }
}

export interface IProjectTargetDto {
    projectTargetId?: string;
    scope?: string;
    modelTypeEntityId?: string | undefined;
    modelTypeName?: string | undefined;
    valueKgCo2ePerM2?: number;
}

export class CadModelCategory2 implements ICadModelCategory2 {
    cadModelCategoryId?: string;
    name?: string | undefined;
    label?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: ICadModelCategory2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CadModelCategory2 {
        data = typeof data === 'object' ? data : {};
        let result = new CadModelCategory2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["name"] = this.name;
        data["label"] = this.label;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ICadModelCategory2 {
    cadModelCategoryId?: string;
    name?: string | undefined;
    label?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
}

export class Co2MaterialTypeOptions implements ICo2MaterialTypeOptions {
    co2MaterialCategories?: Co2MaterialCategory[];
    units?: Co2MaterialUnitOption[];
    coefficients?: Co2MaterialCoefficientOption[];
    co2MaterialLibraries?: Co2MaterialLibrary[];
    co2MaterialTypeSources?: Co2MaterialTypeSourceOption[];

    constructor(data?: ICo2MaterialTypeOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["co2MaterialCategories"])) {
                this.co2MaterialCategories = [] as any;
                for (let item of _data["co2MaterialCategories"])
                    this.co2MaterialCategories!.push(Co2MaterialCategory.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Co2MaterialUnitOption.fromJS(item));
            }
            if (Array.isArray(_data["coefficients"])) {
                this.coefficients = [] as any;
                for (let item of _data["coefficients"])
                    this.coefficients!.push(Co2MaterialCoefficientOption.fromJS(item));
            }
            if (Array.isArray(_data["co2MaterialLibraries"])) {
                this.co2MaterialLibraries = [] as any;
                for (let item of _data["co2MaterialLibraries"])
                    this.co2MaterialLibraries!.push(Co2MaterialLibrary.fromJS(item));
            }
            if (Array.isArray(_data["co2MaterialTypeSources"])) {
                this.co2MaterialTypeSources = [] as any;
                for (let item of _data["co2MaterialTypeSources"])
                    this.co2MaterialTypeSources!.push(Co2MaterialTypeSourceOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Co2MaterialTypeOptions {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialTypeOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.co2MaterialCategories)) {
            data["co2MaterialCategories"] = [];
            for (let item of this.co2MaterialCategories)
                data["co2MaterialCategories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.coefficients)) {
            data["coefficients"] = [];
            for (let item of this.coefficients)
                data["coefficients"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.co2MaterialLibraries)) {
            data["co2MaterialLibraries"] = [];
            for (let item of this.co2MaterialLibraries)
                data["co2MaterialLibraries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.co2MaterialTypeSources)) {
            data["co2MaterialTypeSources"] = [];
            for (let item of this.co2MaterialTypeSources)
                data["co2MaterialTypeSources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICo2MaterialTypeOptions {
    co2MaterialCategories?: Co2MaterialCategory[];
    units?: Co2MaterialUnitOption[];
    coefficients?: Co2MaterialCoefficientOption[];
    co2MaterialLibraries?: Co2MaterialLibrary[];
    co2MaterialTypeSources?: Co2MaterialTypeSourceOption[];
}

export class Co2MaterialUnitOption implements ICo2MaterialUnitOption {
    value?: string;
    name?: string;

    constructor(data?: ICo2MaterialUnitOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Co2MaterialUnitOption {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialUnitOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface ICo2MaterialUnitOption {
    value?: string;
    name?: string;
}

export class Co2MaterialCoefficientOption implements ICo2MaterialCoefficientOption {
    code?: string;
    unit?: string;
    value?: string;
    name?: string;

    constructor(data?: ICo2MaterialCoefficientOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.unit = _data["unit"];
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Co2MaterialCoefficientOption {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialCoefficientOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["unit"] = this.unit;
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface ICo2MaterialCoefficientOption {
    code?: string;
    unit?: string;
    value?: string;
    name?: string;
}

export class Co2MaterialTypeSourceOption implements ICo2MaterialTypeSourceOption {
    source?: string;
    co2MaterialLibrary?: Co2MaterialLibrary;

    constructor(data?: ICo2MaterialTypeSourceOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.co2MaterialLibrary = _data["co2MaterialLibrary"] ? Co2MaterialLibrary.fromJS(_data["co2MaterialLibrary"]) : undefined as any;
        }
    }

    static fromJS(data: any): Co2MaterialTypeSourceOption {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialTypeSourceOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["co2MaterialLibrary"] = this.co2MaterialLibrary ? this.co2MaterialLibrary.toJSON() : undefined as any;
        return data;
    }
}

export interface ICo2MaterialTypeSourceOption {
    source?: string;
    co2MaterialLibrary?: Co2MaterialLibrary;
}

export class UpsertCo2MaterialTypeResponse implements IUpsertCo2MaterialTypeResponse {
    successItems?: Co2MaterialType[];
    failureItems?: UpsertCo2MaterialTypeFailure[];

    constructor(data?: IUpsertCo2MaterialTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["successItems"])) {
                this.successItems = [] as any;
                for (let item of _data["successItems"])
                    this.successItems!.push(Co2MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["failureItems"])) {
                this.failureItems = [] as any;
                for (let item of _data["failureItems"])
                    this.failureItems!.push(UpsertCo2MaterialTypeFailure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertCo2MaterialTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCo2MaterialTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successItems)) {
            data["successItems"] = [];
            for (let item of this.successItems)
                data["successItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failureItems)) {
            data["failureItems"] = [];
            for (let item of this.failureItems)
                data["failureItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpsertCo2MaterialTypeResponse {
    successItems?: Co2MaterialType[];
    failureItems?: UpsertCo2MaterialTypeFailure[];
}

export class UpsertCo2MaterialTypeFailure implements IUpsertCo2MaterialTypeFailure {
    upsertCo2MaterialTypeRequest?: UpsertCo2MaterialTypeRequest;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IUpsertCo2MaterialTypeFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upsertCo2MaterialTypeRequest = _data["upsertCo2MaterialTypeRequest"] ? UpsertCo2MaterialTypeRequest.fromJS(_data["upsertCo2MaterialTypeRequest"]) : undefined as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): UpsertCo2MaterialTypeFailure {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCo2MaterialTypeFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upsertCo2MaterialTypeRequest"] = this.upsertCo2MaterialTypeRequest ? this.upsertCo2MaterialTypeRequest.toJSON() : undefined as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IUpsertCo2MaterialTypeFailure {
    upsertCo2MaterialTypeRequest?: UpsertCo2MaterialTypeRequest;
    errors?: { [key: string]: string[]; } | undefined;
}

export class UpsertCo2MaterialTypeRequest implements IUpsertCo2MaterialTypeRequest {
    /** Id of existing Co2MaterialType or null to create a new Co2MaterialType */
    co2MaterialTypeId?: string | undefined;
    /** Material is scoped to a specific user */
    userId?: string | undefined;
    /** Id of existing CadMaterialCategory */
    co2MaterialCategoryId?: string | undefined;
    /** Id of existing Co2MaterialLibrary */
    co2MaterialLibraryId?: string | undefined;
    /** External ID of the material provided by the Source */
    externalId?: string | undefined;
    /** Name of the material */
    name?: string | undefined;
    /** Description of the material */
    description?: string | undefined;
    /** Declared Unit of the material */
    unit?: string | undefined;
    /** Source of the material factor */
    source?: string | undefined;
    /** Stringified JSON object containing the source data */
    sourceData?: string | undefined;
    /** A1-A3 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a1A2A3?: number | undefined;
    /** A1-A3 Embodied Carbon Equivalence Factor (CO₂e) */
    a1A2A3_ECF?: number | undefined;
    /** A4 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a4?: number | undefined;
    /** A4 Embodied Carbon Equivalence Factor (CO₂e) */
    a4_ECF?: number | undefined;
    /** A5 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a5?: number | undefined;
    /** A5 Embodied Carbon Equivalence Factor (CO₂e) */
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    unitQuantity?: number | undefined;
    /** Material Density (kg/m³) */
    density?: number | undefined;
    /** Mass per Declared Unit (kg/Declared Unit) */
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    /** The active status of the material */
    deleteStatus?: SoftDeleteStatusType | undefined;
    /** Name of new CadMaterialCategory to be added */
    co2MaterialCategoryName?: string | undefined;
    /** Name of new Co2MaterialLibrary to be added */
    co2MaterialLibraryName?: string | undefined;
    /** DensityType of the material */
    densityType?: DensityType | undefined;

    constructor(data?: IUpsertCo2MaterialTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.userId = _data["userId"];
            this.co2MaterialCategoryId = _data["co2MaterialCategoryId"];
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.source = _data["source"];
            this.sourceData = _data["sourceData"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a1A2A3_ECF = _data["a1A2A3_ECF"];
            this.a4 = _data["a4"];
            this.a4_ECF = _data["a4_ECF"];
            this.a5 = _data["a5"];
            this.a5_ECF = _data["a5_ECF"];
            this.b1 = _data["b1"];
            this.b1_ECF = _data["b1_ECF"];
            this.b2 = _data["b2"];
            this.b2_ECF = _data["b2_ECF"];
            this.b3 = _data["b3"];
            this.b3_ECF = _data["b3_ECF"];
            this.b4 = _data["b4"];
            this.b4_ECF = _data["b4_ECF"];
            this.b5 = _data["b5"];
            this.b5_ECF = _data["b5_ECF"];
            this.b6 = _data["b6"];
            this.b6_ECF = _data["b6_ECF"];
            this.b7 = _data["b7"];
            this.b7_ECF = _data["b7_ECF"];
            this.c1 = _data["c1"];
            this.c1_ECF = _data["c1_ECF"];
            this.c2 = _data["c2"];
            this.c2_ECF = _data["c2_ECF"];
            this.c3 = _data["c3"];
            this.c3_ECF = _data["c3_ECF"];
            this.c4 = _data["c4"];
            this.c4_ECF = _data["c4_ECF"];
            this.d = _data["d"];
            this.d_ECF = _data["d_ECF"];
            this.biogenic = _data["biogenic"];
            this.biogenic_ECF = _data["biogenic_ECF"];
            this.wastage = _data["wastage"];
            this.unitQuantity = _data["unitQuantity"];
            this.density = _data["density"];
            this.massPerUnit = _data["massPerUnit"];
            this.omniClassNumber = _data["omniClassNumber"];
            this.omniClassTitle = _data["omniClassTitle"];
            this.uniFormatNumber = _data["uniFormatNumber"];
            this.uniFormatTitle = _data["uniFormatTitle"];
            this.masterFormatNumber = _data["masterFormatNumber"];
            this.masterFormatTitle = _data["masterFormatTitle"];
            this.deleteStatus = _data["deleteStatus"];
            this.co2MaterialCategoryName = _data["co2MaterialCategoryName"];
            this.co2MaterialLibraryName = _data["co2MaterialLibraryName"];
            this.densityType = _data["densityType"];
        }
    }

    static fromJS(data: any): UpsertCo2MaterialTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCo2MaterialTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["userId"] = this.userId;
        data["co2MaterialCategoryId"] = this.co2MaterialCategoryId;
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["source"] = this.source;
        data["sourceData"] = this.sourceData;
        data["a1A2A3"] = this.a1A2A3;
        data["a1A2A3_ECF"] = this.a1A2A3_ECF;
        data["a4"] = this.a4;
        data["a4_ECF"] = this.a4_ECF;
        data["a5"] = this.a5;
        data["a5_ECF"] = this.a5_ECF;
        data["b1"] = this.b1;
        data["b1_ECF"] = this.b1_ECF;
        data["b2"] = this.b2;
        data["b2_ECF"] = this.b2_ECF;
        data["b3"] = this.b3;
        data["b3_ECF"] = this.b3_ECF;
        data["b4"] = this.b4;
        data["b4_ECF"] = this.b4_ECF;
        data["b5"] = this.b5;
        data["b5_ECF"] = this.b5_ECF;
        data["b6"] = this.b6;
        data["b6_ECF"] = this.b6_ECF;
        data["b7"] = this.b7;
        data["b7_ECF"] = this.b7_ECF;
        data["c1"] = this.c1;
        data["c1_ECF"] = this.c1_ECF;
        data["c2"] = this.c2;
        data["c2_ECF"] = this.c2_ECF;
        data["c3"] = this.c3;
        data["c3_ECF"] = this.c3_ECF;
        data["c4"] = this.c4;
        data["c4_ECF"] = this.c4_ECF;
        data["d"] = this.d;
        data["d_ECF"] = this.d_ECF;
        data["biogenic"] = this.biogenic;
        data["biogenic_ECF"] = this.biogenic_ECF;
        data["wastage"] = this.wastage;
        data["unitQuantity"] = this.unitQuantity;
        data["density"] = this.density;
        data["massPerUnit"] = this.massPerUnit;
        data["omniClassNumber"] = this.omniClassNumber;
        data["omniClassTitle"] = this.omniClassTitle;
        data["uniFormatNumber"] = this.uniFormatNumber;
        data["uniFormatTitle"] = this.uniFormatTitle;
        data["masterFormatNumber"] = this.masterFormatNumber;
        data["masterFormatTitle"] = this.masterFormatTitle;
        data["deleteStatus"] = this.deleteStatus;
        data["co2MaterialCategoryName"] = this.co2MaterialCategoryName;
        data["co2MaterialLibraryName"] = this.co2MaterialLibraryName;
        data["densityType"] = this.densityType;
        return data;
    }
}

export interface IUpsertCo2MaterialTypeRequest {
    /** Id of existing Co2MaterialType or null to create a new Co2MaterialType */
    co2MaterialTypeId?: string | undefined;
    /** Material is scoped to a specific user */
    userId?: string | undefined;
    /** Id of existing CadMaterialCategory */
    co2MaterialCategoryId?: string | undefined;
    /** Id of existing Co2MaterialLibrary */
    co2MaterialLibraryId?: string | undefined;
    /** External ID of the material provided by the Source */
    externalId?: string | undefined;
    /** Name of the material */
    name?: string | undefined;
    /** Description of the material */
    description?: string | undefined;
    /** Declared Unit of the material */
    unit?: string | undefined;
    /** Source of the material factor */
    source?: string | undefined;
    /** Stringified JSON object containing the source data */
    sourceData?: string | undefined;
    /** A1-A3 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a1A2A3?: number | undefined;
    /** A1-A3 Embodied Carbon Equivalence Factor (CO₂e) */
    a1A2A3_ECF?: number | undefined;
    /** A4 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a4?: number | undefined;
    /** A4 Embodied Carbon Equivalence Factor (CO₂e) */
    a4_ECF?: number | undefined;
    /** A5 Embodied Carbon Equivalence Factor per Declared Unit (kgCO₂e/Declared Unit) */
    a5?: number | undefined;
    /** A5 Embodied Carbon Equivalence Factor (CO₂e) */
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    unitQuantity?: number | undefined;
    /** Material Density (kg/m³) */
    density?: number | undefined;
    /** Mass per Declared Unit (kg/Declared Unit) */
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    /** The active status of the material */
    deleteStatus?: SoftDeleteStatusType | undefined;
    /** Name of new CadMaterialCategory to be added */
    co2MaterialCategoryName?: string | undefined;
    /** Name of new Co2MaterialLibrary to be added */
    co2MaterialLibraryName?: string | undefined;
    /** DensityType of the material */
    densityType?: DensityType | undefined;
}

/** Used to Capture Aggregated Data such as Most used EC Material in a given category */
export class Co2MaterialTypeByCategory implements ICo2MaterialTypeByCategory {
    /** Indicates the Cad Model Category Name of elements */
    cadModelCategoryName?: string;
    co2MaterialTypeName?: string | undefined;
    count?: number | undefined;

    constructor(data?: ICo2MaterialTypeByCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryName = _data["cadModelCategoryName"];
            this.co2MaterialTypeName = _data["co2MaterialTypeName"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): Co2MaterialTypeByCategory {
        data = typeof data === 'object' ? data : {};
        let result = new Co2MaterialTypeByCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryName"] = this.cadModelCategoryName;
        data["co2MaterialTypeName"] = this.co2MaterialTypeName;
        data["count"] = this.count;
        return data;
    }
}

/** Used to Capture Aggregated Data such as Most used EC Material in a given category */
export interface ICo2MaterialTypeByCategory {
    /** Indicates the Cad Model Category Name of elements */
    cadModelCategoryName?: string;
    co2MaterialTypeName?: string | undefined;
    count?: number | undefined;
}

export class MetadataEntityResponse implements IMetadataEntityResponse {
    metadataEntityId?: string;
    name?: string;
    type?: MetadataEntityType;
    parentId?: string | undefined;
    description?: string | undefined;
    /** Structured JSON payload for types that require it (e.g. BenchmarkCatalogValue).
Null for all other types. */
    metadata?: string | undefined;
    children?: MetadataEntityResponse[];
    /** True when this entity is referenced by other records (e.g. a ScenarioType assigned to a scenario).
Used by the UI to conditionally hide the delete action. */
    isInUse?: boolean;
    /** Convenience property to get ModelFamilyType children when this entity is of type ModelFamily. */
    modelFamilyTypes?: MetadataEntityResponse[];

    constructor(data?: IMetadataEntityResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.description = _data["description"];
            this.metadata = _data["metadata"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(MetadataEntityResponse.fromJS(item));
            }
            this.isInUse = _data["isInUse"];
            if (Array.isArray(_data["modelFamilyTypes"])) {
                this.modelFamilyTypes = [] as any;
                for (let item of _data["modelFamilyTypes"])
                    this.modelFamilyTypes!.push(MetadataEntityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MetadataEntityResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataEntityResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["metadata"] = this.metadata;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["isInUse"] = this.isInUse;
        if (Array.isArray(this.modelFamilyTypes)) {
            data["modelFamilyTypes"] = [];
            for (let item of this.modelFamilyTypes)
                data["modelFamilyTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMetadataEntityResponse {
    metadataEntityId?: string;
    name?: string;
    type?: MetadataEntityType;
    parentId?: string | undefined;
    description?: string | undefined;
    /** Structured JSON payload for types that require it (e.g. BenchmarkCatalogValue).
Null for all other types. */
    metadata?: string | undefined;
    children?: MetadataEntityResponse[];
    /** True when this entity is referenced by other records (e.g. a ScenarioType assigned to a scenario).
Used by the UI to conditionally hide the delete action. */
    isInUse?: boolean;
    /** Convenience property to get ModelFamilyType children when this entity is of type ModelFamily. */
    modelFamilyTypes?: MetadataEntityResponse[];
}

/** Request Models used to create a new metadata entity. */
export class MetadataEntityCreateRequest implements IMetadataEntityCreateRequest {
    /** Display name for the entity (in English by default). */
    name?: string;
    /** Type of the entity (e.g., "System", "Subsystem", "Region").
This will be converted to an enum internally. */
    type?: string;
    /** Parent ID for hierarchical data. Null means root. */
    parentId?: string | undefined;
    /** Optional description. */
    description?: string | undefined;
    /** JSON metadata (stored as string). */
    metadata?: string | undefined;

    constructor(data?: IMetadataEntityCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.description = _data["description"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): MetadataEntityCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataEntityCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["metadata"] = this.metadata;
        return data;
    }
}

/** Request Models used to create a new metadata entity. */
export interface IMetadataEntityCreateRequest {
    /** Display name for the entity (in English by default). */
    name?: string;
    /** Type of the entity (e.g., "System", "Subsystem", "Region").
This will be converted to an enum internally. */
    type?: string;
    /** Parent ID for hierarchical data. Null means root. */
    parentId?: string | undefined;
    /** Optional description. */
    description?: string | undefined;
    /** JSON metadata (stored as string). */
    metadata?: string | undefined;
}

/** Request Models used for updating an existing metadata entity. */
export class MetadataEntityUpdateRequest implements IMetadataEntityUpdateRequest {
    /** The unique identifier of the entity to update. */
    metadataEntityId?: string;
    /** The updated display name of the entity. */
    name?: string;
    /** The updated type of the entity, such as "System", "Subsystem", "Region", etc. */
    type?: string;
    /** Optional updated parent entity ID. Null means the entity is a root entity. */
    parentId?: string | undefined;
    /** Optional updated description of the entity. */
    description?: string | undefined;
    /** Optional structured JSON payload. Used by BenchmarkCatalogValue to update
scope, modelTypeEntityId, and valueKgCo2ePerM2. Null for all other types. */
    metadata?: string | undefined;

    constructor(data?: IMetadataEntityUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.metadataEntityId = _data["metadataEntityId"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.parentId = _data["parentId"];
            this.description = _data["description"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): MetadataEntityUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataEntityUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["metadataEntityId"] = this.metadataEntityId;
        data["name"] = this.name;
        data["type"] = this.type;
        data["parentId"] = this.parentId;
        data["description"] = this.description;
        data["metadata"] = this.metadata;
        return data;
    }
}

/** Request Models used for updating an existing metadata entity. */
export interface IMetadataEntityUpdateRequest {
    /** The unique identifier of the entity to update. */
    metadataEntityId?: string;
    /** The updated display name of the entity. */
    name?: string;
    /** The updated type of the entity, such as "System", "Subsystem", "Region", etc. */
    type?: string;
    /** Optional updated parent entity ID. Null means the entity is a root entity. */
    parentId?: string | undefined;
    /** Optional updated description of the entity. */
    description?: string | undefined;
    /** Optional structured JSON payload. Used by BenchmarkCatalogValue to update
scope, modelTypeEntityId, and valueKgCo2ePerM2. Null for all other types. */
    metadata?: string | undefined;
}

export class NonModelledElementsExportResponse implements INonModelledElementsExportResponse {
    jobId?: string;
    filename?: string;

    constructor(data?: INonModelledElementsExportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.filename = _data["filename"];
        }
    }

    static fromJS(data: any): NonModelledElementsExportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NonModelledElementsExportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["filename"] = this.filename;
        return data;
    }
}

export interface INonModelledElementsExportResponse {
    jobId?: string;
    filename?: string;
}

export class CadModelCategoryFilterResponse implements ICadModelCategoryFilterResponse {
    profileConfigurationId?: string;
    profileId?: string;
    configuration?: string;
    isSystemGenerated?: boolean;
    configurationObjectData?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;
    includes?: ObjectData[];

    constructor(data?: ICadModelCategoryFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileConfigurationId = _data["profileConfigurationId"];
            this.profileId = _data["profileId"];
            this.configuration = _data["configuration"];
            this.isSystemGenerated = _data["isSystemGenerated"];
            if (Array.isArray(_data["configurationObjectData"])) {
                this.configurationObjectData = [] as any;
                for (let item of _data["configurationObjectData"])
                    this.configurationObjectData!.push(CadModelCategoryFilterObjectData.fromJS(item));
            }
            this.profileConfigurationType = _data["profileConfigurationType"];
            if (Array.isArray(_data["includes"])) {
                this.includes = [] as any;
                for (let item of _data["includes"])
                    this.includes!.push(ObjectData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CadModelCategoryFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CadModelCategoryFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileConfigurationId"] = this.profileConfigurationId;
        data["profileId"] = this.profileId;
        data["configuration"] = this.configuration;
        data["isSystemGenerated"] = this.isSystemGenerated;
        if (Array.isArray(this.configurationObjectData)) {
            data["configurationObjectData"] = [];
            for (let item of this.configurationObjectData)
                data["configurationObjectData"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileConfigurationType"] = this.profileConfigurationType;
        if (Array.isArray(this.includes)) {
            data["includes"] = [];
            for (let item of this.includes)
                data["includes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICadModelCategoryFilterResponse {
    profileConfigurationId?: string;
    profileId?: string;
    configuration?: string;
    isSystemGenerated?: boolean;
    configurationObjectData?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;
    includes?: ObjectData[];
}

export class CadModelCategoryFilterObjectData implements ICadModelCategoryFilterObjectData {
    categoryId?: string;
    category?: string;
    categoryKey?: string | undefined;
    categoryValue?: string | undefined;

    constructor(data?: ICadModelCategoryFilterObjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.category = _data["category"];
            this.categoryKey = _data["categoryKey"];
            this.categoryValue = _data["categoryValue"];
        }
    }

    static fromJS(data: any): CadModelCategoryFilterObjectData {
        data = typeof data === 'object' ? data : {};
        let result = new CadModelCategoryFilterObjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["category"] = this.category;
        data["categoryKey"] = this.categoryKey;
        data["categoryValue"] = this.categoryValue;
        return data;
    }
}

export interface ICadModelCategoryFilterObjectData {
    categoryId?: string;
    category?: string;
    categoryKey?: string | undefined;
    categoryValue?: string | undefined;
}

export enum ProfileConfigurationType {
    ModelElementFilter = "ModelElementFilter",
}

export class ObjectData implements IObjectData {
    objectId?: string;
    referenceId?: string;
    category?: string;
    categoryKey?: string;
    categoryValue?: string;
    subCategory?: string;
    subCategoryKey?: string;
    subCategoryValue?: string;
    family?: string;
    type?: string;
    omniClassNumber?: string;
    omniClassTitle?: string;
    uniFormatNumber?: string;
    uniFormatTitle?: string;
    masterFormatNumber?: string;
    masterFormatTitle?: string;
    material?: string;
    materialCategory?: string;
    materialClass?: string;
    materialType?: string;
    isStructuralMaterial?: boolean | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number;
    system?: string;
    subSystem?: string;
    freeText1?: string;
    freeText2?: string;
    freeText3?: string;
    co2MaterialTypeSpec?: string;
    childObjects?: ObjectData[];
    modelParameters?: ModelParameter[];

    constructor(data?: IObjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectId = _data["objectId"];
            this.referenceId = _data["referenceId"];
            this.category = _data["category"];
            this.categoryKey = _data["categoryKey"];
            this.categoryValue = _data["categoryValue"];
            this.subCategory = _data["subCategory"];
            this.subCategoryKey = _data["subCategoryKey"];
            this.subCategoryValue = _data["subCategoryValue"];
            this.family = _data["family"];
            this.type = _data["type"];
            this.omniClassNumber = _data["omniClassNumber"];
            this.omniClassTitle = _data["omniClassTitle"];
            this.uniFormatNumber = _data["uniFormatNumber"];
            this.uniFormatTitle = _data["uniFormatTitle"];
            this.masterFormatNumber = _data["masterFormatNumber"];
            this.masterFormatTitle = _data["masterFormatTitle"];
            this.material = _data["material"];
            this.materialCategory = _data["materialCategory"];
            this.materialClass = _data["materialClass"];
            this.materialType = _data["materialType"];
            this.isStructuralMaterial = _data["isStructuralMaterial"];
            this.length = _data["length"];
            this.area = _data["area"];
            this.volume = _data["volume"];
            this.thickness = _data["thickness"];
            this.quantity = _data["quantity"];
            this.system = _data["system"];
            this.subSystem = _data["subSystem"];
            this.freeText1 = _data["freeText1"];
            this.freeText2 = _data["freeText2"];
            this.freeText3 = _data["freeText3"];
            this.co2MaterialTypeSpec = _data["co2MaterialTypeSpec"];
            if (Array.isArray(_data["childObjects"])) {
                this.childObjects = [] as any;
                for (let item of _data["childObjects"])
                    this.childObjects!.push(ObjectData.fromJS(item));
            }
            if (Array.isArray(_data["modelParameters"])) {
                this.modelParameters = [] as any;
                for (let item of _data["modelParameters"])
                    this.modelParameters!.push(ModelParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjectData {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectId"] = this.objectId;
        data["referenceId"] = this.referenceId;
        data["category"] = this.category;
        data["categoryKey"] = this.categoryKey;
        data["categoryValue"] = this.categoryValue;
        data["subCategory"] = this.subCategory;
        data["subCategoryKey"] = this.subCategoryKey;
        data["subCategoryValue"] = this.subCategoryValue;
        data["family"] = this.family;
        data["type"] = this.type;
        data["omniClassNumber"] = this.omniClassNumber;
        data["omniClassTitle"] = this.omniClassTitle;
        data["uniFormatNumber"] = this.uniFormatNumber;
        data["uniFormatTitle"] = this.uniFormatTitle;
        data["masterFormatNumber"] = this.masterFormatNumber;
        data["masterFormatTitle"] = this.masterFormatTitle;
        data["material"] = this.material;
        data["materialCategory"] = this.materialCategory;
        data["materialClass"] = this.materialClass;
        data["materialType"] = this.materialType;
        data["isStructuralMaterial"] = this.isStructuralMaterial;
        data["length"] = this.length;
        data["area"] = this.area;
        data["volume"] = this.volume;
        data["thickness"] = this.thickness;
        data["quantity"] = this.quantity;
        data["system"] = this.system;
        data["subSystem"] = this.subSystem;
        data["freeText1"] = this.freeText1;
        data["freeText2"] = this.freeText2;
        data["freeText3"] = this.freeText3;
        data["co2MaterialTypeSpec"] = this.co2MaterialTypeSpec;
        if (Array.isArray(this.childObjects)) {
            data["childObjects"] = [];
            for (let item of this.childObjects)
                data["childObjects"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.modelParameters)) {
            data["modelParameters"] = [];
            for (let item of this.modelParameters)
                data["modelParameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IObjectData {
    objectId?: string;
    referenceId?: string;
    category?: string;
    categoryKey?: string;
    categoryValue?: string;
    subCategory?: string;
    subCategoryKey?: string;
    subCategoryValue?: string;
    family?: string;
    type?: string;
    omniClassNumber?: string;
    omniClassTitle?: string;
    uniFormatNumber?: string;
    uniFormatTitle?: string;
    masterFormatNumber?: string;
    masterFormatTitle?: string;
    material?: string;
    materialCategory?: string;
    materialClass?: string;
    materialType?: string;
    isStructuralMaterial?: boolean | undefined;
    length?: number | undefined;
    area?: number | undefined;
    volume?: number | undefined;
    thickness?: number | undefined;
    quantity?: number;
    system?: string;
    subSystem?: string;
    freeText1?: string;
    freeText2?: string;
    freeText3?: string;
    co2MaterialTypeSpec?: string;
    childObjects?: ObjectData[];
    modelParameters?: ModelParameter[];
}

export class ModelParameter implements IModelParameter {
    parameterName?: string;
    parameterValue?: string;
    storageType?: string;
    guid?: string | undefined;
    layer?: string;

    constructor(data?: IModelParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterName = _data["parameterName"];
            this.parameterValue = _data["parameterValue"];
            this.storageType = _data["storageType"];
            this.guid = _data["guid"];
            this.layer = _data["layer"];
        }
    }

    static fromJS(data: any): ModelParameter {
        data = typeof data === 'object' ? data : {};
        let result = new ModelParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterName"] = this.parameterName;
        data["parameterValue"] = this.parameterValue;
        data["storageType"] = this.storageType;
        data["guid"] = this.guid;
        data["layer"] = this.layer;
        return data;
    }
}

export interface IModelParameter {
    parameterName?: string;
    parameterValue?: string;
    storageType?: string;
    guid?: string | undefined;
    layer?: string;
}

export class ProfileConfiguration implements IProfileConfiguration {
    profileConfigurationId?: string;
    profileId!: string;
    configuration!: string;
    type!: ProfileConfigurationType;
    isSystemGenerated!: boolean;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;

    constructor(data?: IProfileConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileConfigurationId = _data["profileConfigurationId"];
            this.profileId = _data["profileId"];
            this.configuration = _data["configuration"];
            this.type = _data["type"];
            this.isSystemGenerated = _data["isSystemGenerated"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ProfileConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileConfigurationId"] = this.profileConfigurationId;
        data["profileId"] = this.profileId;
        data["configuration"] = this.configuration;
        data["type"] = this.type;
        data["isSystemGenerated"] = this.isSystemGenerated;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IProfileConfiguration {
    profileConfigurationId?: string;
    profileId: string;
    configuration: string;
    type: ProfileConfigurationType;
    isSystemGenerated: boolean;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
}

export class CreateProfileConfigurationRequest implements ICreateProfileConfigurationRequest {
    profileId?: string;
    configuration?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;

    constructor(data?: ICreateProfileConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(CadModelCategoryFilterObjectData.fromJS(item));
            }
            this.profileConfigurationType = _data["profileConfigurationType"];
        }
    }

    static fromJS(data: any): CreateProfileConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProfileConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileConfigurationType"] = this.profileConfigurationType;
        return data;
    }
}

export interface ICreateProfileConfigurationRequest {
    profileId?: string;
    configuration?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;
}

export class UpdateProfileConfigurationRequest implements IUpdateProfileConfigurationRequest {
    profileId?: string;
    configuration?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;

    constructor(data?: IUpdateProfileConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            if (Array.isArray(_data["configuration"])) {
                this.configuration = [] as any;
                for (let item of _data["configuration"])
                    this.configuration!.push(CadModelCategoryFilterObjectData.fromJS(item));
            }
            this.profileConfigurationType = _data["profileConfigurationType"];
        }
    }

    static fromJS(data: any): UpdateProfileConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        if (Array.isArray(this.configuration)) {
            data["configuration"] = [];
            for (let item of this.configuration)
                data["configuration"].push(item ? item.toJSON() : undefined as any);
        }
        data["profileConfigurationType"] = this.profileConfigurationType;
        return data;
    }
}

export interface IUpdateProfileConfigurationRequest {
    profileId?: string;
    configuration?: CadModelCategoryFilterObjectData[];
    profileConfigurationType?: ProfileConfigurationType;
}

export class ProfileResponse implements IProfileResponse {
    profileId?: string;
    name?: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    rebarEnabled?: boolean;
    profileConfigurationResponse?: ProfileConfigurationResponse;

    constructor(data?: IProfileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
            this.rebarEnabled = _data["rebarEnabled"];
            this.profileConfigurationResponse = _data["profileConfigurationResponse"] ? ProfileConfigurationResponse.fromJS(_data["profileConfigurationResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        data["rebarEnabled"] = this.rebarEnabled;
        data["profileConfigurationResponse"] = this.profileConfigurationResponse ? this.profileConfigurationResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileResponse {
    profileId?: string;
    name?: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    rebarEnabled?: boolean;
    profileConfigurationResponse?: ProfileConfigurationResponse;
}

export class ProfileConfigurationResponse implements IProfileConfigurationResponse {
    autoMappingRules?: AutoMappingRule[] | undefined;
    nonModelledRules?: AutoMappingRule[] | undefined;
    rebarRules?: AutoMappingRule[] | undefined;

    constructor(data?: IProfileConfigurationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["autoMappingRules"])) {
                this.autoMappingRules = [] as any;
                for (let item of _data["autoMappingRules"])
                    this.autoMappingRules!.push(AutoMappingRule.fromJS(item));
            }
            if (Array.isArray(_data["nonModelledRules"])) {
                this.nonModelledRules = [] as any;
                for (let item of _data["nonModelledRules"])
                    this.nonModelledRules!.push(AutoMappingRule.fromJS(item));
            }
            if (Array.isArray(_data["rebarRules"])) {
                this.rebarRules = [] as any;
                for (let item of _data["rebarRules"])
                    this.rebarRules!.push(AutoMappingRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileConfigurationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileConfigurationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.autoMappingRules)) {
            data["autoMappingRules"] = [];
            for (let item of this.autoMappingRules)
                data["autoMappingRules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nonModelledRules)) {
            data["nonModelledRules"] = [];
            for (let item of this.nonModelledRules)
                data["nonModelledRules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rebarRules)) {
            data["rebarRules"] = [];
            for (let item of this.rebarRules)
                data["rebarRules"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfileConfigurationResponse {
    autoMappingRules?: AutoMappingRule[] | undefined;
    nonModelledRules?: AutoMappingRule[] | undefined;
    rebarRules?: AutoMappingRule[] | undefined;
}

export class AutoMappingRule implements IAutoMappingRule {
    data?: AutoMappingRuleCondition;
    cadModelCategory?: string;
    family?: string;
    type?: string;
    co2MaterialTypeId?: string;
    system?: string | undefined;
    subSystem?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    percentage?: string | undefined;

    constructor(data?: IAutoMappingRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? AutoMappingRuleCondition.fromJS(_data["data"]) : undefined as any;
            this.cadModelCategory = _data["cadModelCategory"];
            this.family = _data["family"];
            this.type = _data["type"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.system = _data["system"];
            this.subSystem = _data["subSystem"];
            this.attribute1 = _data["attribute1"];
            this.attribute2 = _data["attribute2"];
            this.attribute3 = _data["attribute3"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): AutoMappingRule {
        data = typeof data === 'object' ? data : {};
        let result = new AutoMappingRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["cadModelCategory"] = this.cadModelCategory;
        data["family"] = this.family;
        data["type"] = this.type;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["system"] = this.system;
        data["subSystem"] = this.subSystem;
        data["attribute1"] = this.attribute1;
        data["attribute2"] = this.attribute2;
        data["attribute3"] = this.attribute3;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IAutoMappingRule {
    data?: AutoMappingRuleCondition;
    cadModelCategory?: string;
    family?: string;
    type?: string;
    co2MaterialTypeId?: string;
    system?: string | undefined;
    subSystem?: string | undefined;
    attribute1?: string | undefined;
    attribute2?: string | undefined;
    attribute3?: string | undefined;
    percentage?: string | undefined;
}

export class AutoMappingRuleCondition implements IAutoMappingRuleCondition {

    constructor(data?: IAutoMappingRuleCondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AutoMappingRuleCondition {
        data = typeof data === 'object' ? data : {};
        let result = new AutoMappingRuleCondition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IAutoMappingRuleCondition {
}

export class ProfileCreateUpdateResponse implements IProfileCreateUpdateResponse {
    isDuplicate?: boolean;
    profileResponse?: ProfileResponse | undefined;

    constructor(data?: IProfileCreateUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDuplicate = _data["isDuplicate"];
            this.profileResponse = _data["profileResponse"] ? ProfileResponse.fromJS(_data["profileResponse"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProfileCreateUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCreateUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDuplicate"] = this.isDuplicate;
        data["profileResponse"] = this.profileResponse ? this.profileResponse.toJSON() : undefined as any;
        return data;
    }
}

export interface IProfileCreateUpdateResponse {
    isDuplicate?: boolean;
    profileResponse?: ProfileResponse | undefined;
}

export class ProfileCreateRequest implements IProfileCreateRequest {
    name!: string;
    description?: string | undefined;
    rebarEnabled?: boolean;

    constructor(data?: IProfileCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.rebarEnabled = _data["rebarEnabled"];
        }
    }

    static fromJS(data: any): ProfileCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["rebarEnabled"] = this.rebarEnabled;
        return data;
    }
}

export interface IProfileCreateRequest {
    name: string;
    description?: string | undefined;
    rebarEnabled?: boolean;
}

export class ProfileUpdateRequest implements IProfileUpdateRequest {
    profileId!: string;
    name!: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    rebarEnabled?: boolean;

    constructor(data?: IProfileUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deleteStatus = _data["deleteStatus"];
            this.rebarEnabled = _data["rebarEnabled"];
        }
    }

    static fromJS(data: any): ProfileUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deleteStatus"] = this.deleteStatus;
        data["rebarEnabled"] = this.rebarEnabled;
        return data;
    }
}

export interface IProfileUpdateRequest {
    profileId: string;
    name: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    rebarEnabled?: boolean;
}

export class ProfileMaterialConfigurationRequest implements IProfileMaterialConfigurationRequest {
    profileId?: string;
    nodeConfigurations?: NodeMaterialConfigurationDto[];

    constructor(data?: IProfileMaterialConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            if (Array.isArray(_data["nodeConfigurations"])) {
                this.nodeConfigurations = [] as any;
                for (let item of _data["nodeConfigurations"])
                    this.nodeConfigurations!.push(NodeMaterialConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProfileMaterialConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileMaterialConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        if (Array.isArray(this.nodeConfigurations)) {
            data["nodeConfigurations"] = [];
            for (let item of this.nodeConfigurations)
                data["nodeConfigurations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProfileMaterialConfigurationRequest {
    profileId?: string;
    nodeConfigurations?: NodeMaterialConfigurationDto[];
}

export class NodeMaterialConfigurationDto implements INodeMaterialConfigurationDto {
    nodeHierarchyId?: number;
    materialTypes?: MaterialTypeConfiguration[];

    constructor(data?: INodeMaterialConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodeHierarchyId = _data["nodeHierarchyId"];
            if (Array.isArray(_data["materialTypes"])) {
                this.materialTypes = [] as any;
                for (let item of _data["materialTypes"])
                    this.materialTypes!.push(MaterialTypeConfiguration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NodeMaterialConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NodeMaterialConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodeHierarchyId"] = this.nodeHierarchyId;
        if (Array.isArray(this.materialTypes)) {
            data["materialTypes"] = [];
            for (let item of this.materialTypes)
                data["materialTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface INodeMaterialConfigurationDto {
    nodeHierarchyId?: number;
    materialTypes?: MaterialTypeConfiguration[];
}

export class MaterialTypeConfiguration implements IMaterialTypeConfiguration {
    type?: MaterialConfigurationType;
    co2MaterialTypeId?: string | undefined;
    percentage?: number | undefined;

    constructor(data?: IMaterialTypeConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): MaterialTypeConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new MaterialTypeConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IMaterialTypeConfiguration {
    type?: MaterialConfigurationType;
    co2MaterialTypeId?: string | undefined;
    percentage?: number | undefined;
}

/** Material Configuration Type Enum */
export enum MaterialConfigurationType {
    Rebar = "Rebar",
    NonModelled = "NonModelled",
    AutoAssign = "AutoAssign",
}

export class UnMappedCadMaterialsResponse implements IUnMappedCadMaterialsResponse {
    materialName?: string;
    profileName?: string;

    constructor(data?: IUnMappedCadMaterialsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.materialName = _data["materialName"];
            this.profileName = _data["profileName"];
        }
    }

    static fromJS(data: any): UnMappedCadMaterialsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnMappedCadMaterialsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["materialName"] = this.materialName;
        data["profileName"] = this.profileName;
        return data;
    }
}

export interface IUnMappedCadMaterialsResponse {
    materialName?: string;
    profileName?: string;
}

/** Class to send co2MaterialAssign Setting Response */
export class GetCo2MaterialAssignSettingResponse implements IGetCo2MaterialAssignSettingResponse {
    /** Id of the Co2 Material Assign Setting */
    co2MaterialAssignSettingId?: string | undefined;
    /** Name of the Co2 Material Assign Setting */
    name?: string | undefined;
    /** Description of the Co2 Material Assign Setting */
    description?: string | undefined;
    /** Status of the Co2 Material Assign Setting */
    status?: boolean;
    /** Type Indicates the Level like Global || Project || Scenario */
    type?: Co2MaterialSettingType;
    /** Container to hold the items associated with a setting */
    co2MaterialAssignSettingItems?: GetCo2MaterialAssignSettingItemResponse[];

    constructor(data?: IGetCo2MaterialAssignSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.type = _data["type"];
            if (Array.isArray(_data["co2MaterialAssignSettingItems"])) {
                this.co2MaterialAssignSettingItems = [] as any;
                for (let item of _data["co2MaterialAssignSettingItems"])
                    this.co2MaterialAssignSettingItems!.push(GetCo2MaterialAssignSettingItemResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetCo2MaterialAssignSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCo2MaterialAssignSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        data["type"] = this.type;
        if (Array.isArray(this.co2MaterialAssignSettingItems)) {
            data["co2MaterialAssignSettingItems"] = [];
            for (let item of this.co2MaterialAssignSettingItems)
                data["co2MaterialAssignSettingItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Class to send co2MaterialAssign Setting Response */
export interface IGetCo2MaterialAssignSettingResponse {
    /** Id of the Co2 Material Assign Setting */
    co2MaterialAssignSettingId?: string | undefined;
    /** Name of the Co2 Material Assign Setting */
    name?: string | undefined;
    /** Description of the Co2 Material Assign Setting */
    description?: string | undefined;
    /** Status of the Co2 Material Assign Setting */
    status?: boolean;
    /** Type Indicates the Level like Global || Project || Scenario */
    type?: Co2MaterialSettingType;
    /** Container to hold the items associated with a setting */
    co2MaterialAssignSettingItems?: GetCo2MaterialAssignSettingItemResponse[];
}

/** Class to send co2MaterialAssignSettingItem Response */
export class GetCo2MaterialAssignSettingItemResponse implements IGetCo2MaterialAssignSettingItemResponse {
    /** Co2MaterialAssignSettingsItemId */
    co2MaterialAssignSettingsItemId?: string | undefined;
    /** Cad Model Category Id */
    cadModelCategoryId?: string;
    /** Cad Model Category Name */
    cadModelCategoryName?: string;
    /** Co2MaterialTypeId. Can be null in Default /for first time setting creation */
    co2MaterialTypeId?: string | undefined;
    /** Co2MaterialTypeName */
    co2MaterialTypeName?: string | undefined;
    /** Co2MaterialAssignSettingId */
    co2MaterialAssignSettingId?: string | undefined;
    /** RowVersion */
    rowVersion?: string;
    /** Value */
    value?: string | undefined;
    /** ValueType */
    valueType?: string | undefined;
    lowLimit?: string | undefined;
    highLimit?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;

    constructor(data?: IGetCo2MaterialAssignSettingItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingsItemId = _data["co2MaterialAssignSettingsItemId"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.cadModelCategoryName = _data["cadModelCategoryName"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.co2MaterialTypeName = _data["co2MaterialTypeName"];
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.rowVersion = _data["rowVersion"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.lowLimit = _data["lowLimit"];
            this.highLimit = _data["highLimit"];
            this.isRebarFilterByMaterialsEnabled = _data["isRebarFilterByMaterialsEnabled"];
        }
    }

    static fromJS(data: any): GetCo2MaterialAssignSettingItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCo2MaterialAssignSettingItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingsItemId"] = this.co2MaterialAssignSettingsItemId;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["cadModelCategoryName"] = this.cadModelCategoryName;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["co2MaterialTypeName"] = this.co2MaterialTypeName;
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["rowVersion"] = this.rowVersion;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["lowLimit"] = this.lowLimit;
        data["highLimit"] = this.highLimit;
        data["isRebarFilterByMaterialsEnabled"] = this.isRebarFilterByMaterialsEnabled;
        return data;
    }
}

/** Class to send co2MaterialAssignSettingItem Response */
export interface IGetCo2MaterialAssignSettingItemResponse {
    /** Co2MaterialAssignSettingsItemId */
    co2MaterialAssignSettingsItemId?: string | undefined;
    /** Cad Model Category Id */
    cadModelCategoryId?: string;
    /** Cad Model Category Name */
    cadModelCategoryName?: string;
    /** Co2MaterialTypeId. Can be null in Default /for first time setting creation */
    co2MaterialTypeId?: string | undefined;
    /** Co2MaterialTypeName */
    co2MaterialTypeName?: string | undefined;
    /** Co2MaterialAssignSettingId */
    co2MaterialAssignSettingId?: string | undefined;
    /** RowVersion */
    rowVersion?: string;
    /** Value */
    value?: string | undefined;
    /** ValueType */
    valueType?: string | undefined;
    lowLimit?: string | undefined;
    highLimit?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;
}

/** Container to capture Co2MaterialSettingItem Update Object */
export class UpdateCo2MaterialAssignSettingItemRequest implements IUpdateCo2MaterialAssignSettingItemRequest {
    /** Co2MaterialAssignSettingItemId */
    co2MaterialAssignSettingItemId?: string | undefined;
    /** Co2MaterialAssignSettingId */
    co2MaterialAssignSettingId?: string | undefined;
    /** True indicates the request includes a selected Co2MaterialType */
    hasCo2MaterialType?: boolean | undefined;
    /** CadModelCategoryId */
    cadModelCategoryId?: string | undefined;
    /** Co2MaterialLibraryId */
    co2MaterialLibraryId?: string | undefined;
    /** Co2MaterialTypeId */
    co2MaterialTypeId?: string | undefined;
    /** Material category provided by external source */
    materialCategory?: string | undefined;
    /** Material ExternalId */
    externalId?: string | undefined;
    /** Material Name */
    name?: string | undefined;
    /** Value */
    value?: string | undefined;
    /** ValueType */
    valueType?: string | undefined;
    /** Material data from external source */
    sourceData?: string | undefined;
    lowLimit?: string | undefined;
    highLimit?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;

    constructor(data?: IUpdateCo2MaterialAssignSettingItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingItemId = _data["co2MaterialAssignSettingItemId"];
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.hasCo2MaterialType = _data["hasCo2MaterialType"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.materialCategory = _data["materialCategory"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.value = _data["value"];
            this.valueType = _data["valueType"];
            this.sourceData = _data["sourceData"];
            this.lowLimit = _data["lowLimit"];
            this.highLimit = _data["highLimit"];
            this.isRebarFilterByMaterialsEnabled = _data["isRebarFilterByMaterialsEnabled"];
        }
    }

    static fromJS(data: any): UpdateCo2MaterialAssignSettingItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCo2MaterialAssignSettingItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingItemId"] = this.co2MaterialAssignSettingItemId;
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["hasCo2MaterialType"] = this.hasCo2MaterialType;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["materialCategory"] = this.materialCategory;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["valueType"] = this.valueType;
        data["sourceData"] = this.sourceData;
        data["lowLimit"] = this.lowLimit;
        data["highLimit"] = this.highLimit;
        data["isRebarFilterByMaterialsEnabled"] = this.isRebarFilterByMaterialsEnabled;
        return data;
    }
}

/** Container to capture Co2MaterialSettingItem Update Object */
export interface IUpdateCo2MaterialAssignSettingItemRequest {
    /** Co2MaterialAssignSettingItemId */
    co2MaterialAssignSettingItemId?: string | undefined;
    /** Co2MaterialAssignSettingId */
    co2MaterialAssignSettingId?: string | undefined;
    /** True indicates the request includes a selected Co2MaterialType */
    hasCo2MaterialType?: boolean | undefined;
    /** CadModelCategoryId */
    cadModelCategoryId?: string | undefined;
    /** Co2MaterialLibraryId */
    co2MaterialLibraryId?: string | undefined;
    /** Co2MaterialTypeId */
    co2MaterialTypeId?: string | undefined;
    /** Material category provided by external source */
    materialCategory?: string | undefined;
    /** Material ExternalId */
    externalId?: string | undefined;
    /** Material Name */
    name?: string | undefined;
    /** Value */
    value?: string | undefined;
    /** ValueType */
    valueType?: string | undefined;
    /** Material data from external source */
    sourceData?: string | undefined;
    lowLimit?: string | undefined;
    highLimit?: string | undefined;
    isRebarFilterByMaterialsEnabled?: boolean | undefined;
}

/** Used as an Api Request Class for co2MaterialAssign Setting Item Update/Insert */
export class UpsertCo2MaterialSettingRequest implements IUpsertCo2MaterialSettingRequest {
    /** Co2Material AssignId of the Setting under which items are created /Modified
             */
    co2MaterialAssignSettingId?: string | undefined;
    co2MaterialAssignSettingType?: Co2MaterialSettingType;
    /** Indicates Name of Co2MaterialAssignSetting */
    name?: string;
    /** Indicates Description about Co2MaterialAssignSetting */
    description?: string;
    /** Indicates if a Rebar Setting is enabled or disbaled  */
    enableRebar?: boolean;
    /** Project Id  */
    projectId?: string | undefined;
    scenarioId?: string | undefined;
    profileId?: string | undefined;
    upsertCo2MaterialSettingItems?: UpdateCo2MaterialAssignSettingItemRequest[] | undefined;

    constructor(data?: IUpsertCo2MaterialSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialAssignSettingId = _data["co2MaterialAssignSettingId"];
            this.co2MaterialAssignSettingType = _data["co2MaterialAssignSettingType"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.enableRebar = _data["enableRebar"];
            this.projectId = _data["projectId"];
            this.scenarioId = _data["scenarioId"];
            this.profileId = _data["profileId"];
            if (Array.isArray(_data["upsertCo2MaterialSettingItems"])) {
                this.upsertCo2MaterialSettingItems = [] as any;
                for (let item of _data["upsertCo2MaterialSettingItems"])
                    this.upsertCo2MaterialSettingItems!.push(UpdateCo2MaterialAssignSettingItemRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpsertCo2MaterialSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCo2MaterialSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialAssignSettingId"] = this.co2MaterialAssignSettingId;
        data["co2MaterialAssignSettingType"] = this.co2MaterialAssignSettingType;
        data["name"] = this.name;
        data["description"] = this.description;
        data["enableRebar"] = this.enableRebar;
        data["projectId"] = this.projectId;
        data["scenarioId"] = this.scenarioId;
        data["profileId"] = this.profileId;
        if (Array.isArray(this.upsertCo2MaterialSettingItems)) {
            data["upsertCo2MaterialSettingItems"] = [];
            for (let item of this.upsertCo2MaterialSettingItems)
                data["upsertCo2MaterialSettingItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Used as an Api Request Class for co2MaterialAssign Setting Item Update/Insert */
export interface IUpsertCo2MaterialSettingRequest {
    /** Co2Material AssignId of the Setting under which items are created /Modified
             */
    co2MaterialAssignSettingId?: string | undefined;
    co2MaterialAssignSettingType?: Co2MaterialSettingType;
    /** Indicates Name of Co2MaterialAssignSetting */
    name?: string;
    /** Indicates Description about Co2MaterialAssignSetting */
    description?: string;
    /** Indicates if a Rebar Setting is enabled or disbaled  */
    enableRebar?: boolean;
    /** Project Id  */
    projectId?: string | undefined;
    scenarioId?: string | undefined;
    profileId?: string | undefined;
    upsertCo2MaterialSettingItems?: UpdateCo2MaterialAssignSettingItemRequest[] | undefined;
}

/** Entity class for FilteredElementConfiguration table */
export class FilteredElementConfiguration implements IFilteredElementConfiguration {
    /** Primary key for this table */
    filteredElementConfigurationId?: string;
    filteredElementConfigurationType?: string;
    /** Name Indicates the Name of the Rule Set */
    name?: string | undefined;
    /** Description Indicates the Purpose of this rule set */
    description?: string | undefined;
    /** Config holds the JSON data for Filter Selection */
    config?: string | undefined;
    /** Captures the time an object of this entity is inserted */
    createdAt?: Date;
    /** Captures the name of the person by whom a record of this entity is inserted */
    createdBy?: string | undefined;
    /** Captures the time a record of this entity is last modified */
    modifiedAt?: Date;
    /** Captures the name of the person by whom a record of this entity is last modified */
    modifiedBy?: string | undefined;

    constructor(data?: IFilteredElementConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredElementConfigurationId = _data["filteredElementConfigurationId"];
            this.filteredElementConfigurationType = _data["filteredElementConfigurationType"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.config = _data["config"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): FilteredElementConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new FilteredElementConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredElementConfigurationId"] = this.filteredElementConfigurationId;
        data["filteredElementConfigurationType"] = this.filteredElementConfigurationType;
        data["name"] = this.name;
        data["description"] = this.description;
        data["config"] = this.config;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

/** Entity class for FilteredElementConfiguration table */
export interface IFilteredElementConfiguration {
    /** Primary key for this table */
    filteredElementConfigurationId?: string;
    filteredElementConfigurationType?: string;
    /** Name Indicates the Name of the Rule Set */
    name?: string | undefined;
    /** Description Indicates the Purpose of this rule set */
    description?: string | undefined;
    /** Config holds the JSON data for Filter Selection */
    config?: string | undefined;
    /** Captures the time an object of this entity is inserted */
    createdAt?: Date;
    /** Captures the name of the person by whom a record of this entity is inserted */
    createdBy?: string | undefined;
    /** Captures the time a record of this entity is last modified */
    modifiedAt?: Date;
    /** Captures the name of the person by whom a record of this entity is last modified */
    modifiedBy?: string | undefined;
}

/** Used for Capturing Create filter request Object */
export class CreateFilteredElementConfigurationRequest implements ICreateFilteredElementConfigurationRequest {
    /** Captures the Name of the Filter Selection Rule Set */
    name?: string;
    /** Captures the Purpose of the Filter Selection Rule Set */
    description?: string | undefined;
    /** Captures the Configuration of Filter Selection Rule Set */
    configuration?: string;
    filteredElementConfigurationType?: FilteredElementConfigurationType;

    constructor(data?: ICreateFilteredElementConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.configuration = _data["configuration"];
            this.filteredElementConfigurationType = _data["filteredElementConfigurationType"];
        }
    }

    static fromJS(data: any): CreateFilteredElementConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFilteredElementConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["configuration"] = this.configuration;
        data["filteredElementConfigurationType"] = this.filteredElementConfigurationType;
        return data;
    }
}

/** Used for Capturing Create filter request Object */
export interface ICreateFilteredElementConfigurationRequest {
    /** Captures the Name of the Filter Selection Rule Set */
    name?: string;
    /** Captures the Purpose of the Filter Selection Rule Set */
    description?: string | undefined;
    /** Captures the Configuration of Filter Selection Rule Set */
    configuration?: string;
    filteredElementConfigurationType?: FilteredElementConfigurationType;
}

export enum FilteredElementConfigurationType {
    AddNonModelledElement = "AddNonModelledElement",
    AutoAssignMaterial = "AutoAssignMaterial",
    AssignRebarEstimation = "AssignRebarEstimation",
}

/** Used for Capturing update filter request Object */
export class UpdateFilteredElementConfigurationRequest implements IUpdateFilteredElementConfigurationRequest {
    filteredElementConfigurationId?: string;
    /** Captures the Name of the Filter Selection Rule Set */
    name?: string;
    /** Captures the Purpose of the Filter Selection Rule Set */
    description?: string | undefined;
    /** Captures the Configuration of Filter Selection Rule Set */
    configuration?: string;
    filteredElementConfigurationType?: FilteredElementConfigurationType;

    constructor(data?: IUpdateFilteredElementConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredElementConfigurationId = _data["filteredElementConfigurationId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.configuration = _data["configuration"];
            this.filteredElementConfigurationType = _data["filteredElementConfigurationType"];
        }
    }

    static fromJS(data: any): UpdateFilteredElementConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFilteredElementConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredElementConfigurationId"] = this.filteredElementConfigurationId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["configuration"] = this.configuration;
        data["filteredElementConfigurationType"] = this.filteredElementConfigurationType;
        return data;
    }
}

/** Used for Capturing update filter request Object */
export interface IUpdateFilteredElementConfigurationRequest {
    filteredElementConfigurationId?: string;
    /** Captures the Name of the Filter Selection Rule Set */
    name?: string;
    /** Captures the Purpose of the Filter Selection Rule Set */
    description?: string | undefined;
    /** Captures the Configuration of Filter Selection Rule Set */
    configuration?: string;
    filteredElementConfigurationType?: FilteredElementConfigurationType;
}

export class ApplicationSettings implements IApplicationSettings {
    /** True when Rebar Estimation global settings exist */
    rebarEstimation?: boolean;
    /** True when Rebar Estimation global settings exist */
    profileLevelRebarSettings?: boolean;
    /** True when Non-Modelled Elements global settings exist */
    nonModelledElements?: boolean;
    /** True when Additional Metadata feature is enabled */
    additionalMetadata?: boolean;
    /** True when Project Phase feature is enabled */
    projectPhase?: boolean;
    /** True when Scenario Type feature is enabled */
    scenarioType?: boolean;
    features?: string[];
    modelScopeSetting?: ModelScopeSettingResponse;
    settings?: { [key: string]: AppSetting; };
    metadataEntities?: MetadataEntityResponse[];

    constructor(data?: IApplicationSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rebarEstimation = _data["rebarEstimation"];
            this.profileLevelRebarSettings = _data["profileLevelRebarSettings"];
            this.nonModelledElements = _data["nonModelledElements"];
            this.additionalMetadata = _data["additionalMetadata"];
            this.projectPhase = _data["projectPhase"];
            this.scenarioType = _data["scenarioType"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
            this.modelScopeSetting = _data["modelScopeSetting"] ? ModelScopeSettingResponse.fromJS(_data["modelScopeSetting"]) : undefined as any;
            if (_data["settings"]) {
                this.settings = {} as any;
                for (let key in _data["settings"]) {
                    if (_data["settings"].hasOwnProperty(key))
                        (this.settings as any)![key] = _data["settings"][key] ? AppSetting.fromJS(_data["settings"][key]) : new AppSetting();
                }
            }
            if (Array.isArray(_data["metadataEntities"])) {
                this.metadataEntities = [] as any;
                for (let item of _data["metadataEntities"])
                    this.metadataEntities!.push(MetadataEntityResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rebarEstimation"] = this.rebarEstimation;
        data["profileLevelRebarSettings"] = this.profileLevelRebarSettings;
        data["nonModelledElements"] = this.nonModelledElements;
        data["additionalMetadata"] = this.additionalMetadata;
        data["projectPhase"] = this.projectPhase;
        data["scenarioType"] = this.scenarioType;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        data["modelScopeSetting"] = this.modelScopeSetting ? this.modelScopeSetting.toJSON() : undefined as any;
        if (this.settings) {
            data["settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    (data["settings"] as any)[key] = this.settings[key] ? this.settings[key].toJSON() : undefined as any;
            }
        }
        if (Array.isArray(this.metadataEntities)) {
            data["metadataEntities"] = [];
            for (let item of this.metadataEntities)
                data["metadataEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IApplicationSettings {
    /** True when Rebar Estimation global settings exist */
    rebarEstimation?: boolean;
    /** True when Rebar Estimation global settings exist */
    profileLevelRebarSettings?: boolean;
    /** True when Non-Modelled Elements global settings exist */
    nonModelledElements?: boolean;
    /** True when Additional Metadata feature is enabled */
    additionalMetadata?: boolean;
    /** True when Project Phase feature is enabled */
    projectPhase?: boolean;
    /** True when Scenario Type feature is enabled */
    scenarioType?: boolean;
    features?: string[];
    modelScopeSetting?: ModelScopeSettingResponse;
    settings?: { [key: string]: AppSetting; };
    metadataEntities?: MetadataEntityResponse[];
}

export class ModelScopeSettingResponse implements IModelScopeSettingResponse {
    modelScopeSettingId?: string;
    nodePath?: string;
    type?: ModelScopeSettingType;
    name?: string;
    description?: string | undefined;
    status?: string;
    modelScopeSettingsItems?: ModelScopeSettingsItemRespone[];

    constructor(data?: IModelScopeSettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingId = _data["modelScopeSettingId"];
            this.nodePath = _data["nodePath"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.status = _data["status"];
            if (Array.isArray(_data["modelScopeSettingsItems"])) {
                this.modelScopeSettingsItems = [] as any;
                for (let item of _data["modelScopeSettingsItems"])
                    this.modelScopeSettingsItems!.push(ModelScopeSettingsItemRespone.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelScopeSettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ModelScopeSettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingId"] = this.modelScopeSettingId;
        data["nodePath"] = this.nodePath;
        data["type"] = this.type;
        data["name"] = this.name;
        data["description"] = this.description;
        data["status"] = this.status;
        if (Array.isArray(this.modelScopeSettingsItems)) {
            data["modelScopeSettingsItems"] = [];
            for (let item of this.modelScopeSettingsItems)
                data["modelScopeSettingsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModelScopeSettingResponse {
    modelScopeSettingId?: string;
    nodePath?: string;
    type?: ModelScopeSettingType;
    name?: string;
    description?: string | undefined;
    status?: string;
    modelScopeSettingsItems?: ModelScopeSettingsItemRespone[];
}

export enum ModelScopeSettingType {
    Global = "Global",
}

export class ModelScopeSettingsItemRespone implements IModelScopeSettingsItemRespone {
    modelScopeSettingsItemId?: string;
    id?: number;
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;

    constructor(data?: IModelScopeSettingsItemRespone) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingsItemId = _data["modelScopeSettingsItemId"];
            this.id = _data["id"];
            this.nodePath = _data["nodePath"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelScopeSettingsItemRespone {
        data = typeof data === 'object' ? data : {};
        let result = new ModelScopeSettingsItemRespone();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingsItemId"] = this.modelScopeSettingsItemId;
        data["id"] = this.id;
        data["nodePath"] = this.nodePath;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelScopeSettingsItemRespone {
    modelScopeSettingsItemId?: string;
    id?: number;
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
}

export class AppSetting implements IAppSetting {
    key?: string;
    value?: string;
    description?: string;

    constructor(data?: IAppSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): AppSetting {
        data = typeof data === 'object' ? data : {};
        let result = new AppSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface IAppSetting {
    key?: string;
    value?: string;
    description?: string;
}

export class CreateAppSettingRequest implements ICreateAppSettingRequest {
    key?: string;
    value?: string;
    description?: string | undefined;

    constructor(data?: ICreateAppSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateAppSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateAppSettingRequest {
    key?: string;
    value?: string;
    description?: string | undefined;
}

export class UpdateAppSettingRequest implements IUpdateAppSettingRequest {
    value?: string;

    constructor(data?: IUpdateAppSettingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateAppSettingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppSettingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateAppSettingRequest {
    value?: string;
}

export class AllPropertiesData implements IAllPropertiesData {
    type?: string | undefined;
    collection?: AllPropertiesDataCollection[] | undefined;

    constructor(data?: IAllPropertiesData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["collection"])) {
                this.collection = [] as any;
                for (let item of _data["collection"])
                    this.collection!.push(AllPropertiesDataCollection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AllPropertiesData {
        data = typeof data === 'object' ? data : {};
        let result = new AllPropertiesData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.collection)) {
            data["collection"] = [];
            for (let item of this.collection)
                data["collection"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAllPropertiesData {
    type?: string | undefined;
    collection?: AllPropertiesDataCollection[] | undefined;
}

export class AllPropertiesDataCollection implements IAllPropertiesDataCollection {
    objectid?: number | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    properties?: any | undefined;

    constructor(data?: IAllPropertiesDataCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectid = _data["objectid"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.properties = _data["properties"];
        }
    }

    static fromJS(data: any): AllPropertiesDataCollection {
        data = typeof data === 'object' ? data : {};
        let result = new AllPropertiesDataCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectid"] = this.objectid;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["properties"] = this.properties;
        return data;
    }
}

export interface IAllPropertiesDataCollection {
    objectid?: number | undefined;
    name?: string | undefined;
    externalId?: string | undefined;
    properties?: any | undefined;
}

export class CreateModelScopeSettingsItemsRequest implements ICreateModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: CreateModelScopeSettingsItem[];

    constructor(data?: ICreateModelScopeSettingsItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingId = _data["modelScopeSettingId"];
            if (Array.isArray(_data["modelScopeSettingsItems"])) {
                this.modelScopeSettingsItems = [] as any;
                for (let item of _data["modelScopeSettingsItems"])
                    this.modelScopeSettingsItems!.push(CreateModelScopeSettingsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateModelScopeSettingsItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModelScopeSettingsItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingId"] = this.modelScopeSettingId;
        if (Array.isArray(this.modelScopeSettingsItems)) {
            data["modelScopeSettingsItems"] = [];
            for (let item of this.modelScopeSettingsItems)
                data["modelScopeSettingsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: CreateModelScopeSettingsItem[];
}

export class CreateModelScopeSettingsItem implements ICreateModelScopeSettingsItem {
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;

    constructor(data?: ICreateModelScopeSettingsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodePath = _data["nodePath"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): CreateModelScopeSettingsItem {
        data = typeof data === 'object' ? data : {};
        let result = new CreateModelScopeSettingsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodePath"] = this.nodePath;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        return data;
    }
}

export interface ICreateModelScopeSettingsItem {
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;
}

export class UpdateModelScopeSettingsRequest implements IUpdateModelScopeSettingsRequest {
    modelScopeSettingsId?: string;
    status?: ModelScopeSettingStatusType;

    constructor(data?: IUpdateModelScopeSettingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingsId = _data["modelScopeSettingsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateModelScopeSettingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModelScopeSettingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingsId"] = this.modelScopeSettingsId;
        data["status"] = this.status;
        return data;
    }
}

export interface IUpdateModelScopeSettingsRequest {
    modelScopeSettingsId?: string;
    status?: ModelScopeSettingStatusType;
}

export enum ModelScopeSettingStatusType {
    Active = "Active",
    InActive = "InActive",
}

export class UpdateModelScopeSettingsItemsRequest implements IUpdateModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: UpdateModelScopeSettingsItem[];

    constructor(data?: IUpdateModelScopeSettingsItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingId = _data["modelScopeSettingId"];
            if (Array.isArray(_data["modelScopeSettingsItems"])) {
                this.modelScopeSettingsItems = [] as any;
                for (let item of _data["modelScopeSettingsItems"])
                    this.modelScopeSettingsItems!.push(UpdateModelScopeSettingsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateModelScopeSettingsItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModelScopeSettingsItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingId"] = this.modelScopeSettingId;
        if (Array.isArray(this.modelScopeSettingsItems)) {
            data["modelScopeSettingsItems"] = [];
            for (let item of this.modelScopeSettingsItems)
                data["modelScopeSettingsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: UpdateModelScopeSettingsItem[];
}

export class UpdateModelScopeSettingsItem implements IUpdateModelScopeSettingsItem {
    modelScopeSettingsItemId?: string;
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;
    deleteStatus?: SoftDeleteStatusType;

    constructor(data?: IUpdateModelScopeSettingsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingsItemId = _data["modelScopeSettingsItemId"];
            this.nodePath = _data["nodePath"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.deleteStatus = _data["deleteStatus"];
        }
    }

    static fromJS(data: any): UpdateModelScopeSettingsItem {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateModelScopeSettingsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingsItemId"] = this.modelScopeSettingsItemId;
        data["nodePath"] = this.nodePath;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["deleteStatus"] = this.deleteStatus;
        return data;
    }
}

export interface IUpdateModelScopeSettingsItem {
    modelScopeSettingsItemId?: string;
    nodePath?: string;
    name?: string;
    description?: string | undefined;
    color?: number;
    deleteStatus?: SoftDeleteStatusType;
}

export class DeleteModelScopeSettingsItemsRequest implements IDeleteModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: DeleteModelScopeSettingsItem[];

    constructor(data?: IDeleteModelScopeSettingsItemsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingId = _data["modelScopeSettingId"];
            if (Array.isArray(_data["modelScopeSettingsItems"])) {
                this.modelScopeSettingsItems = [] as any;
                for (let item of _data["modelScopeSettingsItems"])
                    this.modelScopeSettingsItems!.push(DeleteModelScopeSettingsItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeleteModelScopeSettingsItemsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModelScopeSettingsItemsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingId"] = this.modelScopeSettingId;
        if (Array.isArray(this.modelScopeSettingsItems)) {
            data["modelScopeSettingsItems"] = [];
            for (let item of this.modelScopeSettingsItems)
                data["modelScopeSettingsItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDeleteModelScopeSettingsItemsRequest {
    modelScopeSettingId?: string;
    modelScopeSettingsItems?: DeleteModelScopeSettingsItem[];
}

export class DeleteModelScopeSettingsItem implements IDeleteModelScopeSettingsItem {
    modelScopeSettingsItemId?: string;

    constructor(data?: IDeleteModelScopeSettingsItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelScopeSettingsItemId = _data["modelScopeSettingsItemId"];
        }
    }

    static fromJS(data: any): DeleteModelScopeSettingsItem {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteModelScopeSettingsItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelScopeSettingsItemId"] = this.modelScopeSettingsItemId;
        return data;
    }
}

export interface IDeleteModelScopeSettingsItem {
    modelScopeSettingsItemId?: string;
}

export class Hub implements IHub {
    id?: string;
    name?: string;
    region?: string;

    constructor(data?: IHub) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.region = _data["region"];
        }
    }

    static fromJS(data: any): Hub {
        data = typeof data === 'object' ? data : {};
        let result = new Hub();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["region"] = this.region;
        return data;
    }
}

export interface IHub {
    id?: string;
    name?: string;
    region?: string;
}

export class ApsHub extends Hub implements IApsHub {

    constructor(data?: IApsHub) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApsHub {
        data = typeof data === 'object' ? data : {};
        let result = new ApsHub();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApsHub extends IHub {
}

export class Project2 implements IProject2 {
    id?: string;
    name?: string;

    constructor(data?: IProject2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Project2 {
        data = typeof data === 'object' ? data : {};
        let result = new Project2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProject2 {
    id?: string;
    name?: string;
}

export class ApsProject extends Project2 implements IApsProject {

    constructor(data?: IApsProject) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApsProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApsProject();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApsProject extends IProject2 {
}

export class FolderContent implements IFolderContent {
    id?: string;
    name?: string;
    type?: string;
    viewId?: string;
    viewName?: string;
    storageId?: string;
    createdAt?: Date;
    createdBy?: string;
    createdByName?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
    modifiedByName?: string;
    version?: number;
    storageSize?: number | undefined;

    constructor(data?: IFolderContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.viewId = _data["viewId"];
            this.viewName = _data["viewName"];
            this.storageId = _data["storageId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdByName = _data["createdByName"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByName = _data["modifiedByName"];
            this.version = _data["version"];
            this.storageSize = _data["storageSize"];
        }
    }

    static fromJS(data: any): FolderContent {
        data = typeof data === 'object' ? data : {};
        let result = new FolderContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["viewId"] = this.viewId;
        data["viewName"] = this.viewName;
        data["storageId"] = this.storageId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdByName"] = this.createdByName;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByName"] = this.modifiedByName;
        data["version"] = this.version;
        data["storageSize"] = this.storageSize;
        return data;
    }
}

export interface IFolderContent {
    id?: string;
    name?: string;
    type?: string;
    viewId?: string;
    viewName?: string;
    storageId?: string;
    createdAt?: Date;
    createdBy?: string;
    createdByName?: string;
    modifiedAt?: Date;
    modifiedBy?: string;
    modifiedByName?: string;
    version?: number;
    storageSize?: number | undefined;
}

export class ApsFolderContent extends FolderContent implements IApsFolderContent {

    constructor(data?: IApsFolderContent) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApsFolderContent {
        data = typeof data === 'object' ? data : {};
        let result = new ApsFolderContent();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApsFolderContent extends IFolderContent {
}

export class ItemView implements IItemView {
    id?: string;
    name?: string;
    role?: string;

    constructor(data?: IItemView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): ItemView {
        data = typeof data === 'object' ? data : {};
        let result = new ItemView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["role"] = this.role;
        return data;
    }
}

export interface IItemView {
    id?: string;
    name?: string;
    role?: string;
}

export class ApsItemView extends ItemView implements IApsItemView {

    constructor(data?: IApsItemView) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ApsItemView {
        data = typeof data === 'object' ? data : {};
        let result = new ApsItemView();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApsItemView extends IItemView {
}

export class GetProjectUsers200Response implements IGetProjectUsers200Response {
    pagination?: Pagination;
    results?: ProjectUserResponse[];

    constructor(data?: IGetProjectUsers200Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pagination = _data["pagination"] ? Pagination.fromJS(_data["pagination"]) : undefined as any;
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ProjectUserResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetProjectUsers200Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetProjectUsers200Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pagination"] = this.pagination ? this.pagination.toJSON() : undefined as any;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetProjectUsers200Response {
    pagination?: Pagination;
    results?: ProjectUserResponse[];
}

export class Pagination implements IPagination {
    limit?: number | undefined;
    offset?: number | undefined;
    totalResults?: number | undefined;
    nextUrl?: string;
    previousUrl?: string;

    constructor(data?: IPagination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limit = _data["limit"];
            this.offset = _data["offset"];
            this.totalResults = _data["totalResults"];
            this.nextUrl = _data["nextUrl"];
            this.previousUrl = _data["previousUrl"];
        }
    }

    static fromJS(data: any): Pagination {
        data = typeof data === 'object' ? data : {};
        let result = new Pagination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limit"] = this.limit;
        data["offset"] = this.offset;
        data["totalResults"] = this.totalResults;
        data["nextUrl"] = this.nextUrl;
        data["previousUrl"] = this.previousUrl;
        return data;
    }
}

export interface IPagination {
    limit?: number | undefined;
    offset?: number | undefined;
    totalResults?: number | undefined;
    nextUrl?: string;
    previousUrl?: string;
}

export class ProjectUserResponse implements IProjectUserResponse {
    email?: any;
    id?: any;
    name?: any;
    firstName?: any;
    lastName?: any;
    autodeskId?: string;
    analyticsId?: string;
    addressLine1?: any;
    addressLine2?: any;
    city?: any;
    stateOrProvince?: any;
    postalCode?: any;
    country?: any;
    imageUrl?: string;
    phone?: any;
    jobTitle?: string;
    industry?: string;
    aboutMe?: string;
    accessLevels?: ProjectUserResponseAllOfAccessLevels;
    addedOn?: Date | undefined;
    updatedAt?: Date | undefined;
    roleIds?: (string | undefined)[];
    roles?: ProjectUserResponseAllOfRoles[];
    status?: string;
    products?: ProjectUserProductsResponse1[];

    constructor(data?: IProjectUserResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.autodeskId = _data["autodeskId"];
            this.analyticsId = _data["analyticsId"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.stateOrProvince = _data["stateOrProvince"];
            this.postalCode = _data["postalCode"];
            this.country = _data["country"];
            this.imageUrl = _data["imageUrl"];
            this.phone = _data["phone"];
            this.jobTitle = _data["jobTitle"];
            this.industry = _data["industry"];
            this.aboutMe = _data["aboutMe"];
            this.accessLevels = _data["accessLevels"] ? ProjectUserResponseAllOfAccessLevels.fromJS(_data["accessLevels"]) : undefined as any;
            this.addedOn = _data["addedOn"] ? new Date(_data["addedOn"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(ProjectUserResponseAllOfRoles.fromJS(item));
            }
            this.status = _data["status"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProjectUserProductsResponse1.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectUserResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["autodeskId"] = this.autodeskId;
        data["analyticsId"] = this.analyticsId;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["stateOrProvince"] = this.stateOrProvince;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["imageUrl"] = this.imageUrl;
        data["phone"] = this.phone;
        data["jobTitle"] = this.jobTitle;
        data["industry"] = this.industry;
        data["aboutMe"] = this.aboutMe;
        data["accessLevels"] = this.accessLevels ? this.accessLevels.toJSON() : undefined as any;
        data["addedOn"] = this.addedOn ? this.addedOn.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        data["status"] = this.status;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectUserResponse {
    email?: any;
    id?: any;
    name?: any;
    firstName?: any;
    lastName?: any;
    autodeskId?: string;
    analyticsId?: string;
    addressLine1?: any;
    addressLine2?: any;
    city?: any;
    stateOrProvince?: any;
    postalCode?: any;
    country?: any;
    imageUrl?: string;
    phone?: any;
    jobTitle?: string;
    industry?: string;
    aboutMe?: string;
    accessLevels?: ProjectUserResponseAllOfAccessLevels;
    addedOn?: Date | undefined;
    updatedAt?: Date | undefined;
    roleIds?: (string | undefined)[];
    roles?: ProjectUserResponseAllOfRoles[];
    status?: string;
    products?: ProjectUserProductsResponse1[];
}

export class ProjectUserResponseAllOfAccessLevels implements IProjectUserResponseAllOfAccessLevels {
    accountAdmin?: boolean | undefined;
    projectAdmin?: boolean | undefined;
    executive?: boolean | undefined;

    constructor(data?: IProjectUserResponseAllOfAccessLevels) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountAdmin = _data["accountAdmin"];
            this.projectAdmin = _data["projectAdmin"];
            this.executive = _data["executive"];
        }
    }

    static fromJS(data: any): ProjectUserResponseAllOfAccessLevels {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserResponseAllOfAccessLevels();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountAdmin"] = this.accountAdmin;
        data["projectAdmin"] = this.projectAdmin;
        data["executive"] = this.executive;
        return data;
    }
}

export interface IProjectUserResponseAllOfAccessLevels {
    accountAdmin?: boolean | undefined;
    projectAdmin?: boolean | undefined;
    executive?: boolean | undefined;
}

export class ProjectUserProductsResponse1 implements IProjectUserProductsResponse1 {
    access?: string;

    constructor(data?: IProjectUserProductsResponse1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.access = _data["access"];
        }
    }

    static fromJS(data: any): ProjectUserProductsResponse1 {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUserProductsResponse1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access"] = this.access;
        return data;
    }
}

export interface IProjectUserProductsResponse1 {
    access?: string;
}

export class Documents implements IDocuments {
    fileName?: string;
    displayName?: string;

    constructor(data?: IDocuments) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): Documents {
        data = typeof data === 'object' ? data : {};
        let result = new Documents();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IDocuments {
    fileName?: string;
    displayName?: string;
}

export class HealthCheckResponse implements IHealthCheckResponse {
    id?: number | undefined;
    status?: string;
    onStateFrom?: Date;
    lastExecuted?: Date;
    uri?: string;
    name?: string;
    discoveryService?: any;
    entries?: HealthCheckEntry[];
    history?: any[];

    constructor(data?: IHealthCheckResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.onStateFrom = _data["onStateFrom"] ? new Date(_data["onStateFrom"].toString()) : undefined as any;
            this.lastExecuted = _data["lastExecuted"] ? new Date(_data["lastExecuted"].toString()) : undefined as any;
            this.uri = _data["uri"];
            this.name = _data["name"];
            this.discoveryService = _data["discoveryService"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(HealthCheckEntry.fromJS(item));
            }
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(item);
            }
        }
    }

    static fromJS(data: any): HealthCheckResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["onStateFrom"] = this.onStateFrom ? this.onStateFrom.toISOString() : undefined as any;
        data["lastExecuted"] = this.lastExecuted ? this.lastExecuted.toISOString() : undefined as any;
        data["uri"] = this.uri;
        data["name"] = this.name;
        data["discoveryService"] = this.discoveryService;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item);
        }
        return data;
    }
}

export interface IHealthCheckResponse {
    id?: number | undefined;
    status?: string;
    onStateFrom?: Date;
    lastExecuted?: Date;
    uri?: string;
    name?: string;
    discoveryService?: any;
    entries?: HealthCheckEntry[];
    history?: any[];
}

export class HealthCheckEntry implements IHealthCheckEntry {
    id?: number;
    name?: string;
    status?: string;
    description?: string;
    duration?: string;
    tags?: any;

    constructor(data?: IHealthCheckEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.description = _data["description"];
            this.duration = _data["duration"];
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): HealthCheckEntry {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["status"] = this.status;
        data["description"] = this.description;
        data["duration"] = this.duration;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IHealthCheckEntry {
    id?: number;
    name?: string;
    status?: string;
    description?: string;
    duration?: string;
    tags?: any;
}

export class ProjectData implements IProjectData {
    projetId?: string;
    scenarioDatas?: ScenarioData[];

    constructor(data?: IProjectData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projetId = _data["projetId"];
            if (Array.isArray(_data["scenarioDatas"])) {
                this.scenarioDatas = [] as any;
                for (let item of _data["scenarioDatas"])
                    this.scenarioDatas!.push(ScenarioData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectData {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projetId"] = this.projetId;
        if (Array.isArray(this.scenarioDatas)) {
            data["scenarioDatas"] = [];
            for (let item of this.scenarioDatas)
                data["scenarioDatas"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectData {
    projetId?: string;
    scenarioDatas?: ScenarioData[];
}

export class ScenarioData implements IScenarioData {
    scenarioId?: string;
    name?: string;
    createdAt?: Date;
    fullName?: string | undefined;
    scenarioMetadata?: ScenarioMetadata;
    modelDatas?: ModelData[];
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2;

    constructor(data?: IScenarioData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.name = _data["name"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.fullName = _data["fullName"];
            this.scenarioMetadata = _data["scenarioMetadata"] ? ScenarioMetadata.fromJS(_data["scenarioMetadata"]) : undefined as any;
            if (Array.isArray(_data["modelDatas"])) {
                this.modelDatas = [] as any;
                for (let item of _data["modelDatas"])
                    this.modelDatas!.push(ModelData.fromJS(item));
            }
            this.elementCount = _data["elementCount"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.co2Aggregates = _data["co2Aggregates"] ? Co2Aggregates2.fromJS(_data["co2Aggregates"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScenarioData {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["name"] = this.name;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["fullName"] = this.fullName;
        data["scenarioMetadata"] = this.scenarioMetadata ? this.scenarioMetadata.toJSON() : undefined as any;
        if (Array.isArray(this.modelDatas)) {
            data["modelDatas"] = [];
            for (let item of this.modelDatas)
                data["modelDatas"].push(item ? item.toJSON() : undefined as any);
        }
        data["elementCount"] = this.elementCount;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["co2Aggregates"] = this.co2Aggregates ? this.co2Aggregates.toJSON() : undefined as any;
        return data;
    }
}

export interface IScenarioData {
    scenarioId?: string;
    name?: string;
    createdAt?: Date;
    fullName?: string | undefined;
    scenarioMetadata?: ScenarioMetadata;
    modelDatas?: ModelData[];
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2;
}

export class ModelData implements IModelData {
    scenarioModelId?: string;
    scenarioId?: string;
    model?: Model;
    categories?: CategoryData[];
    elementDatas?: ElementData[];
    percentageAssign?: number;
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;

    constructor(data?: IModelData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioModelId = _data["scenarioModelId"];
            this.scenarioId = _data["scenarioId"];
            this.model = _data["model"] ? Model.fromJS(_data["model"]) : undefined as any;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(CategoryData.fromJS(item));
            }
            if (Array.isArray(_data["elementDatas"])) {
                this.elementDatas = [] as any;
                for (let item of _data["elementDatas"])
                    this.elementDatas!.push(ElementData.fromJS(item));
            }
            this.percentageAssign = _data["percentageAssign"];
            this.elementCount = _data["elementCount"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.co2Aggregates = _data["co2Aggregates"] ? Co2Aggregates2.fromJS(_data["co2Aggregates"]) : undefined as any;
        }
    }

    static fromJS(data: any): ModelData {
        data = typeof data === 'object' ? data : {};
        let result = new ModelData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioModelId"] = this.scenarioModelId;
        data["scenarioId"] = this.scenarioId;
        data["model"] = this.model ? this.model.toJSON() : undefined as any;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elementDatas)) {
            data["elementDatas"] = [];
            for (let item of this.elementDatas)
                data["elementDatas"].push(item ? item.toJSON() : undefined as any);
        }
        data["percentageAssign"] = this.percentageAssign;
        data["elementCount"] = this.elementCount;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["co2Aggregates"] = this.co2Aggregates ? this.co2Aggregates.toJSON() : undefined as any;
        return data;
    }
}

export interface IModelData {
    scenarioModelId?: string;
    scenarioId?: string;
    model?: Model;
    categories?: CategoryData[];
    elementDatas?: ElementData[];
    percentageAssign?: number;
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;
}

export class CategoryData implements ICategoryData {
    cadModelCategoryId?: string;
    /** Name of the category */
    name?: string;
    /** Localized display label of the category */
    label?: string;
    /** Stores the enum value of the category if available (e.g. -2000011) */
    value?: string | undefined;
    /** Number of elements (top-level elements) */
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;

    constructor(data?: ICategoryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.name = _data["name"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.elementCount = _data["elementCount"];
            this.quantityTotal = _data["quantityTotal"];
            this.lengthTotal = _data["lengthTotal"];
            this.areaTotal = _data["areaTotal"];
            this.volumeTotal = _data["volumeTotal"];
            this.co2Aggregates = _data["co2Aggregates"] ? Co2Aggregates2.fromJS(_data["co2Aggregates"]) : undefined as any;
        }
    }

    static fromJS(data: any): CategoryData {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["name"] = this.name;
        data["label"] = this.label;
        data["value"] = this.value;
        data["elementCount"] = this.elementCount;
        data["quantityTotal"] = this.quantityTotal;
        data["lengthTotal"] = this.lengthTotal;
        data["areaTotal"] = this.areaTotal;
        data["volumeTotal"] = this.volumeTotal;
        data["co2Aggregates"] = this.co2Aggregates ? this.co2Aggregates.toJSON() : undefined as any;
        return data;
    }
}

export interface ICategoryData {
    cadModelCategoryId?: string;
    /** Name of the category */
    name?: string;
    /** Localized display label of the category */
    label?: string;
    /** Stores the enum value of the category if available (e.g. -2000011) */
    value?: string | undefined;
    /** Number of elements (top-level elements) */
    elementCount?: number;
    quantityTotal?: number;
    lengthTotal?: number;
    areaTotal?: number;
    volumeTotal?: number;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;
}

export class Co2Aggregates2 implements ICo2Aggregates2 {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    materialCount?: number | undefined;
    supplementalCount?: number | undefined;
    totalCo2?: number | undefined;

    constructor(data?: ICo2Aggregates2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.materialCount = _data["materialCount"];
            this.supplementalCount = _data["supplementalCount"];
            this.totalCo2 = _data["totalCo2"];
        }
    }

    static fromJS(data: any): Co2Aggregates2 {
        data = typeof data === 'object' ? data : {};
        let result = new Co2Aggregates2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["materialCount"] = this.materialCount;
        data["supplementalCount"] = this.supplementalCount;
        data["totalCo2"] = this.totalCo2;
        return data;
    }
}

export interface ICo2Aggregates2 {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    materialCount?: number | undefined;
    supplementalCount?: number | undefined;
    totalCo2?: number | undefined;
}

export class ElementData implements IElementData {
    cadId?: string;
    parentCadId?: string;
    componentCount?: number;
    cadMaterial?: string | undefined;
    cadModelCategoryId?: string;
    co2MaterialTypeId?: string | undefined;
    scopeId?: number | undefined;
    /** The Co2MaterialType impact factor */
    a1A2A3?: number | undefined;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;
    system?: string | undefined;
    subSystem?: string | undefined;
    freeText1?: string | undefined;
    freeText2?: string | undefined;
    freeText3?: string | undefined;
    type?: MaterialType | undefined;

    constructor(data?: IElementData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadId = _data["cadId"];
            this.parentCadId = _data["parentCadId"];
            this.componentCount = _data["componentCount"];
            this.cadMaterial = _data["cadMaterial"];
            this.cadModelCategoryId = _data["cadModelCategoryId"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.scopeId = _data["scopeId"];
            this.a1A2A3 = _data["a1A2A3"];
            this.co2Aggregates = _data["co2Aggregates"] ? Co2Aggregates2.fromJS(_data["co2Aggregates"]) : undefined as any;
            this.system = _data["system"];
            this.subSystem = _data["subSystem"];
            this.freeText1 = _data["freeText1"];
            this.freeText2 = _data["freeText2"];
            this.freeText3 = _data["freeText3"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ElementData {
        data = typeof data === 'object' ? data : {};
        let result = new ElementData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadId"] = this.cadId;
        data["parentCadId"] = this.parentCadId;
        data["componentCount"] = this.componentCount;
        data["cadMaterial"] = this.cadMaterial;
        data["cadModelCategoryId"] = this.cadModelCategoryId;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["scopeId"] = this.scopeId;
        data["a1A2A3"] = this.a1A2A3;
        data["co2Aggregates"] = this.co2Aggregates ? this.co2Aggregates.toJSON() : undefined as any;
        data["system"] = this.system;
        data["subSystem"] = this.subSystem;
        data["freeText1"] = this.freeText1;
        data["freeText2"] = this.freeText2;
        data["freeText3"] = this.freeText3;
        data["type"] = this.type;
        return data;
    }
}

export interface IElementData {
    cadId?: string;
    parentCadId?: string;
    componentCount?: number;
    cadMaterial?: string | undefined;
    cadModelCategoryId?: string;
    co2MaterialTypeId?: string | undefined;
    scopeId?: number | undefined;
    /** The Co2MaterialType impact factor */
    a1A2A3?: number | undefined;
    /** The calculated tCo2e */
    co2Aggregates?: Co2Aggregates2 | undefined;
    system?: string | undefined;
    subSystem?: string | undefined;
    freeText1?: string | undefined;
    freeText2?: string | undefined;
    freeText3?: string | undefined;
    type?: MaterialType | undefined;
}

export class ExportSelectedDataResponse implements IExportSelectedDataResponse {
    name?: string;
    jobId?: string;

    constructor(data?: IExportSelectedDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.jobId = _data["jobId"];
        }
    }

    static fromJS(data: any): ExportSelectedDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSelectedDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["jobId"] = this.jobId;
        return data;
    }
}

export interface IExportSelectedDataResponse {
    name?: string;
    jobId?: string;
}

export class ExportSelectedDataRequest implements IExportSelectedDataRequest {
    exportFormat?: ExportFormatType;
    scenarioExports?: ScenarioExport[];

    constructor(data?: IExportSelectedDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exportFormat = _data["exportFormat"];
            if (Array.isArray(_data["scenarioExports"])) {
                this.scenarioExports = [] as any;
                for (let item of _data["scenarioExports"])
                    this.scenarioExports!.push(ScenarioExport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportSelectedDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportSelectedDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exportFormat"] = this.exportFormat;
        if (Array.isArray(this.scenarioExports)) {
            data["scenarioExports"] = [];
            for (let item of this.scenarioExports)
                data["scenarioExports"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IExportSelectedDataRequest {
    exportFormat?: ExportFormatType;
    scenarioExports?: ScenarioExport[];
}

export enum ExportFormatType {
    DefaultExcelFormat = "DefaultExcelFormat",
    ZeroPlatformExcelFormat = "ZeroPlatformExcelFormat",
}

export class ScenarioExport implements IScenarioExport {
    scenarioId?: string;
    modelIds?: string[];

    constructor(data?: IScenarioExport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ScenarioExport {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioExport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        return data;
    }
}

export interface IScenarioExport {
    scenarioId?: string;
    modelIds?: string[];
}

export class ProjectResultsDto implements IProjectResultsDto {
    projectId?: string;
    projectName?: string;
    scenarios?: ScenarioResultsSummaryDto[];

    constructor(data?: IProjectResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(ScenarioResultsSummaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectResultsDto {
    projectId?: string;
    projectName?: string;
    scenarios?: ScenarioResultsSummaryDto[];
}

/** Summary-level scenario results used in the project-level response. */
export class ScenarioResultsSummaryDto implements IScenarioResultsSummaryDto {
    scenarioId?: string;
    scenarioName?: string;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;

    constructor(data?: IScenarioResultsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.scenarioName = _data["scenarioName"];
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
            this.percentageAssigned = _data["percentageAssigned"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScenarioResultsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioResultsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["scenarioName"] = this.scenarioName;
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        data["percentageAssigned"] = this.percentageAssigned;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        return data;
    }
}

/** Summary-level scenario results used in the project-level response. */
export interface IScenarioResultsSummaryDto {
    scenarioId?: string;
    scenarioName?: string;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
}

export class Co2ResultsDto implements ICo2ResultsDto {
    tCO2e?: Co2ValuesDto;
    kgCO2ePerM2?: Co2ValuesDto;
    kgCO2ePerM2PerYear?: Co2ValuesDto;

    constructor(data?: ICo2ResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tCO2e = _data["tCO2e"] ? Co2ValuesDto.fromJS(_data["tCO2e"]) : undefined as any;
            this.kgCO2ePerM2 = _data["kgCO2ePerM2"] ? Co2ValuesDto.fromJS(_data["kgCO2ePerM2"]) : undefined as any;
            this.kgCO2ePerM2PerYear = _data["kgCO2ePerM2PerYear"] ? Co2ValuesDto.fromJS(_data["kgCO2ePerM2PerYear"]) : undefined as any;
        }
    }

    static fromJS(data: any): Co2ResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new Co2ResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tCO2e"] = this.tCO2e ? this.tCO2e.toJSON() : undefined as any;
        data["kgCO2ePerM2"] = this.kgCO2ePerM2 ? this.kgCO2ePerM2.toJSON() : undefined as any;
        data["kgCO2ePerM2PerYear"] = this.kgCO2ePerM2PerYear ? this.kgCO2ePerM2PerYear.toJSON() : undefined as any;
        return data;
    }
}

export interface ICo2ResultsDto {
    tCO2e?: Co2ValuesDto;
    kgCO2ePerM2?: Co2ValuesDto;
    kgCO2ePerM2PerYear?: Co2ValuesDto;
}

export class Co2ValuesDto implements ICo2ValuesDto {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;

    constructor(data?: ICo2ValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.a1A2A3 = _data["a1A2A3"];
            this.a4 = _data["a4"];
            this.a5 = _data["a5"];
            this.b1 = _data["b1"];
            this.b2 = _data["b2"];
            this.b3 = _data["b3"];
            this.b4 = _data["b4"];
            this.b5 = _data["b5"];
            this.b6 = _data["b6"];
            this.b7 = _data["b7"];
            this.c1 = _data["c1"];
            this.c2 = _data["c2"];
            this.c3 = _data["c3"];
            this.c4 = _data["c4"];
            this.d = _data["d"];
            this.biogenic = _data["biogenic"];
            this.totalCo2 = _data["totalCo2"];
        }
    }

    static fromJS(data: any): Co2ValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new Co2ValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["a1A2A3"] = this.a1A2A3;
        data["a4"] = this.a4;
        data["a5"] = this.a5;
        data["b1"] = this.b1;
        data["b2"] = this.b2;
        data["b3"] = this.b3;
        data["b4"] = this.b4;
        data["b5"] = this.b5;
        data["b6"] = this.b6;
        data["b7"] = this.b7;
        data["c1"] = this.c1;
        data["c2"] = this.c2;
        data["c3"] = this.c3;
        data["c4"] = this.c4;
        data["d"] = this.d;
        data["biogenic"] = this.biogenic;
        data["totalCo2"] = this.totalCo2;
        return data;
    }
}

export interface ICo2ValuesDto {
    a1A2A3?: number | undefined;
    a4?: number | undefined;
    a5?: number | undefined;
    b1?: number | undefined;
    b2?: number | undefined;
    b3?: number | undefined;
    b4?: number | undefined;
    b5?: number | undefined;
    b6?: number | undefined;
    b7?: number | undefined;
    c1?: number | undefined;
    c2?: number | undefined;
    c3?: number | undefined;
    c4?: number | undefined;
    d?: number | undefined;
    biogenic?: number | undefined;
    totalCo2?: number | undefined;
}

/** Detailed scenario results including per-model breakdowns and groupings. Used in the scenario-level response. */
export class ScenarioResultsDetailDto implements IScenarioResultsDetailDto {
    projectId?: string;
    projectName?: string;
    scenarioId?: string;
    scenarioName?: string;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
    models?: ModelResultsDto[];
    groupings?: ResultsGroupingsDto;

    constructor(data?: IScenarioResultsDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.scenarioId = _data["scenarioId"];
            this.scenarioName = _data["scenarioName"];
            this.totalFloorArea = _data["totalFloorArea"];
            this.serviceLife = _data["serviceLife"];
            this.percentageAssigned = _data["percentageAssigned"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
            if (Array.isArray(_data["models"])) {
                this.models = [] as any;
                for (let item of _data["models"])
                    this.models!.push(ModelResultsDto.fromJS(item));
            }
            this.groupings = _data["groupings"] ? ResultsGroupingsDto.fromJS(_data["groupings"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScenarioResultsDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioResultsDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["scenarioId"] = this.scenarioId;
        data["scenarioName"] = this.scenarioName;
        data["totalFloorArea"] = this.totalFloorArea;
        data["serviceLife"] = this.serviceLife;
        data["percentageAssigned"] = this.percentageAssigned;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        if (Array.isArray(this.models)) {
            data["models"] = [];
            for (let item of this.models)
                data["models"].push(item ? item.toJSON() : undefined as any);
        }
        data["groupings"] = this.groupings ? this.groupings.toJSON() : undefined as any;
        return data;
    }
}

/** Detailed scenario results including per-model breakdowns and groupings. Used in the scenario-level response. */
export interface IScenarioResultsDetailDto {
    projectId?: string;
    projectName?: string;
    scenarioId?: string;
    scenarioName?: string;
    totalFloorArea?: number | undefined;
    serviceLife?: number | undefined;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
    models?: ModelResultsDto[];
    groupings?: ResultsGroupingsDto;
}

export class ModelResultsDto implements IModelResultsDto {
    modelId?: string;
    modelName?: string;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;

    constructor(data?: IModelResultsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.percentageAssigned = _data["percentageAssigned"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
        }
    }

    static fromJS(data: any): ModelResultsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelResultsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["percentageAssigned"] = this.percentageAssigned;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        return data;
    }
}

export interface IModelResultsDto {
    modelId?: string;
    modelName?: string;
    percentageAssigned?: number;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
}

export class ResultsGroupingsDto implements IResultsGroupingsDto {
    byCategory?: CategoryGroupDto[];
    byCadMaterial?: CadMaterialGroupDto[];
    byECMaterial?: EcMaterialGroupDto[];

    constructor(data?: IResultsGroupingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["byCategory"])) {
                this.byCategory = [] as any;
                for (let item of _data["byCategory"])
                    this.byCategory!.push(CategoryGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["byCadMaterial"])) {
                this.byCadMaterial = [] as any;
                for (let item of _data["byCadMaterial"])
                    this.byCadMaterial!.push(CadMaterialGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["byECMaterial"])) {
                this.byECMaterial = [] as any;
                for (let item of _data["byECMaterial"])
                    this.byECMaterial!.push(EcMaterialGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResultsGroupingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultsGroupingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.byCategory)) {
            data["byCategory"] = [];
            for (let item of this.byCategory)
                data["byCategory"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.byCadMaterial)) {
            data["byCadMaterial"] = [];
            for (let item of this.byCadMaterial)
                data["byCadMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.byECMaterial)) {
            data["byECMaterial"] = [];
            for (let item of this.byECMaterial)
                data["byECMaterial"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResultsGroupingsDto {
    byCategory?: CategoryGroupDto[];
    byCadMaterial?: CadMaterialGroupDto[];
    byECMaterial?: EcMaterialGroupDto[];
}

export class CategoryGroupDto implements ICategoryGroupDto {
    categoryName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;

    constructor(data?: ICategoryGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryName = _data["categoryName"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
        }
    }

    static fromJS(data: any): CategoryGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryName"] = this.categoryName;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        return data;
    }
}

export interface ICategoryGroupDto {
    categoryName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
}

export class CadMaterialGroupDto implements ICadMaterialGroupDto {
    cadMaterialName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;

    constructor(data?: ICadMaterialGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cadMaterialName = _data["cadMaterialName"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
        }
    }

    static fromJS(data: any): CadMaterialGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CadMaterialGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cadMaterialName"] = this.cadMaterialName;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        return data;
    }
}

export interface ICadMaterialGroupDto {
    cadMaterialName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
}

export class EcMaterialGroupDto implements IEcMaterialGroupDto {
    ecMaterialId?: string | undefined;
    ecMaterialName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;

    constructor(data?: IEcMaterialGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ecMaterialId = _data["ecMaterialId"];
            this.ecMaterialName = _data["ecMaterialName"];
            this.elementCount = _data["elementCount"];
            this.co2Results = _data["co2Results"] ? Co2ResultsDto.fromJS(_data["co2Results"]) : undefined as any;
        }
    }

    static fromJS(data: any): EcMaterialGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EcMaterialGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ecMaterialId"] = this.ecMaterialId;
        data["ecMaterialName"] = this.ecMaterialName;
        data["elementCount"] = this.elementCount;
        data["co2Results"] = this.co2Results ? this.co2Results.toJSON() : undefined as any;
        return data;
    }
}

export interface IEcMaterialGroupDto {
    ecMaterialId?: string | undefined;
    ecMaterialName?: string;
    elementCount?: number;
    co2Results?: Co2ResultsDto;
}

/** Paginated response for the model element results endpoint. Contains one page of element-level CO2 data along with pagination metadata. */
export class ModelElementResultsPageDto implements IModelElementResultsPageDto {
    projectId?: string;
    projectName?: string;
    scenarioId?: string;
    scenarioName?: string;
    modelId?: string;
    modelName?: string;
    totalElementCount?: number;
    pageSize?: number;
    hasMore?: boolean;
    nextCursor?: string | undefined;
    nextUrl?: string | undefined;
    elements?: ElementResultDto[];

    constructor(data?: IModelElementResultsPageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.scenarioId = _data["scenarioId"];
            this.scenarioName = _data["scenarioName"];
            this.modelId = _data["modelId"];
            this.modelName = _data["modelName"];
            this.totalElementCount = _data["totalElementCount"];
            this.pageSize = _data["pageSize"];
            this.hasMore = _data["hasMore"];
            this.nextCursor = _data["nextCursor"];
            this.nextUrl = _data["nextUrl"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(ElementResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelElementResultsPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelElementResultsPageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["scenarioId"] = this.scenarioId;
        data["scenarioName"] = this.scenarioName;
        data["modelId"] = this.modelId;
        data["modelName"] = this.modelName;
        data["totalElementCount"] = this.totalElementCount;
        data["pageSize"] = this.pageSize;
        data["hasMore"] = this.hasMore;
        data["nextCursor"] = this.nextCursor;
        data["nextUrl"] = this.nextUrl;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Paginated response for the model element results endpoint. Contains one page of element-level CO2 data along with pagination metadata. */
export interface IModelElementResultsPageDto {
    projectId?: string;
    projectName?: string;
    scenarioId?: string;
    scenarioName?: string;
    modelId?: string;
    modelName?: string;
    totalElementCount?: number;
    pageSize?: number;
    hasMore?: boolean;
    nextCursor?: string | undefined;
    nextUrl?: string | undefined;
    elements?: ElementResultDto[];
}

/** A single row of element-level CO2 data. Represents an Element, Component, or Supplemental. */
export class ElementResultDto implements IElementResultDto {
    rowId?: string;
    /** One of "Element", "Component", or "Supplemental". */
    elementType?: string;
    cadId?: string | undefined;
    parentCadId?: string | undefined;
    categoryName?: string | undefined;
    cadMaterial?: string | undefined;
    ecMaterialName?: string | undefined;
    ecMaterialId?: string | undefined;
    scopeId?: number | undefined;
    /** CO2 emissions breakdown by life cycle stage. All values in tCO2e. */
    co2?: Co2ValuesDto;

    constructor(data?: IElementResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowId = _data["rowId"];
            this.elementType = _data["elementType"];
            this.cadId = _data["cadId"];
            this.parentCadId = _data["parentCadId"];
            this.categoryName = _data["categoryName"];
            this.cadMaterial = _data["cadMaterial"];
            this.ecMaterialName = _data["ecMaterialName"];
            this.ecMaterialId = _data["ecMaterialId"];
            this.scopeId = _data["scopeId"];
            this.co2 = _data["co2"] ? Co2ValuesDto.fromJS(_data["co2"]) : undefined as any;
        }
    }

    static fromJS(data: any): ElementResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowId"] = this.rowId;
        data["elementType"] = this.elementType;
        data["cadId"] = this.cadId;
        data["parentCadId"] = this.parentCadId;
        data["categoryName"] = this.categoryName;
        data["cadMaterial"] = this.cadMaterial;
        data["ecMaterialName"] = this.ecMaterialName;
        data["ecMaterialId"] = this.ecMaterialId;
        data["scopeId"] = this.scopeId;
        data["co2"] = this.co2 ? this.co2.toJSON() : undefined as any;
        return data;
    }
}

/** A single row of element-level CO2 data. Represents an Element, Component, or Supplemental. */
export interface IElementResultDto {
    rowId?: string;
    /** One of "Element", "Component", or "Supplemental". */
    elementType?: string;
    cadId?: string | undefined;
    parentCadId?: string | undefined;
    categoryName?: string | undefined;
    cadMaterial?: string | undefined;
    ecMaterialName?: string | undefined;
    ecMaterialId?: string | undefined;
    scopeId?: number | undefined;
    /** CO2 emissions breakdown by life cycle stage. All values in tCO2e. */
    co2?: Co2ValuesDto;
}

export class CreateNewProjectResponse implements ICreateNewProjectResponse {
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;

    constructor(data?: ICreateNewProjectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectStatus = _data["projectStatus"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateNewProjectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewProjectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectStatus"] = this.projectStatus;
        data["name"] = this.name;
        return data;
    }
}

export interface ICreateNewProjectResponse {
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;
}

export class CreateNewProjectRequest implements ICreateNewProjectRequest {
    name?: string | undefined;
    description?: string | undefined;
    projectEmissionReductionTarget?: number | undefined;
    nonModelledElements?: boolean | undefined;
    profileId?: string | undefined;
    projectMetadata?: ProjectMetadata | undefined;

    constructor(data?: ICreateNewProjectRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.nonModelledElements = _data["nonModelledElements"];
            this.profileId = _data["profileId"];
            this.projectMetadata = _data["projectMetadata"] ? ProjectMetadata.fromJS(_data["projectMetadata"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateNewProjectRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewProjectRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["nonModelledElements"] = this.nonModelledElements;
        data["profileId"] = this.profileId;
        data["projectMetadata"] = this.projectMetadata ? this.projectMetadata.toJSON() : undefined as any;
        return data;
    }
}

export interface ICreateNewProjectRequest {
    name?: string | undefined;
    description?: string | undefined;
    projectEmissionReductionTarget?: number | undefined;
    nonModelledElements?: boolean | undefined;
    profileId?: string | undefined;
    projectMetadata?: ProjectMetadata | undefined;
}

export class UpdateProjectAccMappingResponse implements IUpdateProjectAccMappingResponse {
    ictProjectId?: string;
    accProjectId?: string;
    accProjectName?: string;
    accHubId?: string;
    accHubName?: string;

    constructor(data?: IUpdateProjectAccMappingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ictProjectId = _data["ictProjectId"];
            this.accProjectId = _data["accProjectId"];
            this.accProjectName = _data["accProjectName"];
            this.accHubId = _data["accHubId"];
            this.accHubName = _data["accHubName"];
        }
    }

    static fromJS(data: any): UpdateProjectAccMappingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectAccMappingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ictProjectId"] = this.ictProjectId;
        data["accProjectId"] = this.accProjectId;
        data["accProjectName"] = this.accProjectName;
        data["accHubId"] = this.accHubId;
        data["accHubName"] = this.accHubName;
        return data;
    }
}

export interface IUpdateProjectAccMappingResponse {
    ictProjectId?: string;
    accProjectId?: string;
    accProjectName?: string;
    accHubId?: string;
    accHubName?: string;
}

export class UpdateProjectAccMappingRequest implements IUpdateProjectAccMappingRequest {
    ictProjectId?: string;
    accProjectId?: string;
    accHubId?: string;
    accHubName?: string;
    accProjectName?: string;

    constructor(data?: IUpdateProjectAccMappingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ictProjectId = _data["ictProjectId"];
            this.accProjectId = _data["accProjectId"];
            this.accHubId = _data["accHubId"];
            this.accHubName = _data["accHubName"];
            this.accProjectName = _data["accProjectName"];
        }
    }

    static fromJS(data: any): UpdateProjectAccMappingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectAccMappingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ictProjectId"] = this.ictProjectId;
        data["accProjectId"] = this.accProjectId;
        data["accHubId"] = this.accHubId;
        data["accHubName"] = this.accHubName;
        data["accProjectName"] = this.accProjectName;
        return data;
    }
}

export interface IUpdateProjectAccMappingRequest {
    ictProjectId?: string;
    accProjectId?: string;
    accHubId?: string;
    accHubName?: string;
    accProjectName?: string;
}

export class ProjectDto implements IProjectDto {
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateBudgetTarget?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    userId?: string;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    user?: ApplicationUser;
    profileId?: string | undefined;
    profile?: Profile | undefined;
    permissions?: string[];

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectStatus = _data["projectStatus"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.floorArea = _data["floorArea"];
            this.developmentArea = _data["developmentArea"];
            this.totalArea = _data["totalArea"];
            this.climateBudgetTarget = _data["climateBudgetTarget"];
            this.projectEmissionReductionTarget = _data["projectEmissionReductionTarget"];
            this.userId = _data["userId"];
            this.rebarEstimationStatus = _data["rebarEstimationStatus"];
            this.nonModelledElementsStatus = _data["nonModelledElementsStatus"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
            this.user = _data["user"] ? ApplicationUser.fromJS(_data["user"]) : undefined as any;
            this.profileId = _data["profileId"];
            this.profile = _data["profile"] ? Profile.fromJS(_data["profile"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectStatus"] = this.projectStatus;
        data["name"] = this.name;
        data["description"] = this.description;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["floorArea"] = this.floorArea;
        data["developmentArea"] = this.developmentArea;
        data["totalArea"] = this.totalArea;
        data["climateBudgetTarget"] = this.climateBudgetTarget;
        data["projectEmissionReductionTarget"] = this.projectEmissionReductionTarget;
        data["userId"] = this.userId;
        data["rebarEstimationStatus"] = this.rebarEstimationStatus;
        data["nonModelledElementsStatus"] = this.nonModelledElementsStatus;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["profileId"] = this.profileId;
        data["profile"] = this.profile ? this.profile.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IProjectDto {
    projectId?: string;
    projectStatus?: ProjectStatus;
    name?: string | undefined;
    description?: string | undefined;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateBudgetTarget?: number | undefined;
    projectEmissionReductionTarget?: number | undefined;
    userId?: string;
    rebarEstimationStatus?: RebarEstimationStatus;
    nonModelledElementsStatus?: NonModelledElementsStatus;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    user?: ApplicationUser;
    profileId?: string | undefined;
    profile?: Profile | undefined;
    permissions?: string[];
}

export class ScenarioDto implements IScenarioDto {
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;
    profileId?: string | undefined;

    constructor(data?: IScenarioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.profileId = _data["profileId"];
        }
    }

    static fromJS(data: any): ScenarioDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["profileId"] = this.profileId;
        return data;
    }
}

export interface IScenarioDto {
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;
    profileId?: string | undefined;
}

export class CreateNewScenarioResponse implements ICreateNewScenarioResponse {
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;

    constructor(data?: ICreateNewScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateNewScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateNewScenarioResponse {
    scenarioId?: string;
    projectId?: string;
    name?: string;
    description?: string;
}

export class CreateNewScenarioRequest implements ICreateNewScenarioRequest {
    projectId?: string;
    name?: string;
    description?: string;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    modelIds?: string[];
    scenarioMetadata?: ScenarioMetadata | undefined;
    profileId?: string | undefined;
    projectPhaseId?: string | undefined;
    isFinalforProjectPhase?: boolean;
    /** References MetadataEntities where Type = ScenarioType. Use null/empty for "None". */
    scenarioTypeId?: string | undefined;

    constructor(data?: ICreateNewScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.rebarEstimation = _data["rebarEstimation"];
            this.nonModelledElements = _data["nonModelledElements"];
            if (Array.isArray(_data["modelIds"])) {
                this.modelIds = [] as any;
                for (let item of _data["modelIds"])
                    this.modelIds!.push(item);
            }
            this.scenarioMetadata = _data["scenarioMetadata"] ? ScenarioMetadata.fromJS(_data["scenarioMetadata"]) : undefined as any;
            this.profileId = _data["profileId"];
            this.projectPhaseId = _data["projectPhaseId"];
            this.isFinalforProjectPhase = _data["isFinalforProjectPhase"];
            this.scenarioTypeId = _data["scenarioTypeId"];
        }
    }

    static fromJS(data: any): CreateNewScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["rebarEstimation"] = this.rebarEstimation;
        data["nonModelledElements"] = this.nonModelledElements;
        if (Array.isArray(this.modelIds)) {
            data["modelIds"] = [];
            for (let item of this.modelIds)
                data["modelIds"].push(item);
        }
        data["scenarioMetadata"] = this.scenarioMetadata ? this.scenarioMetadata.toJSON() : undefined as any;
        data["profileId"] = this.profileId;
        data["projectPhaseId"] = this.projectPhaseId;
        data["isFinalforProjectPhase"] = this.isFinalforProjectPhase;
        data["scenarioTypeId"] = this.scenarioTypeId;
        return data;
    }
}

export interface ICreateNewScenarioRequest {
    projectId?: string;
    name?: string;
    description?: string;
    rebarEstimation?: boolean | undefined;
    nonModelledElements?: boolean | undefined;
    modelIds?: string[];
    scenarioMetadata?: ScenarioMetadata | undefined;
    profileId?: string | undefined;
    projectPhaseId?: string | undefined;
    isFinalforProjectPhase?: boolean;
    /** References MetadataEntities where Type = ScenarioType. Use null/empty for "None". */
    scenarioTypeId?: string | undefined;
}

export class CreateNewModelResponse implements ICreateNewModelResponse {
    modelId?: string;
    projectId?: string;
    modelName?: string | undefined;
    active?: boolean;

    constructor(data?: ICreateNewModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
            this.modelName = _data["modelName"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): CreateNewModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        data["modelName"] = this.modelName;
        data["active"] = this.active;
        return data;
    }
}

export interface ICreateNewModelResponse {
    modelId?: string;
    projectId?: string;
    modelName?: string | undefined;
    active?: boolean;
}

export class CreateNewModelRequest implements ICreateNewModelRequest {
    projectID?: string;
    /** The name of the model. */
    modelName?: string;
    /** List of elements/components to be created in the Elements table. */
    elements?: CreateElementRequest[];

    constructor(data?: ICreateNewModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectID = _data["Project-ID"];
            this.modelName = _data["Model-Name"];
            if (Array.isArray(_data["elements"])) {
                this.elements = [] as any;
                for (let item of _data["elements"])
                    this.elements!.push(CreateElementRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateNewModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Project-ID"] = this.projectID;
        data["Model-Name"] = this.modelName;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateNewModelRequest {
    projectID?: string;
    /** The name of the model. */
    modelName?: string;
    /** List of elements/components to be created in the Elements table. */
    elements?: CreateElementRequest[];
}

export class CreateElementRequest implements ICreateElementRequest {
    /** The unique identifier for the element/component. */
    id?: string;
    category?: string;
    family?: string;
    typeGroup?: string;
    modelMaterial?: string;
    typeComponent?: string;
    quantities?: CreateQuantityRequest[];
    rebarPercentage?: number | undefined;
    nonModelledPercentage?: number | undefined;

    constructor(data?: ICreateElementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.family = _data["family"];
            this.typeGroup = _data["Type-Group"];
            this.modelMaterial = _data["Model-Material"];
            this.typeComponent = _data["Type-Component"];
            if (Array.isArray(_data["quantities"])) {
                this.quantities = [] as any;
                for (let item of _data["quantities"])
                    this.quantities!.push(CreateQuantityRequest.fromJS(item));
            }
            this.rebarPercentage = _data["Rebar-Percentage"];
            this.nonModelledPercentage = _data["Non-Modelled-Percentage"];
        }
    }

    static fromJS(data: any): CreateElementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateElementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["family"] = this.family;
        data["Type-Group"] = this.typeGroup;
        data["Model-Material"] = this.modelMaterial;
        data["Type-Component"] = this.typeComponent;
        if (Array.isArray(this.quantities)) {
            data["quantities"] = [];
            for (let item of this.quantities)
                data["quantities"].push(item ? item.toJSON() : undefined as any);
        }
        data["Rebar-Percentage"] = this.rebarPercentage;
        data["Non-Modelled-Percentage"] = this.nonModelledPercentage;
        return data;
    }
}

export interface ICreateElementRequest {
    /** The unique identifier for the element/component. */
    id?: string;
    category?: string;
    family?: string;
    typeGroup?: string;
    modelMaterial?: string;
    typeComponent?: string;
    quantities?: CreateQuantityRequest[];
    rebarPercentage?: number | undefined;
    nonModelledPercentage?: number | undefined;
}

export class CreateQuantityRequest implements ICreateQuantityRequest {
    /** The quantity value. */
    quantity?: number;
    /** The unit of the quantity (e.g., m, m2, m3). */
    unit?: string;

    constructor(data?: ICreateQuantityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.unit = _data["unit"];
        }
    }

    static fromJS(data: any): CreateQuantityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuantityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["unit"] = this.unit;
        return data;
    }
}

export interface ICreateQuantityRequest {
    /** The quantity value. */
    quantity?: number;
    /** The unit of the quantity (e.g., m, m2, m3). */
    unit?: string;
}

export class ModelDto implements IModelDto {
    modelId?: string;
    projectId?: string;
    description?: string | undefined;
    active?: boolean;
    status?: ModelState;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateTarget?: number | undefined;
    climateBudgetTarget?: number | undefined;
    elementCount?: number;
    componentCount?: number;
    elementWithComponentsCount?: number;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    modelTypeId?: string | undefined;
    modelTypeName?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;

    constructor(data?: IModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
            this.description = _data["description"];
            this.active = _data["active"];
            this.status = _data["status"];
            this.assetType = _data["assetType"];
            this.projectNumber = _data["projectNumber"];
            this.phase = _data["phase"];
            this.buildingType = _data["buildingType"];
            this.floorArea = _data["floorArea"];
            this.developmentArea = _data["developmentArea"];
            this.totalArea = _data["totalArea"];
            this.climateTarget = _data["climateTarget"];
            this.climateBudgetTarget = _data["climateBudgetTarget"];
            this.elementCount = _data["elementCount"];
            this.componentCount = _data["componentCount"];
            this.elementWithComponentsCount = _data["elementWithComponentsCount"];
            this.apsHubId = _data["apsHubId"];
            this.apsHubName = _data["apsHubName"];
            this.apsProjectId = _data["apsProjectId"];
            this.apsProjectName = _data["apsProjectName"];
            this.apsItemId = _data["apsItemId"];
            this.apsItemName = _data["apsItemName"];
            this.apsViewId = _data["apsViewId"];
            this.apsViewName = _data["apsViewName"];
            this.apsVersionId = _data["apsVersionId"];
            this.apsWebView = _data["apsWebView"];
            this.apsStorageId = _data["apsStorageId"];
            this.apsCreateUserName = _data["apsCreateUserName"];
            this.apsLastModifiedUserName = _data["apsLastModifiedUserName"];
            this.apsVersion = _data["apsVersion"];
            this.apsIsCompositeDesign = _data["apsIsCompositeDesign"];
            this.apsFileSize = _data["apsFileSize"];
            this.apsFileVersion = _data["apsFileVersion"];
            this.modelEmissionReductionTarget = _data["modelEmissionReductionTarget"];
            this.modelTypeId = _data["modelTypeId"];
            this.modelTypeName = _data["modelTypeName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): ModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        data["description"] = this.description;
        data["active"] = this.active;
        data["status"] = this.status;
        data["assetType"] = this.assetType;
        data["projectNumber"] = this.projectNumber;
        data["phase"] = this.phase;
        data["buildingType"] = this.buildingType;
        data["floorArea"] = this.floorArea;
        data["developmentArea"] = this.developmentArea;
        data["totalArea"] = this.totalArea;
        data["climateTarget"] = this.climateTarget;
        data["climateBudgetTarget"] = this.climateBudgetTarget;
        data["elementCount"] = this.elementCount;
        data["componentCount"] = this.componentCount;
        data["elementWithComponentsCount"] = this.elementWithComponentsCount;
        data["apsHubId"] = this.apsHubId;
        data["apsHubName"] = this.apsHubName;
        data["apsProjectId"] = this.apsProjectId;
        data["apsProjectName"] = this.apsProjectName;
        data["apsItemId"] = this.apsItemId;
        data["apsItemName"] = this.apsItemName;
        data["apsViewId"] = this.apsViewId;
        data["apsViewName"] = this.apsViewName;
        data["apsVersionId"] = this.apsVersionId;
        data["apsWebView"] = this.apsWebView;
        data["apsStorageId"] = this.apsStorageId;
        data["apsCreateUserName"] = this.apsCreateUserName;
        data["apsLastModifiedUserName"] = this.apsLastModifiedUserName;
        data["apsVersion"] = this.apsVersion;
        data["apsIsCompositeDesign"] = this.apsIsCompositeDesign;
        data["apsFileSize"] = this.apsFileSize;
        data["apsFileVersion"] = this.apsFileVersion;
        data["modelEmissionReductionTarget"] = this.modelEmissionReductionTarget;
        data["modelTypeId"] = this.modelTypeId;
        data["modelTypeName"] = this.modelTypeName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IModelDto {
    modelId?: string;
    projectId?: string;
    description?: string | undefined;
    active?: boolean;
    status?: ModelState;
    assetType?: string | undefined;
    projectNumber?: string | undefined;
    phase?: string | undefined;
    buildingType?: string | undefined;
    floorArea?: number | undefined;
    developmentArea?: number | undefined;
    totalArea?: number | undefined;
    climateTarget?: number | undefined;
    climateBudgetTarget?: number | undefined;
    elementCount?: number;
    componentCount?: number;
    elementWithComponentsCount?: number;
    apsHubId?: string | undefined;
    apsHubName?: string | undefined;
    apsProjectId?: string | undefined;
    apsProjectName?: string | undefined;
    apsItemId?: string | undefined;
    apsItemName?: string | undefined;
    apsViewId?: string | undefined;
    apsViewName?: string | undefined;
    apsVersionId?: string | undefined;
    apsWebView?: string | undefined;
    apsStorageId?: string | undefined;
    apsCreateUserName?: string | undefined;
    apsLastModifiedUserName?: string | undefined;
    apsVersion?: number;
    apsIsCompositeDesign?: boolean;
    apsFileSize?: number;
    apsFileVersion?: string | undefined;
    modelEmissionReductionTarget?: number | undefined;
    modelTypeId?: string | undefined;
    modelTypeName?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
}

export class SubmitJobResponse implements ISubmitJobResponse {
    jobId?: string;
    statusUrl?: string;

    constructor(data?: ISubmitJobResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.statusUrl = _data["statusUrl"];
        }
    }

    static fromJS(data: any): SubmitJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitJobResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["statusUrl"] = this.statusUrl;
        return data;
    }
}

export interface ISubmitJobResponse {
    jobId?: string;
    statusUrl?: string;
}

export class JobStatusResponse implements IJobStatusResponse {
    jobId?: string;
    status?: string;
    progress?: number;
    result?: any | undefined;
    error?: string | undefined;
    type?: string;
    createdAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;

    constructor(data?: IJobStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.status = _data["status"];
            this.progress = _data["progress"];
            this.result = _data["result"];
            this.error = _data["error"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): JobStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JobStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["status"] = this.status;
        data["progress"] = this.progress;
        data["result"] = this.result;
        data["error"] = this.error;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IJobStatusResponse {
    jobId?: string;
    status?: string;
    progress?: number;
    result?: any | undefined;
    error?: string | undefined;
    type?: string;
    createdAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export class AsyncJobDto implements IAsyncJobDto {
    jobId?: string;
    statusId?: number;
    status?: string;
    progress?: number;
    requestPayload?: string;
    resultPayload?: string | undefined;
    errorMessage?: string | undefined;
    typeId?: number;
    type?: string;
    createdAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;

    constructor(data?: IAsyncJobDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            this.progress = _data["progress"];
            this.requestPayload = _data["requestPayload"];
            this.resultPayload = _data["resultPayload"];
            this.errorMessage = _data["errorMessage"];
            this.typeId = _data["typeId"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : undefined as any;
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AsyncJobDto {
        data = typeof data === 'object' ? data : {};
        let result = new AsyncJobDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        data["progress"] = this.progress;
        data["requestPayload"] = this.requestPayload;
        data["resultPayload"] = this.resultPayload;
        data["errorMessage"] = this.errorMessage;
        data["typeId"] = this.typeId;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : undefined as any;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAsyncJobDto {
    jobId?: string;
    statusId?: number;
    status?: string;
    progress?: number;
    requestPayload?: string;
    resultPayload?: string | undefined;
    errorMessage?: string | undefined;
    typeId?: number;
    type?: string;
    createdAt?: Date;
    startedAt?: Date | undefined;
    completedAt?: Date | undefined;
}

export class CreateNewResourceUserRequest implements ICreateNewResourceUserRequest {
    resourceId?: string;
    apsProjectId?: string | undefined;
    resourceType?: ResourceType;
    email?: string;

    constructor(data?: ICreateNewResourceUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.apsProjectId = _data["apsProjectId"];
            this.resourceType = _data["resourceType"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateNewResourceUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateNewResourceUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["apsProjectId"] = this.apsProjectId;
        data["resourceType"] = this.resourceType;
        data["email"] = this.email;
        return data;
    }
}

export interface ICreateNewResourceUserRequest {
    resourceId?: string;
    apsProjectId?: string | undefined;
    resourceType?: ResourceType;
    email?: string;
}

export class ProfileDto implements IProfileDto {
    profileId?: string;
    name?: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    rebarEnabled?: boolean;

    constructor(data?: IProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileId = _data["profileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.deleteStatus = _data["deleteStatus"];
            this.isDeleted = _data["isDeleted"];
            this.rebarEnabled = _data["rebarEnabled"];
        }
    }

    static fromJS(data: any): ProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileId"] = this.profileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["deleteStatus"] = this.deleteStatus;
        data["isDeleted"] = this.isDeleted;
        data["rebarEnabled"] = this.rebarEnabled;
        return data;
    }
}

export interface IProfileDto {
    profileId?: string;
    name?: string;
    description?: string | undefined;
    deleteStatus?: SoftDeleteStatusType;
    isDeleted?: boolean;
    rebarEnabled?: boolean;
}

export enum FeatureManagementType {
    RebarEstimation = "RebarEstimation",
    ModelScopes = "ModelScopes",
    Material2050Database = "Material2050Database",
    MiniProfiler = "MiniProfiler",
    ShareProject = "ShareProject",
    DACategoryFilter = "DACategoryFilter",
    ModelSplit = "ModelSplit",
    UseNewApproachForLoadingDB = "UseNewApproachForLoadingDB",
    ADStages = "ADStages",
    ProfileLevelRebarSettings = "ProfileLevelRebarSettings",
    AdditionalMetadata = "AdditionalMetadata",
    AssignAllADStages = "AssignAllADStages",
    ScenariosADStages = "ScenariosADStages",
    ResultsADStages = "ResultsADStages",
    EnableRebarLineItems = "EnableRebarLineItems",
    EnableNonModelledLineItems = "EnableNonModelledLineItems",
    ResultsAttributes = "ResultsAttributes",
    AttributesVisibility = "AttributesVisibility",
    ExportToZero = "ExportToZero",
    ProjectExtendedDetails = "ProjectExtendedDetails",
    ProjectPhase = "ProjectPhase",
    ScenarioType = "ScenarioType",
    AzureBlobStorageForMultiProjectExports = "AzureBlobStorageForMultiProjectExports",
    SDADataSyncVisibility = "SDADataSyncVisibility",
    BenchmarkCatalog = "BenchmarkCatalog",
}

export enum ServerNotificationType {
    OnExcelExportStart = "onExcelExportStart",
    OnExcelExportComplete = "onExcelExportComplete",
    OnExcelExportFailure = "onExcelExportFailure",
    OnDeleteProjectComplete = "onDeleteProjectComplete",
    OnDeleteProjectFailure = "onDeleteProjectFailure",
    OnModelSplitStart = "onModelSplitStart",
    OnModelSplitComplete = "onModelSplitComplete",
    OnModelSplitFailure = "onModelSplitFailure",
    OnJobStatus = "onJobStatus",
    OnJobComplete = "onJobComplete",
    OnJobFailure = "onJobFailure",
    OnJobProgress = "onJobProgress",
    OnModelImportJobStatus = "onModelImportJobStatus",
    OnModelImportJobComplete = "onModelImportJobComplete",
    OnCreateVersionStatus = "onCreateVersionStatus",
    OnCreateVersionFailure = "onCreateVersionFailure",
    OnCreateVersionComplete = "onCreateVersionComplete",
    OnDeleteModelStatus = "onDeleteModelStatus",
    OnDeleteModelFailure = "onDeleteModelFailure",
    OnDeleteModelComplete = "onDeleteModelComplete",
    OnUpdateVersionStatus = "onUpdateVersionStatus",
    OnUpdateVersionFailure = "onUpdateVersionFailure",
    OnUpdateVersionComplete = "onUpdateVersionComplete",
    OnReceiveMessage = "onReceiveMessage",
    OnCloneScenarioStatus = "onCloneScenarioStatus",
    OnCloneScenarioFailure = "onCloneScenarioFailure",
    OnCloneScenarioComplete = "onCloneScenarioComplete",
    OnCopyModelMaterialStatus = "onCopyModelMaterialStatus",
    OnCopyModelMaterialFailure = "onCopyModelMaterialFailure",
    OnCopyModelMaterialComplete = "onCopyModelMaterialComplete",
    OnApsUsersSyncStatus = "onApsUsersSyncStatus",
    OnApsUsersSyncComplete = "onApsUsersSyncComplete",
    OnApsUsersSyncFailure = "onApsUsersSyncFailure",
    OnMultiProjectExportStart = "onMultiProjectExportStart",
    OnMultiProjectExportComplete = "onMultiProjectExportComplete",
    OnMultiProjectExportFailure = "onMultiProjectExportFailure",
    OnSustainabilitySyncStart = "onSustainabilitySyncStart",
    OnSustainabilitySyncComplete = "onSustainabilitySyncComplete",
    OnSustainabilitySyncFailure = "onSustainabilitySyncFailure",
}

export enum ImportStatusType {
    Success = "Success",
    Warning = "Warning",
    Error = "Error",
}

export enum ImportActionType {
    Add = "Add",
    Update = "Update",
    Revise = "Revise",
    Remove = "Remove",
}

export enum ModelCommandType {
    AddNonModelledElement = "AddNonModelledElement",
    AutoAssignMaterial = "AutoAssignMaterial",
    AssignRebarEstimation = "AssignRebarEstimation",
}

export enum AppSettingType {
    RebarEstimationMaterials = "RebarEstimationMaterials",
    NumberFormat_EC_Digits = "NumberFormat_EC_Digits",
    DesignAutomation_EnableLogs = "DesignAutomation_EnableLogs",
    DesignAutomation_EnableWebhooks = "DesignAutomation_EnableWebhooks",
}

export class ImportCo2MaterialTypesResponse implements IImportCo2MaterialTypesResponse {
    importCo2MaterialLibraryResult?: ImportCo2MaterialLibraryResult;
    importCo2MaterialCategoryResult?: ImportCo2MaterialCategoryResult;
    importCo2MaterialTypeResult?: ImportCo2MaterialTypeResult;
    validationFailures?: ValidationFailure[];
    isValid?: boolean;

    constructor(data?: IImportCo2MaterialTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCo2MaterialLibraryResult = _data["importCo2MaterialLibraryResult"] ? ImportCo2MaterialLibraryResult.fromJS(_data["importCo2MaterialLibraryResult"]) : undefined as any;
            this.importCo2MaterialCategoryResult = _data["importCo2MaterialCategoryResult"] ? ImportCo2MaterialCategoryResult.fromJS(_data["importCo2MaterialCategoryResult"]) : undefined as any;
            this.importCo2MaterialTypeResult = _data["importCo2MaterialTypeResult"] ? ImportCo2MaterialTypeResult.fromJS(_data["importCo2MaterialTypeResult"]) : undefined as any;
            if (Array.isArray(_data["validationFailures"])) {
                this.validationFailures = [] as any;
                for (let item of _data["validationFailures"])
                    this.validationFailures!.push(ValidationFailure.fromJS(item));
            }
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ImportCo2MaterialTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCo2MaterialLibraryResult"] = this.importCo2MaterialLibraryResult ? this.importCo2MaterialLibraryResult.toJSON() : undefined as any;
        data["importCo2MaterialCategoryResult"] = this.importCo2MaterialCategoryResult ? this.importCo2MaterialCategoryResult.toJSON() : undefined as any;
        data["importCo2MaterialTypeResult"] = this.importCo2MaterialTypeResult ? this.importCo2MaterialTypeResult.toJSON() : undefined as any;
        if (Array.isArray(this.validationFailures)) {
            data["validationFailures"] = [];
            for (let item of this.validationFailures)
                data["validationFailures"].push(item ? item.toJSON() : undefined as any);
        }
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IImportCo2MaterialTypesResponse {
    importCo2MaterialLibraryResult?: ImportCo2MaterialLibraryResult;
    importCo2MaterialCategoryResult?: ImportCo2MaterialCategoryResult;
    importCo2MaterialTypeResult?: ImportCo2MaterialTypeResult;
    validationFailures?: ValidationFailure[];
    isValid?: boolean;
}

export class ImportCo2MaterialLibraryResult implements IImportCo2MaterialLibraryResult {
    successItems?: ImportCo2MaterialLibrary[];
    failureItems?: ImportCo2MaterialLibraryFailure[];

    constructor(data?: IImportCo2MaterialLibraryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["successItems"])) {
                this.successItems = [] as any;
                for (let item of _data["successItems"])
                    this.successItems!.push(ImportCo2MaterialLibrary.fromJS(item));
            }
            if (Array.isArray(_data["failureItems"])) {
                this.failureItems = [] as any;
                for (let item of _data["failureItems"])
                    this.failureItems!.push(ImportCo2MaterialLibraryFailure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialLibraryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialLibraryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successItems)) {
            data["successItems"] = [];
            for (let item of this.successItems)
                data["successItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failureItems)) {
            data["failureItems"] = [];
            for (let item of this.failureItems)
                data["failureItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportCo2MaterialLibraryResult {
    successItems?: ImportCo2MaterialLibrary[];
    failureItems?: ImportCo2MaterialLibraryFailure[];
}

export class ImportCo2MaterialLibrary implements IImportCo2MaterialLibrary {
    co2MaterialLibraryId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IImportCo2MaterialLibrary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImportCo2MaterialLibrary {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialLibrary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["name"] = this.name;
        return data;
    }
}

export interface IImportCo2MaterialLibrary {
    co2MaterialLibraryId?: string | undefined;
    name?: string | undefined;
}

export class ImportCo2MaterialLibraryFailure implements IImportCo2MaterialLibraryFailure {
    importCo2MaterialLibrary?: ImportCo2MaterialLibrary;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IImportCo2MaterialLibraryFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCo2MaterialLibrary = _data["importCo2MaterialLibrary"] ? ImportCo2MaterialLibrary.fromJS(_data["importCo2MaterialLibrary"]) : undefined as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialLibraryFailure {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialLibraryFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCo2MaterialLibrary"] = this.importCo2MaterialLibrary ? this.importCo2MaterialLibrary.toJSON() : undefined as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IImportCo2MaterialLibraryFailure {
    importCo2MaterialLibrary?: ImportCo2MaterialLibrary;
    errors?: { [key: string]: string[]; } | undefined;
}

export class ImportCo2MaterialCategoryResult implements IImportCo2MaterialCategoryResult {
    successItems?: ImportCo2MaterialCategory[];
    failureItems?: ImportCo2MaterialCategoryFailure[];

    constructor(data?: IImportCo2MaterialCategoryResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["successItems"])) {
                this.successItems = [] as any;
                for (let item of _data["successItems"])
                    this.successItems!.push(ImportCo2MaterialCategory.fromJS(item));
            }
            if (Array.isArray(_data["failureItems"])) {
                this.failureItems = [] as any;
                for (let item of _data["failureItems"])
                    this.failureItems!.push(ImportCo2MaterialCategoryFailure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialCategoryResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialCategoryResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successItems)) {
            data["successItems"] = [];
            for (let item of this.successItems)
                data["successItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failureItems)) {
            data["failureItems"] = [];
            for (let item of this.failureItems)
                data["failureItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportCo2MaterialCategoryResult {
    successItems?: ImportCo2MaterialCategory[];
    failureItems?: ImportCo2MaterialCategoryFailure[];
}

export class ImportCo2MaterialCategory implements IImportCo2MaterialCategory {
    co2MaterialCategoryId?: string | undefined;
    name?: string | undefined;

    constructor(data?: IImportCo2MaterialCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.co2MaterialCategoryId = _data["co2MaterialCategoryId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ImportCo2MaterialCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["co2MaterialCategoryId"] = this.co2MaterialCategoryId;
        data["name"] = this.name;
        return data;
    }
}

export interface IImportCo2MaterialCategory {
    co2MaterialCategoryId?: string | undefined;
    name?: string | undefined;
}

export class ImportCo2MaterialCategoryFailure implements IImportCo2MaterialCategoryFailure {
    importCo2MaterialCategory?: ImportCo2MaterialCategory;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IImportCo2MaterialCategoryFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCo2MaterialCategory = _data["importCo2MaterialCategory"] ? ImportCo2MaterialCategory.fromJS(_data["importCo2MaterialCategory"]) : undefined as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialCategoryFailure {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialCategoryFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCo2MaterialCategory"] = this.importCo2MaterialCategory ? this.importCo2MaterialCategory.toJSON() : undefined as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IImportCo2MaterialCategoryFailure {
    importCo2MaterialCategory?: ImportCo2MaterialCategory;
    errors?: { [key: string]: string[]; } | undefined;
}

export class ImportCo2MaterialTypeResult implements IImportCo2MaterialTypeResult {
    successItems?: ImportCo2MaterialType[];
    failureItems?: ImportCo2MaterialTypeFailure[];

    constructor(data?: IImportCo2MaterialTypeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["successItems"])) {
                this.successItems = [] as any;
                for (let item of _data["successItems"])
                    this.successItems!.push(ImportCo2MaterialType.fromJS(item));
            }
            if (Array.isArray(_data["failureItems"])) {
                this.failureItems = [] as any;
                for (let item of _data["failureItems"])
                    this.failureItems!.push(ImportCo2MaterialTypeFailure.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialTypeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialTypeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.successItems)) {
            data["successItems"] = [];
            for (let item of this.successItems)
                data["successItems"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.failureItems)) {
            data["failureItems"] = [];
            for (let item of this.failureItems)
                data["failureItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportCo2MaterialTypeResult {
    successItems?: ImportCo2MaterialType[];
    failureItems?: ImportCo2MaterialTypeFailure[];
}

export class ImportCo2MaterialType implements IImportCo2MaterialType {
    row?: number;
    co2MaterialTypeId?: string | undefined;
    co2MaterialLibraryId?: string | undefined;
    co2MaterialCategoryId?: string | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    source?: string | undefined;
    sourceData?: string | undefined;
    a1A2A3?: number | undefined;
    a1A2A3_ECF?: number | undefined;
    a4?: number | undefined;
    a4_ECF?: number | undefined;
    a5?: number | undefined;
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    wastage_ECF?: number | undefined;
    unitQuantity?: number | undefined;
    density?: number | undefined;
    densityType?: number | undefined;
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    deleteStatus?: SoftDeleteStatusType | undefined;
    co2MaterialCategoryName?: string | undefined;
    co2MaterialLibraryName?: string | undefined;
    importStatus?: string | undefined;
    importAction?: string | undefined;
    importStatusMessage?: string | undefined;
    isDuplicateName?: boolean;

    constructor(data?: IImportCo2MaterialType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"];
            this.co2MaterialTypeId = _data["co2MaterialTypeId"];
            this.co2MaterialLibraryId = _data["co2MaterialLibraryId"];
            this.co2MaterialCategoryId = _data["co2MaterialCategoryId"];
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.unit = _data["unit"];
            this.source = _data["source"];
            this.sourceData = _data["sourceData"];
            this.a1A2A3 = _data["a1A2A3"];
            this.a1A2A3_ECF = _data["a1A2A3_ECF"];
            this.a4 = _data["a4"];
            this.a4_ECF = _data["a4_ECF"];
            this.a5 = _data["a5"];
            this.a5_ECF = _data["a5_ECF"];
            this.b1 = _data["b1"];
            this.b1_ECF = _data["b1_ECF"];
            this.b2 = _data["b2"];
            this.b2_ECF = _data["b2_ECF"];
            this.b3 = _data["b3"];
            this.b3_ECF = _data["b3_ECF"];
            this.b4 = _data["b4"];
            this.b4_ECF = _data["b4_ECF"];
            this.b5 = _data["b5"];
            this.b5_ECF = _data["b5_ECF"];
            this.b6 = _data["b6"];
            this.b6_ECF = _data["b6_ECF"];
            this.b7 = _data["b7"];
            this.b7_ECF = _data["b7_ECF"];
            this.c1 = _data["c1"];
            this.c1_ECF = _data["c1_ECF"];
            this.c2 = _data["c2"];
            this.c2_ECF = _data["c2_ECF"];
            this.c3 = _data["c3"];
            this.c3_ECF = _data["c3_ECF"];
            this.c4 = _data["c4"];
            this.c4_ECF = _data["c4_ECF"];
            this.d = _data["d"];
            this.d_ECF = _data["d_ECF"];
            this.biogenic = _data["biogenic"];
            this.biogenic_ECF = _data["biogenic_ECF"];
            this.wastage = _data["wastage"];
            this.wastage_ECF = _data["wastage_ECF"];
            this.unitQuantity = _data["unitQuantity"];
            this.density = _data["density"];
            this.densityType = _data["densityType"];
            this.massPerUnit = _data["massPerUnit"];
            this.omniClassNumber = _data["omniClassNumber"];
            this.omniClassTitle = _data["omniClassTitle"];
            this.uniFormatNumber = _data["uniFormatNumber"];
            this.uniFormatTitle = _data["uniFormatTitle"];
            this.masterFormatNumber = _data["masterFormatNumber"];
            this.masterFormatTitle = _data["masterFormatTitle"];
            this.deleteStatus = _data["deleteStatus"];
            this.co2MaterialCategoryName = _data["co2MaterialCategoryName"];
            this.co2MaterialLibraryName = _data["co2MaterialLibraryName"];
            this.importStatus = _data["importStatus"];
            this.importAction = _data["importAction"];
            this.importStatusMessage = _data["importStatusMessage"];
            this.isDuplicateName = _data["isDuplicateName"];
        }
    }

    static fromJS(data: any): ImportCo2MaterialType {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        data["co2MaterialTypeId"] = this.co2MaterialTypeId;
        data["co2MaterialLibraryId"] = this.co2MaterialLibraryId;
        data["co2MaterialCategoryId"] = this.co2MaterialCategoryId;
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["unit"] = this.unit;
        data["source"] = this.source;
        data["sourceData"] = this.sourceData;
        data["a1A2A3"] = this.a1A2A3;
        data["a1A2A3_ECF"] = this.a1A2A3_ECF;
        data["a4"] = this.a4;
        data["a4_ECF"] = this.a4_ECF;
        data["a5"] = this.a5;
        data["a5_ECF"] = this.a5_ECF;
        data["b1"] = this.b1;
        data["b1_ECF"] = this.b1_ECF;
        data["b2"] = this.b2;
        data["b2_ECF"] = this.b2_ECF;
        data["b3"] = this.b3;
        data["b3_ECF"] = this.b3_ECF;
        data["b4"] = this.b4;
        data["b4_ECF"] = this.b4_ECF;
        data["b5"] = this.b5;
        data["b5_ECF"] = this.b5_ECF;
        data["b6"] = this.b6;
        data["b6_ECF"] = this.b6_ECF;
        data["b7"] = this.b7;
        data["b7_ECF"] = this.b7_ECF;
        data["c1"] = this.c1;
        data["c1_ECF"] = this.c1_ECF;
        data["c2"] = this.c2;
        data["c2_ECF"] = this.c2_ECF;
        data["c3"] = this.c3;
        data["c3_ECF"] = this.c3_ECF;
        data["c4"] = this.c4;
        data["c4_ECF"] = this.c4_ECF;
        data["d"] = this.d;
        data["d_ECF"] = this.d_ECF;
        data["biogenic"] = this.biogenic;
        data["biogenic_ECF"] = this.biogenic_ECF;
        data["wastage"] = this.wastage;
        data["wastage_ECF"] = this.wastage_ECF;
        data["unitQuantity"] = this.unitQuantity;
        data["density"] = this.density;
        data["densityType"] = this.densityType;
        data["massPerUnit"] = this.massPerUnit;
        data["omniClassNumber"] = this.omniClassNumber;
        data["omniClassTitle"] = this.omniClassTitle;
        data["uniFormatNumber"] = this.uniFormatNumber;
        data["uniFormatTitle"] = this.uniFormatTitle;
        data["masterFormatNumber"] = this.masterFormatNumber;
        data["masterFormatTitle"] = this.masterFormatTitle;
        data["deleteStatus"] = this.deleteStatus;
        data["co2MaterialCategoryName"] = this.co2MaterialCategoryName;
        data["co2MaterialLibraryName"] = this.co2MaterialLibraryName;
        data["importStatus"] = this.importStatus;
        data["importAction"] = this.importAction;
        data["importStatusMessage"] = this.importStatusMessage;
        data["isDuplicateName"] = this.isDuplicateName;
        return data;
    }
}

export interface IImportCo2MaterialType {
    row?: number;
    co2MaterialTypeId?: string | undefined;
    co2MaterialLibraryId?: string | undefined;
    co2MaterialCategoryId?: string | undefined;
    externalId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    unit?: string | undefined;
    source?: string | undefined;
    sourceData?: string | undefined;
    a1A2A3?: number | undefined;
    a1A2A3_ECF?: number | undefined;
    a4?: number | undefined;
    a4_ECF?: number | undefined;
    a5?: number | undefined;
    a5_ECF?: number | undefined;
    b1?: number | undefined;
    b1_ECF?: number | undefined;
    b2?: number | undefined;
    b2_ECF?: number | undefined;
    b3?: number | undefined;
    b3_ECF?: number | undefined;
    b4?: number | undefined;
    b4_ECF?: number | undefined;
    b5?: number | undefined;
    b5_ECF?: number | undefined;
    b6?: number | undefined;
    b6_ECF?: number | undefined;
    b7?: number | undefined;
    b7_ECF?: number | undefined;
    c1?: number | undefined;
    c1_ECF?: number | undefined;
    c2?: number | undefined;
    c2_ECF?: number | undefined;
    c3?: number | undefined;
    c3_ECF?: number | undefined;
    c4?: number | undefined;
    c4_ECF?: number | undefined;
    d?: number | undefined;
    d_ECF?: number | undefined;
    biogenic?: number | undefined;
    biogenic_ECF?: number | undefined;
    wastage?: number | undefined;
    wastage_ECF?: number | undefined;
    unitQuantity?: number | undefined;
    density?: number | undefined;
    densityType?: number | undefined;
    massPerUnit?: number | undefined;
    omniClassNumber?: string | undefined;
    omniClassTitle?: string | undefined;
    uniFormatNumber?: string | undefined;
    uniFormatTitle?: string | undefined;
    masterFormatNumber?: string | undefined;
    masterFormatTitle?: string | undefined;
    deleteStatus?: SoftDeleteStatusType | undefined;
    co2MaterialCategoryName?: string | undefined;
    co2MaterialLibraryName?: string | undefined;
    importStatus?: string | undefined;
    importAction?: string | undefined;
    importStatusMessage?: string | undefined;
    isDuplicateName?: boolean;
}

export class ImportCo2MaterialTypeFailure implements IImportCo2MaterialTypeFailure {
    importCo2MaterialType?: ImportCo2MaterialType;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IImportCo2MaterialTypeFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importCo2MaterialType = _data["importCo2MaterialType"] ? ImportCo2MaterialType.fromJS(_data["importCo2MaterialType"]) : undefined as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ImportCo2MaterialTypeFailure {
        data = typeof data === 'object' ? data : {};
        let result = new ImportCo2MaterialTypeFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importCo2MaterialType"] = this.importCo2MaterialType ? this.importCo2MaterialType.toJSON() : undefined as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IImportCo2MaterialTypeFailure {
    importCo2MaterialType?: ImportCo2MaterialType;
    errors?: { [key: string]: string[]; } | undefined;
}

/** Defines a validation failure */
export class ValidationFailure implements IValidationFailure {
    /** The name of the property. */
    propertyName?: string | undefined;
    /** The error message */
    errorMessage?: string | undefined;
    /** The property value that caused the failure. */
    attemptedValue?: any | undefined;
    /** Custom state associated with the failure. */
    customState?: any | undefined;
    /** Custom severity level associated with the failure. */
    severity?: Severity;
    /** Gets or sets the error code. */
    errorCode?: string | undefined;
    /** Gets or sets the formatted message placeholder values. */
    formattedMessagePlaceholderValues?: { [key: string]: any; } | undefined;

    constructor(data?: IValidationFailure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            this.attemptedValue = _data["attemptedValue"];
            this.customState = _data["customState"];
            this.severity = _data["severity"];
            this.errorCode = _data["errorCode"];
            if (_data["formattedMessagePlaceholderValues"]) {
                this.formattedMessagePlaceholderValues = {} as any;
                for (let key in _data["formattedMessagePlaceholderValues"]) {
                    if (_data["formattedMessagePlaceholderValues"].hasOwnProperty(key))
                        (this.formattedMessagePlaceholderValues as any)![key] = _data["formattedMessagePlaceholderValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): ValidationFailure {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationFailure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        data["attemptedValue"] = this.attemptedValue;
        data["customState"] = this.customState;
        data["severity"] = this.severity;
        data["errorCode"] = this.errorCode;
        if (this.formattedMessagePlaceholderValues) {
            data["formattedMessagePlaceholderValues"] = {};
            for (let key in this.formattedMessagePlaceholderValues) {
                if (this.formattedMessagePlaceholderValues.hasOwnProperty(key))
                    (data["formattedMessagePlaceholderValues"] as any)[key] = (this.formattedMessagePlaceholderValues as any)[key];
            }
        }
        return data;
    }
}

/** Defines a validation failure */
export interface IValidationFailure {
    /** The name of the property. */
    propertyName?: string | undefined;
    /** The error message */
    errorMessage?: string | undefined;
    /** The property value that caused the failure. */
    attemptedValue?: any | undefined;
    /** Custom state associated with the failure. */
    customState?: any | undefined;
    /** Custom severity level associated with the failure. */
    severity?: Severity;
    /** Gets or sets the error code. */
    errorCode?: string | undefined;
    /** Gets or sets the formatted message placeholder values. */
    formattedMessagePlaceholderValues?: { [key: string]: any; } | undefined;
}

/** Specifies the severity of a rule. */
export enum Severity {
    Error = "Error",
    Warning = "Warning",
    Info = "Info",
}

export class JobStatus implements IJobStatus {
    job?: Job;
    workItemStatus?: WorkItemStatus;
    /** Derived property for Status(Calculated from WorkItemStatus and Status) */
    status?: string;

    constructor(data?: IJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job = _data["job"] ? Job.fromJS(_data["job"]) : undefined as any;
            this.workItemStatus = _data["workItemStatus"] ? WorkItemStatus.fromJS(_data["workItemStatus"]) : undefined as any;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new JobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["workItemStatus"] = this.workItemStatus ? this.workItemStatus.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobStatus {
    job?: Job;
    workItemStatus?: WorkItemStatus;
    /** Derived property for Status(Calculated from WorkItemStatus and Status) */
    status?: string;
}

export class WorkItemStatus implements IWorkItemStatus {
    status?: Status;
    progress?: string | undefined;
    reportUrl?: string | undefined;
    debugInfoUrl?: string | undefined;
    stats?: Statistics | undefined;
    id?: string | undefined;

    constructor(data?: IWorkItemStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.progress = _data["progress"];
            this.reportUrl = _data["reportUrl"];
            this.debugInfoUrl = _data["debugInfoUrl"];
            this.stats = _data["stats"] ? Statistics.fromJS(_data["stats"]) : undefined as any;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WorkItemStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WorkItemStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["progress"] = this.progress;
        data["reportUrl"] = this.reportUrl;
        data["debugInfoUrl"] = this.debugInfoUrl;
        data["stats"] = this.stats ? this.stats.toJSON() : undefined as any;
        data["id"] = this.id;
        return data;
    }
}

export interface IWorkItemStatus {
    status?: Status;
    progress?: string | undefined;
    reportUrl?: string | undefined;
    debugInfoUrl?: string | undefined;
    stats?: Statistics | undefined;
    id?: string | undefined;
}

export enum Status {
    Pending = "pending",
    Inprogress = "inprogress",
    Cancelled = "cancelled",
    FailedLimitDataSize = "failedLimitDataSize",
    FailedLimitProcessingTime = "failedLimitProcessingTime",
    FailedDownload = "failedDownload",
    FailedInstructions = "failedInstructions",
    FailedUpload = "failedUpload",
    Success = "success",
    FailedUploadOptional = "failedUploadOptional",
}

export class Statistics implements IStatistics {
    timeQueued?: Date;
    timeDownloadStarted?: Date | undefined;
    timeInstructionsStarted?: Date | undefined;
    timeInstructionsEnded?: Date | undefined;
    timeUploadEnded?: Date | undefined;
    timeFinished?: Date | undefined;
    bytesDownloaded?: number | undefined;
    bytesUploaded?: number | undefined;

    constructor(data?: IStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeQueued = _data["timeQueued"] ? new Date(_data["timeQueued"].toString()) : undefined as any;
            this.timeDownloadStarted = _data["timeDownloadStarted"] ? new Date(_data["timeDownloadStarted"].toString()) : undefined as any;
            this.timeInstructionsStarted = _data["timeInstructionsStarted"] ? new Date(_data["timeInstructionsStarted"].toString()) : undefined as any;
            this.timeInstructionsEnded = _data["timeInstructionsEnded"] ? new Date(_data["timeInstructionsEnded"].toString()) : undefined as any;
            this.timeUploadEnded = _data["timeUploadEnded"] ? new Date(_data["timeUploadEnded"].toString()) : undefined as any;
            this.timeFinished = _data["timeFinished"] ? new Date(_data["timeFinished"].toString()) : undefined as any;
            this.bytesDownloaded = _data["bytesDownloaded"];
            this.bytesUploaded = _data["bytesUploaded"];
        }
    }

    static fromJS(data: any): Statistics {
        data = typeof data === 'object' ? data : {};
        let result = new Statistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeQueued"] = this.timeQueued ? this.timeQueued.toISOString() : undefined as any;
        data["timeDownloadStarted"] = this.timeDownloadStarted ? this.timeDownloadStarted.toISOString() : undefined as any;
        data["timeInstructionsStarted"] = this.timeInstructionsStarted ? this.timeInstructionsStarted.toISOString() : undefined as any;
        data["timeInstructionsEnded"] = this.timeInstructionsEnded ? this.timeInstructionsEnded.toISOString() : undefined as any;
        data["timeUploadEnded"] = this.timeUploadEnded ? this.timeUploadEnded.toISOString() : undefined as any;
        data["timeFinished"] = this.timeFinished ? this.timeFinished.toISOString() : undefined as any;
        data["bytesDownloaded"] = this.bytesDownloaded;
        data["bytesUploaded"] = this.bytesUploaded;
        return data;
    }
}

export interface IStatistics {
    timeQueued?: Date;
    timeDownloadStarted?: Date | undefined;
    timeInstructionsStarted?: Date | undefined;
    timeInstructionsEnded?: Date | undefined;
    timeUploadEnded?: Date | undefined;
    timeFinished?: Date | undefined;
    bytesDownloaded?: number | undefined;
    bytesUploaded?: number | undefined;
}

export class EtlJobStatus implements IEtlJobStatus {
    job?: Job2;
    modelId?: string | undefined;
    projectId?: string | undefined;

    constructor(data?: IEtlJobStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.job = _data["job"] ? Job2.fromJS(_data["job"]) : undefined as any;
            this.modelId = _data["modelId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): EtlJobStatus {
        data = typeof data === 'object' ? data : {};
        let result = new EtlJobStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["modelId"] = this.modelId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IEtlJobStatus {
    job?: Job2;
    modelId?: string | undefined;
    projectId?: string | undefined;
}

export class Job2 implements IJob2 {
    jobId?: number;
    /** Public identifier for the job. */
    jobGuid?: string;
    /** Type of template file. */
    templateType?: TemplateType;
    /** Name of the file uploaded with extension. */
    filename?: string;
    /** Name of the file without extension. */
    name?: string;
    /** Revision number of the file based on matching file names. */
    revision?: number;
    /** File content as a byte array. */
    fileContent?: string;
    /** JSON encoded data from the template file. */
    templateData?: string | undefined;
    /** JSON encoded errors from the template file. */
    templateErrors?: string | undefined;
    /** Job status string. */
    status?: string;
    /** Job status enum. */
    jobStatus?: JobStatus2;
    /** DateTime when the job was completed successfully. */
    completedAt?: Date | undefined;
    /** DateTime when the job results were downloaded. Safe to delete after this date. */
    downloadedAt?: Date | undefined;
    /** Captures the Configuration for Job */
    arguments?: string | undefined;
    /** Manifest JSON for the multi project export files, contains information about the export, used to
generate logs and audit purposes.
This is an object of MultiProjectExportInfo serialized as a JSON.
Should be handled while deserializing as an JSON object not as a single string. */
    multiProjectExportManifest?: string | undefined;
    /** Azure Blob Storage blob name for the export files.       */
    blobName?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    jobLogs?: JobLog[];

    constructor(data?: IJob2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobId = _data["jobId"];
            this.jobGuid = _data["jobGuid"];
            this.templateType = _data["templateType"];
            this.filename = _data["filename"];
            this.name = _data["name"];
            this.revision = _data["revision"];
            this.fileContent = _data["fileContent"];
            this.templateData = _data["templateData"];
            this.templateErrors = _data["templateErrors"];
            this.status = _data["status"];
            this.jobStatus = _data["jobStatus"];
            this.completedAt = _data["completedAt"] ? new Date(_data["completedAt"].toString()) : undefined as any;
            this.downloadedAt = _data["downloadedAt"] ? new Date(_data["downloadedAt"].toString()) : undefined as any;
            this.arguments = _data["arguments"];
            this.multiProjectExportManifest = _data["multiProjectExportManifest"];
            this.blobName = _data["blobName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["jobLogs"])) {
                this.jobLogs = [] as any;
                for (let item of _data["jobLogs"])
                    this.jobLogs!.push(JobLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Job2 {
        data = typeof data === 'object' ? data : {};
        let result = new Job2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobId"] = this.jobId;
        data["jobGuid"] = this.jobGuid;
        data["templateType"] = this.templateType;
        data["filename"] = this.filename;
        data["name"] = this.name;
        data["revision"] = this.revision;
        data["fileContent"] = this.fileContent;
        data["templateData"] = this.templateData;
        data["templateErrors"] = this.templateErrors;
        data["status"] = this.status;
        data["jobStatus"] = this.jobStatus;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : undefined as any;
        data["downloadedAt"] = this.downloadedAt ? this.downloadedAt.toISOString() : undefined as any;
        data["arguments"] = this.arguments;
        data["multiProjectExportManifest"] = this.multiProjectExportManifest;
        data["blobName"] = this.blobName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.jobLogs)) {
            data["jobLogs"] = [];
            for (let item of this.jobLogs)
                data["jobLogs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IJob2 {
    jobId?: number;
    /** Public identifier for the job. */
    jobGuid?: string;
    /** Type of template file. */
    templateType?: TemplateType;
    /** Name of the file uploaded with extension. */
    filename?: string;
    /** Name of the file without extension. */
    name?: string;
    /** Revision number of the file based on matching file names. */
    revision?: number;
    /** File content as a byte array. */
    fileContent?: string;
    /** JSON encoded data from the template file. */
    templateData?: string | undefined;
    /** JSON encoded errors from the template file. */
    templateErrors?: string | undefined;
    /** Job status string. */
    status?: string;
    /** Job status enum. */
    jobStatus?: JobStatus2;
    /** DateTime when the job was completed successfully. */
    completedAt?: Date | undefined;
    /** DateTime when the job results were downloaded. Safe to delete after this date. */
    downloadedAt?: Date | undefined;
    /** Captures the Configuration for Job */
    arguments?: string | undefined;
    /** Manifest JSON for the multi project export files, contains information about the export, used to
generate logs and audit purposes.
This is an object of MultiProjectExportInfo serialized as a JSON.
Should be handled while deserializing as an JSON object not as a single string. */
    multiProjectExportManifest?: string | undefined;
    /** Azure Blob Storage blob name for the export files.       */
    blobName?: string | undefined;
    createdAt?: Date;
    createdBy?: string | undefined;
    modifiedAt?: Date;
    modifiedBy?: string | undefined;
    jobLogs?: JobLog[];
}

export enum JobStatus2 {
    Unknown = "unknown",
    Pending = "pending",
    Inprogress = "inprogress",
    Cancelled = "cancelled",
    FailedInstructions = "failedInstructions",
    Success = "success",
}

export class JobLog implements IJobLog {
    jobLogId?: number;
    message?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    jobId?: number;
    job?: Job2;

    constructor(data?: IJobLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobLogId = _data["jobLogId"];
            this.message = _data["message"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.jobId = _data["jobId"];
            this.job = _data["job"] ? Job2.fromJS(_data["job"]) : undefined as any;
        }
    }

    static fromJS(data: any): JobLog {
        data = typeof data === 'object' ? data : {};
        let result = new JobLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobLogId"] = this.jobLogId;
        data["message"] = this.message;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["jobId"] = this.jobId;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        return data;
    }
}

export interface IJobLog {
    jobLogId?: number;
    message?: string;
    createdAt?: Date;
    createdBy?: string | undefined;
    jobId?: number;
    job?: Job2;
}

export enum JwtMiddleWareText {
    JwtToken = "jwttoken",
    Email = "email",
}

export enum Permissions {
    App_Project_Create = "app.project.create",
    App_Project_Delete = "app.project.delete",
    App_Project_View = "app.project.view",
    App_Project_Settings = "app.project.settings",
    App_Project_External_Link_Create = "app.project.external.link.create",
    App_Project_External_Link_Add_Users = "app.project.external.link.add.users",
    App_Project_External_Link_Add_Users_Map_Aps_Project = "app.project.external.link.add.users.map.aps.project",
    App_Project_External_Link_Add_Users_Delete = "app.project.external.link.add.users.delete",
    App_Project_External_Link_Add_Users_Add_Member = "app.project.external.link.add.users.add.member",
    App_Project_Model_Create = "app.project.model.create",
    App_Project_Model_View = "app.project.model.view",
    App_Project_Model_Edit = "app.project.model.edit",
    App_Project_Model_Delete = "app.project.model.delete",
    App_Project_Scenario_Create = "app.project.scenario.create",
    App_Project_Scenario_View = "app.project.scenario.view",
    App_Project_Scenario_Delete = "app.project.scenario.delete",
    App_Project_Scenario_Edit = "app.project.scenario.edit",
    App_Project_Model_Materials_Create = "app.project.model.materials.create",
    App_Project_Model_Materials_Edit = "app.project.model.materials.edit",
    App_Project_Model_Materials_View = "app.project.model.materials.view",
    App_Project_Model_Materials_Delete = "app.project.model.materials.delete",
    App_Project_Results_View = "app.project.results.view",
    App_Manage = "app.manage",
    Unknown = "unknown",
}

export enum AutoAssignMaterialConfigurationType {
    CadModelCategory = "CadModelCategory",
    CadMaterial = "CadMaterial",
    CadCustom = "CadCustom",
}

export enum ModelDataType {
    Native = "native",
    Revit = "rvt",
    DWG = "dwg",
    CSV = "csv",
    XLSX = "xlsx",
    IFC = "ifc",
    ModelDerivative = "model-derivative",
    JSON = "json",
    TextBased = "text-based",
}

export enum ModelDataSourceType {
    Application = "application",
    ACC = "acc",
    Upload = "upload",
    Split = "split",
    Merged = "merged",
}

export enum ExtendedDataKey {
    MultiplierInput = "MultiplierInput",
    MultiplierValue = "MultiplierValue",
    Notes = "Notes",
    SystemId = "SystemId",
    SubSystemId = "SubSystemId",
    Attribute1 = "Attribute1",
    Attribute2 = "Attribute2",
    Attribute3 = "Attribute3",
    HasChildMultiplierOverride = "HasChildMultiplierOverride",
    CarbonImpactInput = "CarbonImpactInput",
    CarbonImpactValue = "CarbonImpactValue",
    CarbonImpactNotes = "CarbonImpactNotes",
    HasChildCarbonImpactOverride = "HasChildCarbonImpactOverride",
    Co2MaterialTypeSpec = "Co2MaterialTypeSpec",
}

export enum ExtendedDataValueType {
    String = "string",
    Decimal = "decimal",
    Guid = "guid",
    Boolean = "boolean",
    Json = "json",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}